/* tslint:disable */
/* eslint-disable */
/**
 * DrDropin API
 * DrDropin REST and GraphQL API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface V1GetPatientExorliveUrl200Response {
    /**
     * Exorlive url
     */
    'url': string;
}
export interface V1IntegrationsAuth0UsersEmployeePutRequest {
    'userId'?: string;
    'oktaId': string;
    'firstName': string;
    'lastName': string;
    'email': string;
    'phone'?: string;
    'organization': string;
}
export interface V1IntegrationsAuth0UsersPatientPutRequest {
    'userId'?: string;
    'firstName': string;
    'lastName': string;
    'ssn': string;
    'organization': string;
}
export interface V1IntegrationsDigicareBookingsPostRequest {
    'booking_token': string;
    'patient_data': V1IntegrationsDigicareBookingsPostRequestPatientData;
    'sakid'?: string;
    'comment'?: string;
}
export interface V1IntegrationsDigicareBookingsPostRequestPatientData {
    'ssn': string;
    'first_name': string;
    'last_name': string;
    'address': string;
    'post_code': string;
    'email': string;
    'phone_number'?: string;
    'mobile_number': string;
    'gender': string;
}
export interface V1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest {
    'appointmentIds': Array<string>;
}
export interface V1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest {
    'appointmentIds': Array<string>;
    'sendAppointmentBookedMessageAt': string;
}
export interface V1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest {
    'recallId': string;
}
export interface V1PatientAuthChallenge200Response {
    'verifier': string;
    'challenge': string;
}
export interface V1PatientBookFirstAvailableVideoAppointmentRequest {
    'acceptedWaitInMinutes': number;
    'bookingOrigin': V1PatientBookFirstAvailableVideoAppointmentRequestBookingOriginEnum;
    'childId'?: string | null;
    'description': string;
    'expectedPatientPrice': number;
    'insuranceCountry'?: string | null;
    'partnerCampaignId'?: string;
    'serviceId': string;
}

export const V1PatientBookFirstAvailableVideoAppointmentRequestBookingOriginEnum = {
    App: 'app',
    Web: 'web'
} as const;

export type V1PatientBookFirstAvailableVideoAppointmentRequestBookingOriginEnum = typeof V1PatientBookFirstAvailableVideoAppointmentRequestBookingOriginEnum[keyof typeof V1PatientBookFirstAvailableVideoAppointmentRequestBookingOriginEnum];

export interface V1PatientBookPhysicalAppointmentForLoggedInPatientRequest {
    'bookingOrigin': V1PatientBookPhysicalAppointmentForLoggedInPatientRequestBookingOriginEnum;
    'description': string;
    'expectedPatientPrice': number;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'startTime': any;
    'clinicId': string;
}

export const V1PatientBookPhysicalAppointmentForLoggedInPatientRequestBookingOriginEnum = {
    App: 'app',
    Web: 'web'
} as const;

export type V1PatientBookPhysicalAppointmentForLoggedInPatientRequestBookingOriginEnum = typeof V1PatientBookPhysicalAppointmentForLoggedInPatientRequestBookingOriginEnum[keyof typeof V1PatientBookPhysicalAppointmentForLoggedInPatientRequestBookingOriginEnum];

export interface V1PatientBookPhysicalAppointmentRequest {
    'bookingOrigin': V1PatientBookPhysicalAppointmentRequestBookingOriginEnum;
    'description': string;
    'expectedPatientPrice': number;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'startTime': any;
    'clinicId': string;
    'practitionerId': string;
}

export const V1PatientBookPhysicalAppointmentRequestBookingOriginEnum = {
    App: 'app',
    Web: 'web'
} as const;

export type V1PatientBookPhysicalAppointmentRequestBookingOriginEnum = typeof V1PatientBookPhysicalAppointmentRequestBookingOriginEnum[keyof typeof V1PatientBookPhysicalAppointmentRequestBookingOriginEnum];

export interface V1PatientBookVideoAppointmentRequest {
    'bookingOrigin': V1PatientBookVideoAppointmentRequestBookingOriginEnum;
    'description': string;
    'expectedPatientPrice': number;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'startTime': any;
    'childId'?: string | null;
    'insuranceCountry'?: string | null;
}

export const V1PatientBookVideoAppointmentRequestBookingOriginEnum = {
    App: 'app',
    Web: 'web'
} as const;

export type V1PatientBookVideoAppointmentRequestBookingOriginEnum = typeof V1PatientBookVideoAppointmentRequestBookingOriginEnum[keyof typeof V1PatientBookVideoAppointmentRequestBookingOriginEnum];

/**
 * Appointment response
 */
export interface V1PatientBookVideoAppointmentWithPractitioner200Response {
    'clinicId': string;
    'id': string;
    'practitionerId': string;
    'serviceId': string;
    'startTime': string;
}
export interface V1PatientBookVideoAppointmentWithPractitionerRequest {
    'bookingOrigin': V1PatientBookVideoAppointmentWithPractitionerRequestBookingOriginEnum;
    'description': string;
    'expectedPatientPrice': number;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'startTime': any;
    'insuranceCountry'?: string | null;
    'practitionerId': string;
}

export const V1PatientBookVideoAppointmentWithPractitionerRequestBookingOriginEnum = {
    App: 'app',
    Web: 'web'
} as const;

export type V1PatientBookVideoAppointmentWithPractitionerRequestBookingOriginEnum = typeof V1PatientBookVideoAppointmentWithPractitionerRequestBookingOriginEnum[keyof typeof V1PatientBookVideoAppointmentWithPractitionerRequestBookingOriginEnum];

/**
 * The cancelled photo case
 */
export interface V1PatientCancelPhotoCase200Response {
    'id': string;
    'patientId': string;
    'organizationId': string;
    'clinicId': string | null;
    'serviceId': string;
    'departmentId': string;
    'orderId': string | null;
    'status': V1PatientCancelPhotoCase200ResponseStatusEnum;
    'caseCode': string;
    'category': string | null;
    'questionnaire': { [key: string]: any; } | null;
    'childId': string | null;
    'submittedAt': string | null;
    'diagnosedAt': string | null;
    'closedAt': string | null;
    'deadlineAt': string | null;
    'createdAt': string;
    'updatedAt': string;
}

export const V1PatientCancelPhotoCase200ResponseStatusEnum = {
    Draft: 'draft',
    Submitted: 'submitted',
    Claimed: 'claimed',
    Diagnosed: 'diagnosed',
    Closed: 'closed',
    Rejected: 'rejected',
    Cancelled: 'cancelled'
} as const;

export type V1PatientCancelPhotoCase200ResponseStatusEnum = typeof V1PatientCancelPhotoCase200ResponseStatusEnum[keyof typeof V1PatientCancelPhotoCase200ResponseStatusEnum];

/**
 * Bad Request - case can no longer be cancelled
 */
export interface V1PatientCancelPhotoCase400Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
export interface V1PatientCapChallenge200Response {
    'challenge': V1PatientCapChallenge200ResponseChallenge;
    'token'?: string;
    'expires': number;
}
export interface V1PatientCapChallenge200ResponseChallenge {
    'c': number;
    's': number;
    'd': number;
}
export interface V1PatientCapRedeem200Response {
    'success': boolean;
    'token'?: string;
    'expires'?: number;
    'message'?: string;
}
export interface V1PatientCapRedeem400Response {
    'success': boolean;
}
export interface V1PatientCapRedeemRequest {
    'token': string;
    'solutions': Array<number>;
}
/**
 * The confirmed, now-visible case image
 */
export interface V1PatientConfirmCaseImageUpload200Response {
    'id': string;
    'imageType': V1PatientConfirmCaseImageUpload200ResponseImageTypeEnum;
    'mimeType': string | null;
    'sizeBytes': number | null;
    'isVisible': boolean;
    'createdAt': string;
}

export const V1PatientConfirmCaseImageUpload200ResponseImageTypeEnum = {
    Closeup: 'closeup',
    Overview: 'overview',
    IdProof: 'id_proof',
    Signature: 'signature'
} as const;

export type V1PatientConfirmCaseImageUpload200ResponseImageTypeEnum = typeof V1PatientConfirmCaseImageUpload200ResponseImageTypeEnum[keyof typeof V1PatientConfirmCaseImageUpload200ResponseImageTypeEnum];

/**
 * Bad Request - upload not completed or size mismatch
 */
export interface V1PatientConfirmCaseImageUpload400Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
/**
 * Forbidden
 */
export interface V1PatientConfirmCaseImageUpload403Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
/**
 * Not Found
 */
export interface V1PatientConfirmCaseImageUpload404Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
export interface V1PatientCreateCampaignMembershipWithCodeRequest {
    'campaignCode': string;
    'type'?: V1PatientCreateCampaignMembershipWithCodeRequestTypeEnum;
}

export const V1PatientCreateCampaignMembershipWithCodeRequestTypeEnum = {
    Owner: 'owner',
    Household: 'household',
    Business: 'business'
} as const;

export type V1PatientCreateCampaignMembershipWithCodeRequestTypeEnum = typeof V1PatientCreateCampaignMembershipWithCodeRequestTypeEnum[keyof typeof V1PatientCreateCampaignMembershipWithCodeRequestTypeEnum];

export interface V1PatientCreateCampaignMembershipWithEmailRequest {
    'email': string;
    'partnerCampaignId': string;
    'type'?: V1PatientCreateCampaignMembershipWithEmailRequestTypeEnum;
}

export const V1PatientCreateCampaignMembershipWithEmailRequestTypeEnum = {
    Owner: 'owner',
    Household: 'household',
    Business: 'business'
} as const;

export type V1PatientCreateCampaignMembershipWithEmailRequestTypeEnum = typeof V1PatientCreateCampaignMembershipWithEmailRequestTypeEnum[keyof typeof V1PatientCreateCampaignMembershipWithEmailRequestTypeEnum];

export interface V1PatientCreateCampaignMembershipWithInsuranceNumberRequest {
    'partnerCampaignId'?: string;
    'insuranceNumber': string;
    'partnerCampaignShortId'?: string;
}
export interface V1PatientCreateChildRequest {
    'name': string;
    'ssn': string;
}
export interface V1PatientCreateNordeaCampaignMembershipRequest {
    'ssn': string;
    'campaignShortId': string;
}
/**
 * The created draft photo case
 */
export interface V1PatientCreatePhotoCase201Response {
    'id': string;
    'patientId': string;
    'organizationId': string;
    'clinicId': string | null;
    'serviceId': string;
    'departmentId': string;
    'orderId': string | null;
    'status': V1PatientCreatePhotoCase201ResponseStatusEnum;
    'caseCode': string;
    'category': string | null;
    'questionnaire': { [key: string]: any; } | null;
    'childId': string | null;
    'submittedAt': string | null;
    'diagnosedAt': string | null;
    'closedAt': string | null;
    'deadlineAt': string | null;
    'createdAt': string;
    'updatedAt': string;
}

export const V1PatientCreatePhotoCase201ResponseStatusEnum = {
    Draft: 'draft',
    Submitted: 'submitted',
    Claimed: 'claimed',
    Diagnosed: 'diagnosed',
    Closed: 'closed',
    Rejected: 'rejected',
    Cancelled: 'cancelled'
} as const;

export type V1PatientCreatePhotoCase201ResponseStatusEnum = typeof V1PatientCreatePhotoCase201ResponseStatusEnum[keyof typeof V1PatientCreatePhotoCase201ResponseStatusEnum];

/**
 * Not Found - service or child not found
 */
export interface V1PatientCreatePhotoCase404Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
export interface V1PatientCreatePhotoCaseRequest {
    'serviceId': string;
    'category'?: string | null;
    'childId'?: string | null;
    'questionnaire'?: { [key: string]: any; } | null;
}
/**
 * Bad Request - case is no longer a draft
 */
export interface V1PatientDeleteCaseImage400Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
/**
 * Appointment with full relations and payment details
 */
export interface V1PatientGetAppointmentById200Response {
    'id': string;
    'orderId': string;
    'description'?: string | null;
    'serviceId': string;
    'practitionerId': string;
    'clinicId': string;
    'patientId': string;
    'childId': string | null;
    'status': V1PatientGetAppointmentById200ResponseStatusEnum;
    'bookingOrigin': V1PatientGetAppointmentById200ResponseBookingOriginEnum;
    'departmentId': string;
    'organizationId': string;
    'startTime': string;
    'endTime': string;
    'startedAt': string | null;
    'endedAt': string | null;
    'preAppointmentBufferTime': V1PublicPatientGetAppointment200ResponseFreeCancellationLimit;
    'postAppointmentBufferTime': V1PublicPatientGetAppointment200ResponseFreeCancellationLimit;
    'freeCancellationLimit': V1PublicPatientGetAppointment200ResponseFreeCancellationLimit;
    'blocksAvailabilityFrom': string | null;
    'blocksAvailabilityTo': string | null;
    'updatedAt': string;
    'createdAt': string;
    'bookedByUserId': string;
    'organization'?: V1PatientGetAppointmentById200ResponseOrganization | null;
    'department'?: V1PatientGetAppointmentById200ResponseDepartment | null;
    'service'?: V1PatientGetAppointmentById200ResponseService | null;
    'practitioner'?: V1PatientGetAppointmentById200ResponsePractitioner | null;
    'clinic'?: V1PatientGetAppointmentById200ResponseClinic | null;
    'patient'?: V1PatientGetAppointmentById200ResponsePatient | null;
    'order'?: V1PatientGetAppointmentById200ResponseOrder | null;
}

export const V1PatientGetAppointmentById200ResponseStatusEnum = {
    Reserved: 'reserved',
    Booked: 'booked',
    Claimed: 'claimed',
    InProgress: 'in_progress',
    Cancelled: 'cancelled',
    NoShow: 'no_show',
    Completed: 'completed',
    Failed: 'failed',
    Deleted: 'deleted'
} as const;

export type V1PatientGetAppointmentById200ResponseStatusEnum = typeof V1PatientGetAppointmentById200ResponseStatusEnum[keyof typeof V1PatientGetAppointmentById200ResponseStatusEnum];
export const V1PatientGetAppointmentById200ResponseBookingOriginEnum = {
    App: 'app',
    Web: 'web',
    Seed: 'seed',
    AdminUi: 'admin_ui',
    Digicare: 'digicare',
    Recall: 'recall'
} as const;

export type V1PatientGetAppointmentById200ResponseBookingOriginEnum = typeof V1PatientGetAppointmentById200ResponseBookingOriginEnum[keyof typeof V1PatientGetAppointmentById200ResponseBookingOriginEnum];

export interface V1PatientGetAppointmentById200ResponseClinic {
    'id': string;
    'name': string;
    'shortId': string;
    'timeZone'?: string;
    'address': V1PatientPublicGetClinics200ResponseInnerAddress;
    'coordinates': V1PublicPatientGetAppointment200ResponseClinicCoordinates;
}
export interface V1PatientGetAppointmentById200ResponseDepartment {
    'id': string;
    'name': string;
    'organizationId': string;
}
export interface V1PatientGetAppointmentById200ResponseOrder {
    'id': string;
    'type': V1PatientGetAppointmentById200ResponseOrderTypeEnum;
    'status': V1PatientGetAppointmentById200ResponseOrderStatusEnum;
    'refundCause': string | null;
    'refundReason': string | null;
    'refundedAt': string | null;
    'partnerCampaignId': string | null;
    'orderItems': Array<V1PatientGetAppointmentById200ResponseOrderOrderItemsInner>;
    'totalPrice': number;
    'payments': Array<V1PatientGetAppointmentById200ResponseOrderPaymentsInner>;
    'discounts': Array<V1PatientGetAppointmentById200ResponseOrderDiscountsInner>;
    'remainingAmount': number;
    'totalDiscount'?: number;
    'totalBilling'?: number;
}

export const V1PatientGetAppointmentById200ResponseOrderTypeEnum = {
    Appointment: 'appointment',
    FirstAvailableAppointment: 'first-available-appointment',
    PhotoCase: 'photo-case'
} as const;

export type V1PatientGetAppointmentById200ResponseOrderTypeEnum = typeof V1PatientGetAppointmentById200ResponseOrderTypeEnum[keyof typeof V1PatientGetAppointmentById200ResponseOrderTypeEnum];
export const V1PatientGetAppointmentById200ResponseOrderStatusEnum = {
    Initiated: 'initiated',
    Ready: 'ready',
    Completed: 'completed',
    Refunded: 'refunded',
    Cancelled: 'cancelled',
    Failed: 'failed'
} as const;

export type V1PatientGetAppointmentById200ResponseOrderStatusEnum = typeof V1PatientGetAppointmentById200ResponseOrderStatusEnum[keyof typeof V1PatientGetAppointmentById200ResponseOrderStatusEnum];

export interface V1PatientGetAppointmentById200ResponseOrderDiscountsInner {
    'id': string;
    'orderId': string;
    'billingAmount': number;
    'discountAmount': number;
    'billingCode': string | null;
    'campaignCode': string | null;
    'insuranceNumber': string | null;
    'insuranceCountry': string | null;
    'status': V1PatientGetAppointmentById200ResponseOrderDiscountsInnerStatusEnum;
    'type': V1PatientGetAppointmentById200ResponseOrderDiscountsInnerTypeEnum;
    'description': string;
}

export const V1PatientGetAppointmentById200ResponseOrderDiscountsInnerStatusEnum = {
    Pending: 'pending',
    Cancelled: 'cancelled',
    ReadyForBilling: 'ready_for_billing',
    Billed: 'billed',
    Deleted: 'deleted'
} as const;

export type V1PatientGetAppointmentById200ResponseOrderDiscountsInnerStatusEnum = typeof V1PatientGetAppointmentById200ResponseOrderDiscountsInnerStatusEnum[keyof typeof V1PatientGetAppointmentById200ResponseOrderDiscountsInnerStatusEnum];
export const V1PatientGetAppointmentById200ResponseOrderDiscountsInnerTypeEnum = {
    Appointment: 'appointment',
    Surcharge: 'surcharge'
} as const;

export type V1PatientGetAppointmentById200ResponseOrderDiscountsInnerTypeEnum = typeof V1PatientGetAppointmentById200ResponseOrderDiscountsInnerTypeEnum[keyof typeof V1PatientGetAppointmentById200ResponseOrderDiscountsInnerTypeEnum];

export interface V1PatientGetAppointmentById200ResponseOrderOrderItemsInner {
    'id': string;
    'type': V1PatientGetAppointmentById200ResponseOrderOrderItemsInnerTypeEnum;
    'name': string;
    'price': number;
    'billingCode': string | null;
}

export const V1PatientGetAppointmentById200ResponseOrderOrderItemsInnerTypeEnum = {
    Service: 'service',
    Surcharge: 'surcharge'
} as const;

export type V1PatientGetAppointmentById200ResponseOrderOrderItemsInnerTypeEnum = typeof V1PatientGetAppointmentById200ResponseOrderOrderItemsInnerTypeEnum[keyof typeof V1PatientGetAppointmentById200ResponseOrderOrderItemsInnerTypeEnum];

export interface V1PatientGetAppointmentById200ResponseOrderPaymentsInner {
    'id': string;
    'patientId': string;
    'orderId': string;
    'status': V1PatientGetAppointmentById200ResponseOrderPaymentsInnerStatusEnum;
    'amount': number;
    'currency': string;
    'externalId': string | null;
    'createdAt': string;
    'authorizationUrl': string | null;
    'method': V1PatientGetAppointmentById200ResponseOrderPaymentsInnerMethodEnum;
    'provider': V1PatientGetAppointmentById200ResponseOrderPaymentsInnerProviderEnum;
    'paymentCardId': string | null;
}

export const V1PatientGetAppointmentById200ResponseOrderPaymentsInnerStatusEnum = {
    Initiated: 'initiated',
    Authorized: 'authorized',
    Captured: 'captured',
    Cancelled: 'cancelled',
    Refunded: 'refunded',
    Failed: 'failed'
} as const;

export type V1PatientGetAppointmentById200ResponseOrderPaymentsInnerStatusEnum = typeof V1PatientGetAppointmentById200ResponseOrderPaymentsInnerStatusEnum[keyof typeof V1PatientGetAppointmentById200ResponseOrderPaymentsInnerStatusEnum];
export const V1PatientGetAppointmentById200ResponseOrderPaymentsInnerMethodEnum = {
    Card: 'card',
    Vipps: 'vipps'
} as const;

export type V1PatientGetAppointmentById200ResponseOrderPaymentsInnerMethodEnum = typeof V1PatientGetAppointmentById200ResponseOrderPaymentsInnerMethodEnum[keyof typeof V1PatientGetAppointmentById200ResponseOrderPaymentsInnerMethodEnum];
export const V1PatientGetAppointmentById200ResponseOrderPaymentsInnerProviderEnum = {
    Dintero: 'dintero',
    Swedbank: 'swedbank'
} as const;

export type V1PatientGetAppointmentById200ResponseOrderPaymentsInnerProviderEnum = typeof V1PatientGetAppointmentById200ResponseOrderPaymentsInnerProviderEnum[keyof typeof V1PatientGetAppointmentById200ResponseOrderPaymentsInnerProviderEnum];

export interface V1PatientGetAppointmentById200ResponseOrganization {
    'id': string;
    'name': string;
    'shortId': string;
}
export interface V1PatientGetAppointmentById200ResponsePatient {
    'id': string;
    'firstName': string;
    'lastName': string;
    'birthDate': string | null;
    'phone': string | null;
    'countryCode': string | null;
    'email': string | null;
    'isAuthenticated': boolean;
    'organizationId': string;
}
export interface V1PatientGetAppointmentById200ResponsePractitioner {
    'id': string;
    'shortName': string;
    'longName': string;
    'isActive': boolean;
    'gender'?: V1PatientGetAppointmentById200ResponsePractitionerGenderEnum | null;
    'departmentId': string;
    'organizationId': string;
    'employeeId': string;
    'pictureUrl': string | null;
    'videoUrl': string | null;
    'videoId': string | null;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'description': { [key: string]: string | null; };
    'plandayId': number | null;
}

export const V1PatientGetAppointmentById200ResponsePractitionerGenderEnum = {
    Male: 'male',
    Female: 'female',
    Other: 'other'
} as const;

export type V1PatientGetAppointmentById200ResponsePractitionerGenderEnum = typeof V1PatientGetAppointmentById200ResponsePractitionerGenderEnum[keyof typeof V1PatientGetAppointmentById200ResponsePractitionerGenderEnum];

export interface V1PatientGetAppointmentById200ResponseService {
    'id': string;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'displayName': { [key: string]: string | null; };
    'duration': V1PublicPatientGetAppointment200ResponseFreeCancellationLimit;
    'isVideo': boolean;
    'shortId'?: string;
    'price'?: number;
    'departmentId'?: string;
}
/**
 * Appointment summary resolved from a video room
 */
export interface V1PatientGetAppointmentByVideoRoomId200Response {
    'id': string;
    'startTime': string;
    'endedAt': string | null;
    'practitionerName': string | null;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'serviceName': { [key: string]: string | null; } | null;
    'paidAmount': number | null;
}
/**
 * Appointment response
 */
export interface V1PatientGetAppointments200ResponseInner {
    'id': string;
    'startTime': string;
    'endTime': string;
    'clinic': V1PatientGetAppointments200ResponseInnerClinic;
    'status': V1PatientGetAppointments200ResponseInnerStatusEnum;
    'service': V1PatientGetAppointments200ResponseInnerService;
    'practitioner': V1PatientGetAppointments200ResponseInnerPractitioner;
}

export const V1PatientGetAppointments200ResponseInnerStatusEnum = {
    Reserved: 'reserved',
    Booked: 'booked',
    Claimed: 'claimed',
    InProgress: 'in_progress',
    Cancelled: 'cancelled',
    NoShow: 'no_show',
    Completed: 'completed',
    Failed: 'failed',
    Deleted: 'deleted'
} as const;

export type V1PatientGetAppointments200ResponseInnerStatusEnum = typeof V1PatientGetAppointments200ResponseInnerStatusEnum[keyof typeof V1PatientGetAppointments200ResponseInnerStatusEnum];

export interface V1PatientGetAppointments200ResponseInnerClinic {
    'name': string;
    'address': V1PatientPublicGetClinics200ResponseInnerAddress;
    'coordinates': V1PublicPatientGetAppointment200ResponseClinicCoordinates;
}
export interface V1PatientGetAppointments200ResponseInnerPractitioner {
    'longName': string;
    'pictureUrl': string | null;
}
export interface V1PatientGetAppointments200ResponseInnerService {
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'displayName': { [key: string]: string | null; };
    'shortId': string;
    'isVideo': boolean;
    'requiresPatientDevice'?: boolean;
}
/**
 * Signed view URL for the case image
 */
export interface V1PatientGetCaseImageViewUrl200Response {
    'url': string;
}
/**
 * Bad Request - image upload not confirmed
 */
export interface V1PatientGetCaseImageViewUrl400Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
export interface V1PatientGetChildren200ResponseInner {
    'id': string;
    'name': string;
    'ssn': string;
}
export interface V1PatientGetMe200Response {
    'id': string;
    'firstName': string;
    'lastName': string;
    /**
     * Full legal name, register-sourced from the JWT when present; falls back to the stored first/last name if the token omits it
     */
    'fullName': string;
    /**
     * National identity number, register-sourced from the JWT; null when the token does not carry the claim
     */
    'ssn': string | null;
    'phone': string | null;
    'countryCode': string | null;
    'email': string | null;
    /**
     * In YYYY-MM-DD format
     */
    'birthDate': string | null;
    'isAuthenticated': boolean;
    'organizationId': string;
    /**
     * Present only for cookie-authenticated (browser) sessions. Must be echoed back as the x-csrf-token header on subsequent mutating requests. Absent for bearer-token (mobile) clients, which don\'t need it.
     */
    'csrfToken'?: string;
}
/**
 * Unauthorized
 */
export interface V1PatientGetMe401Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
export interface V1PatientGetMyMedicalInfo200Response {
    'id': string;
    'patientId': string;
    'hasAllergies': boolean;
    'allergies': string | null;
    'hasMedication': boolean;
    'medication': string | null;
    'createdAt': string;
    'updatedAt': string;
}
/**
 * A photo case owned by the authenticated patient
 */
export interface V1PatientGetMyPhotoCases200ResponseInner {
    'id': string;
    'patientId': string;
    'organizationId': string;
    'clinicId': string | null;
    'serviceId': string;
    'departmentId': string;
    'orderId': string | null;
    'status': V1PatientGetMyPhotoCases200ResponseInnerStatusEnum;
    'caseCode': string;
    'category': string | null;
    'questionnaire': { [key: string]: any; } | null;
    'childId': string | null;
    'submittedAt': string | null;
    'diagnosedAt': string | null;
    'closedAt': string | null;
    'deadlineAt': string | null;
    'createdAt': string;
    'updatedAt': string;
}

export const V1PatientGetMyPhotoCases200ResponseInnerStatusEnum = {
    Draft: 'draft',
    Submitted: 'submitted',
    Claimed: 'claimed',
    Diagnosed: 'diagnosed',
    Closed: 'closed',
    Rejected: 'rejected',
    Cancelled: 'cancelled'
} as const;

export type V1PatientGetMyPhotoCases200ResponseInnerStatusEnum = typeof V1PatientGetMyPhotoCases200ResponseInnerStatusEnum[keyof typeof V1PatientGetMyPhotoCases200ResponseInnerStatusEnum];

export interface V1PatientGetPartnerCampaigns200ResponseInner {
    'id': string;
    'shortId': string;
    'validFrom': string | null;
    'validTo': string | null;
    'totalCampaignUsageLimit': number | null;
    'perUserUsageLimit': number | null;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'title': { [key: string]: string | null; };
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'description': { [key: string]: string | null; };
    'requireConsent': boolean;
    'parentId': string | null;
    'verificationMethod': V1PatientGetPartnerCampaigns200ResponseInnerVerificationMethodEnum;
    'partnerId': string;
}

export const V1PatientGetPartnerCampaigns200ResponseInnerVerificationMethodEnum = {
    Code: 'code',
    InsuranceNumber: 'insurance_number',
    NordeaSsn: 'nordea_ssn',
    Email: 'email'
} as const;

export type V1PatientGetPartnerCampaigns200ResponseInnerVerificationMethodEnum = typeof V1PatientGetPartnerCampaigns200ResponseInnerVerificationMethodEnum[keyof typeof V1PatientGetPartnerCampaigns200ResponseInnerVerificationMethodEnum];

export interface V1PatientGetPartnerList200ResponseInner {
    'id': string;
    'shortId': string;
    'name': string;
    'logoUrl': string | null;
}
export interface V1PatientGetPatientCampaignMemberships200ResponseInner {
    'patientCampaignUsage': number;
    'usageLimitReached': boolean;
    'serviceUsages': Array<V1PatientGetPatientCampaignMemberships200ResponseInnerServiceUsagesInner>;
    'campaignCode': string | null;
    'createdAt': string;
    'expiresAt': string | null;
    'isActive': boolean;
    'partnerCampaign': V1PatientGetPatientCampaignMemberships200ResponseInnerPartnerCampaign;
    'partner': V1PatientGetPatientCampaignMemberships200ResponseInnerPartner;
}
export interface V1PatientGetPatientCampaignMemberships200ResponseInnerPartner {
    'id': string;
    'name'?: string;
    'logoUrl'?: string | null;
}
export interface V1PatientGetPatientCampaignMemberships200ResponseInnerPartnerCampaign {
    'id': string;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'title': { [key: string]: string | null; };
    'parentId': string | null;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'description': { [key: string]: string | null; };
    'perUserLimit': number;
    'shortId': string;
    'sortOrder': number;
    'validTo': string | null;
    'requireConsent': boolean;
}
export interface V1PatientGetPatientCampaignMemberships200ResponseInnerServiceUsagesInner {
    'serviceId': string;
    'usedByPatient': number;
    'usedTotal': number;
    'perUserServiceLimit': number | null;
    'totalServiceLimit': number | null;
    'usageLimitReached': boolean;
}
export interface V1PatientGetPatientCampaignMembershipsRequiringReverification200ResponseInner {
    'partnerCampaignId': string;
    'patientId': string;
}
export interface V1PatientGetPatientDiagnosis200Response {
    'id': string;
    'photoCaseId': string;
    'practitionerId': string;
    'description': string | null;
    'isPrescribed': boolean;
    'nextAppointmentDate': string | null;
    'nextAppointmentType': string | null;
    'appointmentReminderEnabled': boolean;
    'createdAt': string;
    'updatedAt': string;
}
export interface V1PatientGetPaymentCards200ResponseInner {
    'id': string;
    'number': string | null;
    'brand': string | null;
    'expirationDate': string | null;
    'isDefault': boolean;
}
/**
 * The photo case
 */
export interface V1PatientGetPhotoCaseById200Response {
    'id': string;
    'patientId': string;
    'organizationId': string;
    'clinicId': string | null;
    'serviceId': string;
    'departmentId': string;
    'orderId': string | null;
    'status': V1PatientGetPhotoCaseById200ResponseStatusEnum;
    'caseCode': string;
    'category': string | null;
    'questionnaire': { [key: string]: any; } | null;
    'childId': string | null;
    'submittedAt': string | null;
    'diagnosedAt': string | null;
    'closedAt': string | null;
    'deadlineAt': string | null;
    'createdAt': string;
    'updatedAt': string;
}

export const V1PatientGetPhotoCaseById200ResponseStatusEnum = {
    Draft: 'draft',
    Submitted: 'submitted',
    Claimed: 'claimed',
    Diagnosed: 'diagnosed',
    Closed: 'closed',
    Rejected: 'rejected',
    Cancelled: 'cancelled'
} as const;

export type V1PatientGetPhotoCaseById200ResponseStatusEnum = typeof V1PatientGetPhotoCaseById200ResponseStatusEnum[keyof typeof V1PatientGetPhotoCaseById200ResponseStatusEnum];

export interface V1PatientGetPractitioner200Response {
    'id': string;
    'shortName': string;
    'longName': string;
    'pictureUrl': string | null;
    'videoId': string | null;
    'gender'?: V1PatientGetPractitioner200ResponseGenderEnum | null;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'description': { [key: string]: string | null; };
    'clinics': Array<V1PatientGetPractitionersWithService200ResponseInnerClinicsInner>;
}

export const V1PatientGetPractitioner200ResponseGenderEnum = {
    Male: 'male',
    Female: 'female',
    Other: 'other'
} as const;

export type V1PatientGetPractitioner200ResponseGenderEnum = typeof V1PatientGetPractitioner200ResponseGenderEnum[keyof typeof V1PatientGetPractitioner200ResponseGenderEnum];

/**
 * Skill proficiency
 */
export interface V1PatientGetPractitionerSkillProficiencies200ResponseInner {
    'skillId': string;
    'proficiency': number;
}
export interface V1PatientGetPractitionersWithService200ResponseInner {
    'id': string;
    'shortName': string;
    'longName': string;
    'pictureUrl': string | null;
    'videoId': string | null;
    'gender'?: V1PatientGetPractitionersWithService200ResponseInnerGenderEnum | null;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'description': { [key: string]: string | null; };
    'clinics': Array<V1PatientGetPractitionersWithService200ResponseInnerClinicsInner>;
}

export const V1PatientGetPractitionersWithService200ResponseInnerGenderEnum = {
    Male: 'male',
    Female: 'female',
    Other: 'other'
} as const;

export type V1PatientGetPractitionersWithService200ResponseInnerGenderEnum = typeof V1PatientGetPractitionersWithService200ResponseInnerGenderEnum[keyof typeof V1PatientGetPractitionersWithService200ResponseInnerGenderEnum];

export interface V1PatientGetPractitionersWithService200ResponseInnerClinicsInner {
    'id': string;
    'name': string;
    'city': string;
}
/**
 * Video Room Access Token
 */
export interface V1PatientGetVideoRoomAccessToken200Response {
    'accessToken': string;
}
/**
 * Forbidden - patient does not own appointment
 */
export interface V1PatientGetVideoRoomAccessToken403Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
/**
 * Not Found - video room not found
 */
export interface V1PatientGetVideoRoomAccessToken404Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
/**
 * Internal Server Error
 */
export interface V1PatientGetVideoRoomAccessToken500Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
export interface V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest {
    'acceptedWaitInMinutes': number;
    'bookingOrigin': V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequestBookingOriginEnum;
    'childId'?: string | null;
    'description': string;
    'expectedPatientPrice': number;
    'insuranceCountry'?: string | null;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'paymentCardId'?: string | null;
    'paymentMethod': V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequestPaymentMethodEnum;
    'returnPath'?: string;
}

export const V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequestBookingOriginEnum = {
    App: 'app',
    Web: 'web'
} as const;

export type V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequestBookingOriginEnum = typeof V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequestBookingOriginEnum[keyof typeof V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequestBookingOriginEnum];
export const V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequestPaymentMethodEnum = {
    Card: 'card',
    Vipps: 'vipps'
} as const;

export type V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequestPaymentMethodEnum = typeof V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequestPaymentMethodEnum[keyof typeof V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequestPaymentMethodEnum];

/**
 * Payment initiated
 */
export interface V1PatientInitiatePaymentForPhotoCase200Response {
    'message': string;
    'paymentId': string;
    'authorizationUrl': string;
}
/**
 * Bad Request - case is not a draft or payment failed
 */
export interface V1PatientInitiatePaymentForPhotoCase400Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
export interface V1PatientInitiatePaymentForPhotoCaseRequest {
    'paymentMethod': V1PatientInitiatePaymentForPhotoCaseRequestPaymentMethodEnum;
    'paymentCardId'?: string | null;
    'returnPath'?: string;
}

export const V1PatientInitiatePaymentForPhotoCaseRequestPaymentMethodEnum = {
    Card: 'card',
    Vipps: 'vipps'
} as const;

export type V1PatientInitiatePaymentForPhotoCaseRequestPaymentMethodEnum = typeof V1PatientInitiatePaymentForPhotoCaseRequestPaymentMethodEnum[keyof typeof V1PatientInitiatePaymentForPhotoCaseRequestPaymentMethodEnum];

export interface V1PatientInitiatePaymentForPhysicalAppointmentRequest {
    'bookingOrigin': V1PatientInitiatePaymentForPhysicalAppointmentRequestBookingOriginEnum;
    'description': string;
    'expectedPatientPrice': number;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'startTime': any;
    'paymentCardId'?: string | null;
    'paymentMethod': V1PatientInitiatePaymentForPhysicalAppointmentRequestPaymentMethodEnum;
    'returnPath'?: string;
    'clinicId': string;
}

export const V1PatientInitiatePaymentForPhysicalAppointmentRequestBookingOriginEnum = {
    App: 'app',
    Web: 'web'
} as const;

export type V1PatientInitiatePaymentForPhysicalAppointmentRequestBookingOriginEnum = typeof V1PatientInitiatePaymentForPhysicalAppointmentRequestBookingOriginEnum[keyof typeof V1PatientInitiatePaymentForPhysicalAppointmentRequestBookingOriginEnum];
export const V1PatientInitiatePaymentForPhysicalAppointmentRequestPaymentMethodEnum = {
    Card: 'card',
    Vipps: 'vipps'
} as const;

export type V1PatientInitiatePaymentForPhysicalAppointmentRequestPaymentMethodEnum = typeof V1PatientInitiatePaymentForPhysicalAppointmentRequestPaymentMethodEnum[keyof typeof V1PatientInitiatePaymentForPhysicalAppointmentRequestPaymentMethodEnum];

export interface V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest {
    'bookingOrigin': V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequestBookingOriginEnum;
    'description': string;
    'expectedPatientPrice': number;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'startTime': any;
    'paymentCardId'?: string | null;
    'paymentMethod': V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequestPaymentMethodEnum;
    'returnPath'?: string;
    'clinicId': string;
    'practitionerId': string;
}

export const V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequestBookingOriginEnum = {
    App: 'app',
    Web: 'web'
} as const;

export type V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequestBookingOriginEnum = typeof V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequestBookingOriginEnum[keyof typeof V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequestBookingOriginEnum];
export const V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequestPaymentMethodEnum = {
    Card: 'card',
    Vipps: 'vipps'
} as const;

export type V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequestPaymentMethodEnum = typeof V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequestPaymentMethodEnum[keyof typeof V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequestPaymentMethodEnum];

export interface V1PatientInitiatePaymentForVideoAppointmentRequest {
    'bookingOrigin': V1PatientInitiatePaymentForVideoAppointmentRequestBookingOriginEnum;
    'description': string;
    'expectedPatientPrice': number;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'startTime': any;
    'paymentCardId'?: string | null;
    'paymentMethod': V1PatientInitiatePaymentForVideoAppointmentRequestPaymentMethodEnum;
    'returnPath'?: string;
    'childId'?: string | null;
    'insuranceCountry'?: string | null;
}

export const V1PatientInitiatePaymentForVideoAppointmentRequestBookingOriginEnum = {
    App: 'app',
    Web: 'web'
} as const;

export type V1PatientInitiatePaymentForVideoAppointmentRequestBookingOriginEnum = typeof V1PatientInitiatePaymentForVideoAppointmentRequestBookingOriginEnum[keyof typeof V1PatientInitiatePaymentForVideoAppointmentRequestBookingOriginEnum];
export const V1PatientInitiatePaymentForVideoAppointmentRequestPaymentMethodEnum = {
    Card: 'card',
    Vipps: 'vipps'
} as const;

export type V1PatientInitiatePaymentForVideoAppointmentRequestPaymentMethodEnum = typeof V1PatientInitiatePaymentForVideoAppointmentRequestPaymentMethodEnum[keyof typeof V1PatientInitiatePaymentForVideoAppointmentRequestPaymentMethodEnum];

export interface V1PatientInitiatePaymentForVideoAppointmentWithPractitioner200Response {
    'appointmentId': string;
    'authorizationUrl': string;
    'message': string;
    'paymentId': string;
}
export interface V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest {
    'bookingOrigin': V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequestBookingOriginEnum;
    'description': string;
    'expectedPatientPrice': number;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'startTime': any;
    'paymentCardId'?: string | null;
    'paymentMethod': V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequestPaymentMethodEnum;
    'returnPath'?: string;
    'insuranceCountry'?: string | null;
    'practitionerId': string;
}

export const V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequestBookingOriginEnum = {
    App: 'app',
    Web: 'web'
} as const;

export type V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequestBookingOriginEnum = typeof V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequestBookingOriginEnum[keyof typeof V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequestBookingOriginEnum];
export const V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequestPaymentMethodEnum = {
    Card: 'card',
    Vipps: 'vipps'
} as const;

export type V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequestPaymentMethodEnum = typeof V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequestPaymentMethodEnum[keyof typeof V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequestPaymentMethodEnum];

/**
 * Phone verification initiated successfully
 */
export interface V1PatientInitiatePhoneVerification200Response {
    /**
     * Phone number that will receive the verification code
     */
    'phone': string;
    /**
     * The current status of the verification request
     */
    'status': string;
}
export interface V1PatientInitiatePhoneVerificationRequest {
    /**
     * Phone number in E.164 format (e.g., +4712345678)
     */
    'phone': string;
    /**
     * Locale for the verification message
     */
    'locale'?: V1PatientInitiatePhoneVerificationRequestLocaleEnum;
    'token'?: string;
}

export const V1PatientInitiatePhoneVerificationRequestLocaleEnum = {
    Nb: 'nb',
    En: 'en'
} as const;

export type V1PatientInitiatePhoneVerificationRequestLocaleEnum = typeof V1PatientInitiatePhoneVerificationRequestLocaleEnum[keyof typeof V1PatientInitiatePhoneVerificationRequestLocaleEnum];

export interface V1PatientLegacyBookPhysicalAppointmentRequest {
    'bookingOrigin': V1PatientLegacyBookPhysicalAppointmentRequestBookingOriginEnum;
    'description': string;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'startTime': any;
    'clinicId': string;
}

export const V1PatientLegacyBookPhysicalAppointmentRequestBookingOriginEnum = {
    App: 'app',
    Web: 'web'
} as const;

export type V1PatientLegacyBookPhysicalAppointmentRequestBookingOriginEnum = typeof V1PatientLegacyBookPhysicalAppointmentRequestBookingOriginEnum[keyof typeof V1PatientLegacyBookPhysicalAppointmentRequestBookingOriginEnum];

export interface V1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest {
    'bookingOrigin': V1PatientLegacyBookPhysicalAppointmentWithPractitionerRequestBookingOriginEnum;
    'description': string;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'startTime': any;
    'clinicId': string;
    'practitionerId': string;
}

export const V1PatientLegacyBookPhysicalAppointmentWithPractitionerRequestBookingOriginEnum = {
    App: 'app',
    Web: 'web'
} as const;

export type V1PatientLegacyBookPhysicalAppointmentWithPractitionerRequestBookingOriginEnum = typeof V1PatientLegacyBookPhysicalAppointmentWithPractitionerRequestBookingOriginEnum[keyof typeof V1PatientLegacyBookPhysicalAppointmentWithPractitionerRequestBookingOriginEnum];

export interface V1PatientLegacyGetAppointments200ResponseInner {
    'clinicId'?: string;
    'id': string;
    'productId': string;
    'professional'?: V1PatientLegacyGetAppointments200ResponseInnerProfessional;
    'start': string;
    'status': V1PatientLegacyGetAppointments200ResponseInnerStatusEnum;
}

export const V1PatientLegacyGetAppointments200ResponseInnerStatusEnum = {
    Payed: 'payed',
    Booked: 'booked',
    Claimed: 'claimed',
    Completed: 'completed'
} as const;

export type V1PatientLegacyGetAppointments200ResponseInnerStatusEnum = typeof V1PatientLegacyGetAppointments200ResponseInnerStatusEnum[keyof typeof V1PatientLegacyGetAppointments200ResponseInnerStatusEnum];

export interface V1PatientLegacyGetAppointments200ResponseInnerProfessional {
    'firstName': string;
}
export interface V1PatientLegacyGetPatientCampaignMemberships200ResponseInner {
    'id': string;
    'createdAt': string;
    'custom'?: string;
    'membershipCampaignsId': string;
    'membershipCode': string;
    'partnerId': string;
    'type': V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerTypeEnum | null;
    'userId': string;
    'expiresAt': string | null;
    'insuranceNumber': string | null;
    'partner': V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerPartner;
    'membershipCampaign': V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerMembershipCampaign;
    'campaignTotalUsage': number;
    'campaignPatientUsage': number;
    'isActive': boolean;
    'usageLimitReached': boolean;
}

export const V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerTypeEnum = {
    Owner: 'owner',
    Household: 'household',
    Business: 'business'
} as const;

export type V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerTypeEnum = typeof V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerTypeEnum[keyof typeof V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerTypeEnum];

export interface V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerMembershipCampaign {
    'id': string;
    'description': string;
    'end': string | null;
    'membershipCode': string;
    'partnerId': string;
    'start': string | null;
    'title': string;
    'perUserLimit': number;
    'perCampaignLimit': number;
    'custom': string | null;
    'requireConsent': boolean | null;
    'productCampaigns': Array<V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerMembershipCampaignProductCampaignsInner>;
    'order': number;
    'verificationMethod': V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerMembershipCampaignVerificationMethodEnum | null;
    'parentId': string | null;
}

export const V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerMembershipCampaignVerificationMethodEnum = {
    Code: 'code',
    InsuranceNumber: 'insuranceNumber',
    Email: 'email'
} as const;

export type V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerMembershipCampaignVerificationMethodEnum = typeof V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerMembershipCampaignVerificationMethodEnum[keyof typeof V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerMembershipCampaignVerificationMethodEnum];

export interface V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerMembershipCampaignProductCampaignsInner {
    'productId': string;
    'customerPrice': number;
}
export interface V1PatientLegacyGetPatientCampaignMemberships200ResponseInnerPartner {
    'id': string;
    'name': string;
    'logoUrl': string | null;
    'isActive': boolean;
    'onboardingType': string | null;
}
export interface V1PatientListCaseImages200ResponseInner {
    'id': string;
    'imageType': V1PatientListCaseImages200ResponseInnerImageTypeEnum;
    'mimeType': string | null;
    'sizeBytes': number | null;
    'isVisible': boolean;
    'createdAt': string;
}

export const V1PatientListCaseImages200ResponseInnerImageTypeEnum = {
    Closeup: 'closeup',
    Overview: 'overview',
    IdProof: 'id_proof',
    Signature: 'signature'
} as const;

export type V1PatientListCaseImages200ResponseInnerImageTypeEnum = typeof V1PatientListCaseImages200ResponseInnerImageTypeEnum[keyof typeof V1PatientListCaseImages200ResponseInnerImageTypeEnum];

export interface V1PatientPublicBookPhysicalAppointment200Response {
    'id': string;
}
export interface V1PatientPublicBookPhysicalAppointmentRequest {
    'bookAppointmentRequest': V1PatientPublicBookPhysicalAppointmentRequestBookAppointmentRequest;
    'patient': V1PatientPublicBookPhysicalAppointmentRequestPatient;
}
export interface V1PatientPublicBookPhysicalAppointmentRequestBookAppointmentRequest {
    'bookingOrigin': V1PatientPublicBookPhysicalAppointmentRequestBookAppointmentRequestBookingOriginEnum;
    'description': string;
    'expectedPatientPrice': number;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'startTime': any;
    'clinicId': string;
}

export const V1PatientPublicBookPhysicalAppointmentRequestBookAppointmentRequestBookingOriginEnum = {
    Web: 'web'
} as const;

export type V1PatientPublicBookPhysicalAppointmentRequestBookAppointmentRequestBookingOriginEnum = typeof V1PatientPublicBookPhysicalAppointmentRequestBookAppointmentRequestBookingOriginEnum[keyof typeof V1PatientPublicBookPhysicalAppointmentRequestBookAppointmentRequestBookingOriginEnum];

export interface V1PatientPublicBookPhysicalAppointmentRequestPatient {
    'birthdate': string;
    'countryCode': string;
    'firstName': string;
    'lastName': string;
    'phone': string;
}
export interface V1PatientPublicBookPhysicalAppointmentWithPractitionerRequest {
    'bookAppointmentRequest': V1PatientPublicBookPhysicalAppointmentWithPractitionerRequestBookAppointmentRequest;
    'patient': V1PatientPublicBookPhysicalAppointmentRequestPatient;
}
export interface V1PatientPublicBookPhysicalAppointmentWithPractitionerRequestBookAppointmentRequest {
    'bookingOrigin': V1PatientPublicBookPhysicalAppointmentWithPractitionerRequestBookAppointmentRequestBookingOriginEnum;
    'description': string;
    'expectedPatientPrice': number;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'startTime': any;
    'clinicId': string;
    'practitionerId': string;
}

export const V1PatientPublicBookPhysicalAppointmentWithPractitionerRequestBookAppointmentRequestBookingOriginEnum = {
    Web: 'web'
} as const;

export type V1PatientPublicBookPhysicalAppointmentWithPractitionerRequestBookAppointmentRequestBookingOriginEnum = typeof V1PatientPublicBookPhysicalAppointmentWithPractitionerRequestBookAppointmentRequestBookingOriginEnum[keyof typeof V1PatientPublicBookPhysicalAppointmentWithPractitionerRequestBookAppointmentRequestBookingOriginEnum];

/**
 * Bad request
 */
export interface V1PatientPublicFeedbackRedirect400Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
/**
 * Not found
 */
export interface V1PatientPublicFeedbackRedirect404Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
/**
 * Too many requests
 */
export interface V1PatientPublicFeedbackRedirect429Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
/**
 * Internal server error
 */
export interface V1PatientPublicFeedbackRedirect500Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
/**
 * Area
 */
export interface V1PatientPublicGetAreas200ResponseInner {
    'id': string;
    'name': string;
}
export interface V1PatientPublicGetAvailabilityForServiceInClinicByDateAndPractitioner200ResponseValueInner {
    'practitionerId': string;
    'timeslots': Array<V1PatientPublicGetAvailabilityInClinicWithPractitioner200ResponseInner>;
}
export interface V1PatientPublicGetAvailabilityInClinic200ResponseInner {
    'serviceId': string;
    'startTime': string;
    'numAvailableSpots': number;
    'isAvailable': boolean;
    'surcharges': Array<V1PatientPublicGetAvailabilityInClinicWithPractitioner200ResponseInnerAllOfSurchargesInner>;
    'practitionerAvailability': Array<V1PatientPublicGetAvailabilityInClinic200ResponseInnerAllOfPractitionerAvailabilityInner>;
}
export interface V1PatientPublicGetAvailabilityInClinic200ResponseInnerAllOfPractitionerAvailabilityInner {
    'practitionerId': string;
    'clinicId': string;
    'isAvailable': boolean;
    'numAvailableSpots': number;
}
export interface V1PatientPublicGetAvailabilityInClinicWithPractitioner200ResponseInner {
    'serviceId': string;
    'startTime': string;
    'numAvailableSpots': number;
    'isAvailable': boolean;
    'surcharges': Array<V1PatientPublicGetAvailabilityInClinicWithPractitioner200ResponseInnerAllOfSurchargesInner>;
}
export interface V1PatientPublicGetAvailabilityInClinicWithPractitioner200ResponseInnerAllOfSurchargesInner {
    'price': number;
    'type': V1PatientPublicGetAvailabilityInClinicWithPractitioner200ResponseInnerAllOfSurchargesInnerTypeEnum;
}

export const V1PatientPublicGetAvailabilityInClinicWithPractitioner200ResponseInnerAllOfSurchargesInnerTypeEnum = {
    Evening: 'evening',
    Weekend: 'weekend',
    Holiday: 'holiday'
} as const;

export type V1PatientPublicGetAvailabilityInClinicWithPractitioner200ResponseInnerAllOfSurchargesInnerTypeEnum = typeof V1PatientPublicGetAvailabilityInClinicWithPractitioner200ResponseInnerAllOfSurchargesInnerTypeEnum[keyof typeof V1PatientPublicGetAvailabilityInClinicWithPractitioner200ResponseInnerAllOfSurchargesInnerTypeEnum];

export interface V1PatientPublicGetClinicByShortId200Response {
    'id': string;
    'name': string;
    'timeZone': string;
    'shortId': string;
    'areaId': string;
    'isActive': boolean;
    'coordinates': V1PublicPatientGetAppointment200ResponseClinicCoordinates;
    'address': V1PatientPublicGetClinics200ResponseInnerAddress;
}
export interface V1PatientPublicGetClinics200ResponseInner {
    'id': string;
    'name': string;
    'timeZone': string;
    'shortId': string;
    'areaId': string;
    'isActive': boolean;
    'coordinates': V1PublicPatientGetAppointment200ResponseClinicCoordinates;
    'address': V1PatientPublicGetClinics200ResponseInnerAddress;
}
export interface V1PatientPublicGetClinics200ResponseInnerAddress {
    'street': string;
    'city': string;
    'postalCode': string;
}
export interface V1PatientPublicGetClinicsByArea200ResponseInner {
    'name': string;
    'clinics': Array<V1PatientPublicGetClinics200ResponseInner>;
}
export interface V1PatientPublicGetClinicsWithService200ResponseInner {
    'id': string;
    'name': string;
    'timeZone': string;
    'shortId': string;
    'areaId': string;
    'isActive': boolean;
    'coordinates': V1PublicPatientGetAppointment200ResponseClinicCoordinates;
    'address': V1PatientPublicGetClinics200ResponseInnerAddress;
    'legacyShortIds'?: Array<string>;
}
export interface V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response {
    'serviceId': string;
    'startTime': string;
    'numAvailableSpots': number;
    'isAvailable': boolean;
}
export interface V1PatientPublicGetPractitionerListingFilters200Response {
    'locations': Array<V1PatientPublicGetPractitionerListingFilters200ResponseLocationsInner>;
    'clinics': Array<V1PatientPublicGetPractitionerListingFilters200ResponseClinicsInner>;
    'services': Array<V1PatientPublicGetPractitionerListingFilters200ResponseServicesInner>;
    'serviceCategories': Array<V1PatientPublicGetPractitionerListingFilters200ResponseServiceCategoriesInner>;
    'practitionerTypes': Array<V1PatientPublicGetPractitionerListingFilters200ResponsePractitionerTypesInner>;
    'skills': Array<V1PatientPublicGetPractitionerListingFilters200ResponseSkillsInner>;
}
export interface V1PatientPublicGetPractitionerListingFilters200ResponseClinicsInner {
    'id': string;
    'shortId': string;
    'locationShortId': string | null;
    'name': string;
}
export interface V1PatientPublicGetPractitionerListingFilters200ResponseLocationsInner {
    'shortId': string;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'name': { [key: string]: string | null; };
}
export interface V1PatientPublicGetPractitionerListingFilters200ResponsePractitionerTypesInner {
    'id': string;
    'shortId': string;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'name': { [key: string]: string | null; };
}
export interface V1PatientPublicGetPractitionerListingFilters200ResponseServiceCategoriesInner {
    'id': string;
    'shortId': string;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'name': { [key: string]: string | null; };
    'order': number;
    'parentId': string | null;
}
export interface V1PatientPublicGetPractitionerListingFilters200ResponseServicesInner {
    'id': string;
    'shortId': string;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'name': { [key: string]: string | null; };
    'serviceCategoryId': string;
    'order': number;
    'isVideo': boolean;
    'clinicIds': Array<string>;
}
export interface V1PatientPublicGetPractitionerListingFilters200ResponseSkillsInner {
    'skillCategoryId': string;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'skillCategoryName': { [key: string]: string | null; };
    'skills': Array<V1PatientPublicGetPractitionerListingFilters200ResponseSkillsInnerSkillsInner>;
}
export interface V1PatientPublicGetPractitionerListingFilters200ResponseSkillsInnerSkillsInner {
    'skillId': string;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'skillName': { [key: string]: string | null; };
}
/**
 * Practitioner type
 */
export interface V1PatientPublicGetPractitionerTypes200ResponseInner {
    'id': string;
    'name': string;
    'shortId': string | null;
}
export interface V1PatientPublicGetPractitionersForListing200ResponseInner {
    'id': string;
    'name': string;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'description': { [key: string]: string | null; };
    'photoUrl': string | null;
    'videoId': string | null;
    'serviceIds': Array<string>;
    'clinicIds': Array<string>;
    'skillProficiencies': Array<V1PatientGetPractitionerSkillProficiencies200ResponseInner>;
    'practitionerTypeIds': Array<string>;
}
export interface V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter {
}
/**
 * Service
 */
export interface V1PatientPublicGetServiceByShortId200Response {
    'id': string;
    'departmentId': string;
    'name': string;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'displayName': { [key: string]: string | null; };
    'shortId': string;
    'price': number;
    'duration': V1PublicPatientGetAppointment200ResponseFreeCancellationLimit;
    'requiresPrepayment': boolean;
    'requiresBookWithPractitioner': boolean;
    'bookFirstAvailable': boolean;
    'isVideo': boolean;
    'freeCancellationLimit': V1PublicPatientGetAppointment200ResponseFreeCancellationLimit;
    'weekendSurcharge': number;
    'eveningSurcharge': number;
    'serviceCategoryId': string;
    'clinicIds': Array<string>;
}
/**
 * Service category
 */
export interface V1PatientPublicGetServiceCategories200ResponseInner {
    'id': string;
    'shortId': string;
    'name': string;
}
export interface V1PatientPublicGetServiceTriage200Response {
    'id': string;
    'shortId': string;
    'serviceId': string;
    'medicalIssues': Array<V1PatientPublicGetServiceTriage200ResponseMedicalIssuesInner> | null;
}
export interface V1PatientPublicGetServiceTriage200ResponseMedicalIssuesInner {
    'id': string;
    'name': string;
    'shortId': string;
    'treatable': boolean;
    'description': string | null;
    'shouldBlockBooking': boolean;
    'link': string | null;
}
/**
 * Service
 */
export interface V1PatientPublicGetServices200ResponseInner {
    'id': string;
    'departmentId': string;
    'name': string;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'displayName': { [key: string]: string | null; };
    'shortId': string;
    'price': number;
    'duration': V1PublicPatientGetAppointment200ResponseFreeCancellationLimit;
    'requiresPrepayment': boolean;
    'requiresBookWithPractitioner': boolean;
    'bookFirstAvailable': boolean;
    'isVideo': boolean;
    'freeCancellationLimit': V1PublicPatientGetAppointment200ResponseFreeCancellationLimit;
    'weekendSurcharge': number;
    'eveningSurcharge': number;
    'serviceCategoryId': string;
    'clinicIds': Array<string>;
}
/**
 * Skill category with skills
 */
export interface V1PatientPublicGetSkillCategories200ResponseInner {
    'id': string;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'name': { [key: string]: string | null; };
    'skills': Array<V1PatientPublicGetSkillCategories200ResponseInnerSkillsInner>;
}
/**
 * Skill
 */
export interface V1PatientPublicGetSkillCategories200ResponseInnerSkillsInner {
    'id': string;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'name': { [key: string]: string | null; };
}
export interface V1PatientPublicLegacyBookPhysicalAppointment200Response {
    'clinicId': string;
    'id': string;
    'practitionerId': string;
    'serviceId': string;
    'startTime': string;
}
export interface V1PatientPublicLegacyBookPhysicalAppointmentRequest {
    'bookAppointmentRequest': V1PatientPublicLegacyBookPhysicalAppointmentRequestBookAppointmentRequest;
    'patient': V1PatientPublicBookPhysicalAppointmentRequestPatient;
}
export interface V1PatientPublicLegacyBookPhysicalAppointmentRequestBookAppointmentRequest {
    'bookingOrigin': V1PatientPublicLegacyBookPhysicalAppointmentRequestBookAppointmentRequestBookingOriginEnum;
    'description': string;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'startTime': any;
    'clinicId': string;
}

export const V1PatientPublicLegacyBookPhysicalAppointmentRequestBookAppointmentRequestBookingOriginEnum = {
    Web: 'web'
} as const;

export type V1PatientPublicLegacyBookPhysicalAppointmentRequestBookAppointmentRequestBookingOriginEnum = typeof V1PatientPublicLegacyBookPhysicalAppointmentRequestBookAppointmentRequestBookingOriginEnum[keyof typeof V1PatientPublicLegacyBookPhysicalAppointmentRequestBookAppointmentRequestBookingOriginEnum];

export interface V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest {
    'bookAppointmentRequest': V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequestBookAppointmentRequest;
    'patient': V1PatientPublicBookPhysicalAppointmentRequestPatient;
}
export interface V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequestBookAppointmentRequest {
    'bookingOrigin': V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequestBookAppointmentRequestBookingOriginEnum;
    'description': string;
    'partnerCampaignId'?: string;
    'serviceId': string;
    'startTime': any;
    'clinicId': string;
    'practitionerId': string;
}

export const V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequestBookAppointmentRequestBookingOriginEnum = {
    Web: 'web'
} as const;

export type V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequestBookAppointmentRequestBookingOriginEnum = typeof V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequestBookAppointmentRequestBookingOriginEnum[keyof typeof V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequestBookAppointmentRequestBookingOriginEnum];

/**
 * Bad Request - invalid request
 */
export interface V1PatientReportCallStatus400Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
/**
 * Not Found - room not found
 */
export interface V1PatientReportCallStatus404Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
export interface V1PatientReportCallStatusRequest {
    'action': V1PatientReportCallStatusRequestActionEnum;
}

export const V1PatientReportCallStatusRequestActionEnum = {
    Ringing: 'ringing',
    Answered: 'answered',
    Declined: 'declined',
    NoAnswer: 'no-answer'
} as const;

export type V1PatientReportCallStatusRequestActionEnum = typeof V1PatientReportCallStatusRequestActionEnum[keyof typeof V1PatientReportCallStatusRequestActionEnum];

/**
 * Signed upload URL + the created (hidden) case-image id
 */
export interface V1PatientRequestCaseImageUploadUrl200Response {
    'caseImageId': string;
    'uploadUrl': string;
}
/**
 * Bad Request
 */
export interface V1PatientRequestCaseImageUploadUrl400Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
/**
 * Forbidden - patient does not own the photo case
 */
export interface V1PatientRequestCaseImageUploadUrl403Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
/**
 * Not Found - photo case not found
 */
export interface V1PatientRequestCaseImageUploadUrl404Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
export interface V1PatientRequestCaseImageUploadUrlRequest {
    'photoCaseId': string;
    'imageType': V1PatientRequestCaseImageUploadUrlRequestImageTypeEnum;
    'mimeType': string;
    'declaredSizeBytes'?: number | null;
}

export const V1PatientRequestCaseImageUploadUrlRequestImageTypeEnum = {
    Closeup: 'closeup',
    Overview: 'overview',
    IdProof: 'id_proof',
    Signature: 'signature'
} as const;

export type V1PatientRequestCaseImageUploadUrlRequestImageTypeEnum = typeof V1PatientRequestCaseImageUploadUrlRequestImageTypeEnum[keyof typeof V1PatientRequestCaseImageUploadUrlRequestImageTypeEnum];

/**
 * The submitted photo case
 */
export interface V1PatientSubmitPhotoCase200Response {
    'id': string;
    'patientId': string;
    'organizationId': string;
    'clinicId': string | null;
    'serviceId': string;
    'departmentId': string;
    'orderId': string | null;
    'status': V1PatientSubmitPhotoCase200ResponseStatusEnum;
    'caseCode': string;
    'category': string | null;
    'questionnaire': { [key: string]: any; } | null;
    'childId': string | null;
    'submittedAt': string | null;
    'diagnosedAt': string | null;
    'closedAt': string | null;
    'deadlineAt': string | null;
    'createdAt': string;
    'updatedAt': string;
}

export const V1PatientSubmitPhotoCase200ResponseStatusEnum = {
    Draft: 'draft',
    Submitted: 'submitted',
    Claimed: 'claimed',
    Diagnosed: 'diagnosed',
    Closed: 'closed',
    Rejected: 'rejected',
    Cancelled: 'cancelled'
} as const;

export type V1PatientSubmitPhotoCase200ResponseStatusEnum = typeof V1PatientSubmitPhotoCase200ResponseStatusEnum[keyof typeof V1PatientSubmitPhotoCase200ResponseStatusEnum];

/**
 * Bad Request - case is not a draft
 */
export interface V1PatientSubmitPhotoCase400Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
export interface V1PatientTravelInsuranceGetCountries200ResponseInner {
    'name': string;
    'A3': string;
}
export interface V1PatientTravelInsuranceLegacyValidateCountry200Response {
    'isValid': boolean;
    'errorMessage'?: string;
}
export interface V1PatientTravelInsuranceLegacyValidateCountryRequest {
    'partnerCampaignId': string;
    'serviceId': string;
    /**
     * ISO3166-1 alpha-3 country code
     */
    'country': string;
    'locale'?: V1PatientTravelInsuranceLegacyValidateCountryRequestLocaleEnum;
}

export const V1PatientTravelInsuranceLegacyValidateCountryRequestLocaleEnum = {
    Nb: 'nb',
    En: 'en'
} as const;

export type V1PatientTravelInsuranceLegacyValidateCountryRequestLocaleEnum = typeof V1PatientTravelInsuranceLegacyValidateCountryRequestLocaleEnum[keyof typeof V1PatientTravelInsuranceLegacyValidateCountryRequestLocaleEnum];

export interface V1PatientUpdatePersonalInfo200Response {
    'firstName': string;
    'lastName': string;
    'phone': string;
    'countryCode': string;
    'email': string | null;
}
export interface V1PatientUpdatePersonalInfoRequest {
    'firstName': string;
    'lastName': string;
    'phone': string;
    'countryCode': string;
    'email': string | null;
}
/**
 * The updated photo case
 */
export interface V1PatientUpdatePhotoCaseQuestionnaire200Response {
    'id': string;
    'patientId': string;
    'organizationId': string;
    'clinicId': string | null;
    'serviceId': string;
    'departmentId': string;
    'orderId': string | null;
    'status': V1PatientUpdatePhotoCaseQuestionnaire200ResponseStatusEnum;
    'caseCode': string;
    'category': string | null;
    'questionnaire': { [key: string]: any; } | null;
    'childId': string | null;
    'submittedAt': string | null;
    'diagnosedAt': string | null;
    'closedAt': string | null;
    'deadlineAt': string | null;
    'createdAt': string;
    'updatedAt': string;
}

export const V1PatientUpdatePhotoCaseQuestionnaire200ResponseStatusEnum = {
    Draft: 'draft',
    Submitted: 'submitted',
    Claimed: 'claimed',
    Diagnosed: 'diagnosed',
    Closed: 'closed',
    Rejected: 'rejected',
    Cancelled: 'cancelled'
} as const;

export type V1PatientUpdatePhotoCaseQuestionnaire200ResponseStatusEnum = typeof V1PatientUpdatePhotoCaseQuestionnaire200ResponseStatusEnum[keyof typeof V1PatientUpdatePhotoCaseQuestionnaire200ResponseStatusEnum];

/**
 * Not Found - photo case or child not found
 */
export interface V1PatientUpdatePhotoCaseQuestionnaire404Response {
    'message': string;
    'errorCode': string;
    'issues'?: Array<string>;
}
export interface V1PatientUpdatePhotoCaseQuestionnaireRequest {
    'category'?: string | null;
    'childId'?: string | null;
    'questionnaire'?: { [key: string]: any; } | null;
}
export interface V1PatientUpsertMyMedicalInfo200Response {
    'medicalInfoId': string;
}
export interface V1PatientUpsertMyMedicalInfoRequest {
    'hasAllergies': boolean;
    'allergies': string | null;
    'hasMedication': boolean;
    'medication': string | null;
}
export interface V1PatientVerifyGjensidigeInsuranceNumberRequest {
    'partnerCampaignId': string;
    'insuranceNumber': string;
}
export interface V1PatientVerifyPartnerCampaignCodeRequest {
    'partnerId': string;
    'campaignCode': string;
}
/**
 * Phone number verified successfully
 */
export interface V1PatientVerifyPhoneNumber200Response {
    /**
     * Verification status
     */
    'status': V1PatientVerifyPhoneNumber200ResponseStatusEnum;
    /**
     * Whether the phone number was successfully verified
     */
    'verified': boolean;
}

export const V1PatientVerifyPhoneNumber200ResponseStatusEnum = {
    Approved: 'approved',
    Pending: 'pending',
    Canceled: 'canceled',
    MaxAttemptsReached: 'max_attempts_reached',
    Deleted: 'deleted',
    Failed: 'failed',
    Expired: 'expired'
} as const;

export type V1PatientVerifyPhoneNumber200ResponseStatusEnum = typeof V1PatientVerifyPhoneNumber200ResponseStatusEnum[keyof typeof V1PatientVerifyPhoneNumber200ResponseStatusEnum];

export interface V1PatientVerifyPhoneNumberRequest {
    /**
     * Phone number in E.164 format (e.g., +4712345678)
     */
    'phone': string;
    /**
     * Verification code received via SMS
     */
    'code': string;
}
export interface V1PublicPatientCancelAppointment200Response {
    'id': string;
    'message': string;
}
/**
 * Public Appointment with Relations and Order Summaries
 */
export interface V1PublicPatientGetAppointment200Response {
    'clinic': V1PublicPatientGetAppointment200ResponseClinic;
    'endTime': string;
    'freeCancellationLimit': V1PublicPatientGetAppointment200ResponseFreeCancellationLimit;
    'order': V1PublicPatientGetAppointment200ResponseOrder;
    'partnerName'?: string | null;
    'practitioner': V1PublicPatientGetAppointment200ResponsePractitioner;
    'service': V1PublicPatientGetAppointment200ResponseService;
    'canReschedule': boolean;
    'startTime': string;
    'status': V1PublicPatientGetAppointment200ResponseStatusEnum;
}

export const V1PublicPatientGetAppointment200ResponseStatusEnum = {
    Reserved: 'reserved',
    Booked: 'booked',
    Claimed: 'claimed',
    InProgress: 'in_progress',
    Cancelled: 'cancelled',
    NoShow: 'no_show',
    Completed: 'completed',
    Failed: 'failed',
    Deleted: 'deleted'
} as const;

export type V1PublicPatientGetAppointment200ResponseStatusEnum = typeof V1PublicPatientGetAppointment200ResponseStatusEnum[keyof typeof V1PublicPatientGetAppointment200ResponseStatusEnum];

export interface V1PublicPatientGetAppointment200ResponseClinic {
    'id': string;
    'name': string;
    'address': V1PublicPatientGetAppointment200ResponseClinicAddress;
    'coordinates': V1PublicPatientGetAppointment200ResponseClinicCoordinates;
}
export interface V1PublicPatientGetAppointment200ResponseClinicAddress {
    'street': string;
    'postalCode': string;
    'city': string;
}
export interface V1PublicPatientGetAppointment200ResponseClinicCoordinates {
    'lat': number;
    'lng': number;
}
/**
 * Duration
 */
export interface V1PublicPatientGetAppointment200ResponseFreeCancellationLimit {
    'seconds'?: number;
    'minutes'?: number;
    'hours'?: number;
    'days'?: number;
    'months'?: number;
    'years'?: number;
}
export interface V1PublicPatientGetAppointment200ResponseOrder {
    'totalPrice': number;
    'remainingAmount': number;
    'totalDiscount': number;
    'payments': Array<V1PublicPatientGetAppointment200ResponseOrderPaymentsInner>;
    'orderItems': Array<V1PublicPatientGetAppointment200ResponseOrderOrderItemsInner>;
}
export interface V1PublicPatientGetAppointment200ResponseOrderOrderItemsInner {
    'type': V1PublicPatientGetAppointment200ResponseOrderOrderItemsInnerTypeEnum;
    'name': string;
    'price': number;
}

export const V1PublicPatientGetAppointment200ResponseOrderOrderItemsInnerTypeEnum = {
    Service: 'service',
    Surcharge: 'surcharge'
} as const;

export type V1PublicPatientGetAppointment200ResponseOrderOrderItemsInnerTypeEnum = typeof V1PublicPatientGetAppointment200ResponseOrderOrderItemsInnerTypeEnum[keyof typeof V1PublicPatientGetAppointment200ResponseOrderOrderItemsInnerTypeEnum];

export interface V1PublicPatientGetAppointment200ResponseOrderPaymentsInner {
    'amount': number;
}
export interface V1PublicPatientGetAppointment200ResponsePractitioner {
    'id': string;
    'shortName': string;
    'pictureUrl': string | null;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'description': { [key: string]: string | null; };
}
export interface V1PublicPatientGetAppointment200ResponseService {
    'id': string;
    /**
     * localized string where the key is a language code and the value is the localized string
     */
    'displayName': { [key: string]: string | null; };
    'duration': V1PublicPatientGetAppointment200ResponseFreeCancellationLimit;
    'isVideo': boolean;
    'allowPatientRescheduling': boolean;
    'allowPatientReschedulingAcrossPractitioners': boolean;
    'requiresBookWithPractitioner': boolean;
    'eveningSurcharge': number;
    'weekendSurcharge': number;
}
/**
 * Public Appointment with Relations and Order Summaries
 */
export interface V1PublicPatientRescheduleAppointment200Response {
    'clinic': V1PublicPatientGetAppointment200ResponseClinic;
    'endTime': string;
    'freeCancellationLimit': V1PublicPatientGetAppointment200ResponseFreeCancellationLimit;
    'order': V1PublicPatientGetAppointment200ResponseOrder;
    'partnerName'?: string | null;
    'practitioner': V1PublicPatientGetAppointment200ResponsePractitioner;
    'service': V1PublicPatientGetAppointment200ResponseService;
    'canReschedule': boolean;
    'startTime': string;
    'status': V1PublicPatientRescheduleAppointment200ResponseStatusEnum;
}

export const V1PublicPatientRescheduleAppointment200ResponseStatusEnum = {
    Reserved: 'reserved',
    Booked: 'booked',
    Claimed: 'claimed',
    InProgress: 'in_progress',
    Cancelled: 'cancelled',
    NoShow: 'no_show',
    Completed: 'completed',
    Failed: 'failed',
    Deleted: 'deleted'
} as const;

export type V1PublicPatientRescheduleAppointment200ResponseStatusEnum = typeof V1PublicPatientRescheduleAppointment200ResponseStatusEnum[keyof typeof V1PublicPatientRescheduleAppointment200ResponseStatusEnum];

export interface V1PublicPatientRescheduleAppointmentRequest {
    'startTime': string;
    'practitionerId'?: string;
}
/**
 * Created or updated device token
 */
export interface V1createDeviceToken200Response {
    'id': string;
    'patientId': string;
    'token': string;
    'deviceType': string;
    'createdAt': string;
}
export interface V1createDeviceTokenRequest {
    'deviceToken': string;
    'deviceType': V1createDeviceTokenRequestDeviceTypeEnum;
}

export const V1createDeviceTokenRequestDeviceTypeEnum = {
    Ios: 'ios',
    Android: 'android'
} as const;

export type V1createDeviceTokenRequestDeviceTypeEnum = typeof V1createDeviceTokenRequestDeviceTypeEnum[keyof typeof V1createDeviceTokenRequestDeviceTypeEnum];


/**
 * DefaultApi - axios parameter creator
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthLiveGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthReadyGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health/ready`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if the patient has Motimate access, needs to create a user, or has expired access, or can be linked directly to the Motimate login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CreateMotimateUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/partners/motimate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the Exorlive url for patient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPatientExorliveUrl: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/exorlive/url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if the patient has Motimate access, needs to create a user, or has expired access, or can be linked directly to the Motimate login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPatientMotimateAccessStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/partners/motimate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1IntegrationsAuth0UsersEmployeePutRequest} v1IntegrationsAuth0UsersEmployeePutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsAuth0UsersEmployeePut: async (v1IntegrationsAuth0UsersEmployeePutRequest: V1IntegrationsAuth0UsersEmployeePutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1IntegrationsAuth0UsersEmployeePutRequest' is not null or undefined
            assertParamExists('v1IntegrationsAuth0UsersEmployeePut', 'v1IntegrationsAuth0UsersEmployeePutRequest', v1IntegrationsAuth0UsersEmployeePutRequest)
            const localVarPath = `/v1/integrations/auth0/users/employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1IntegrationsAuth0UsersEmployeePutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1IntegrationsAuth0UsersPatientPutRequest} v1IntegrationsAuth0UsersPatientPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsAuth0UsersPatientPut: async (v1IntegrationsAuth0UsersPatientPutRequest: V1IntegrationsAuth0UsersPatientPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1IntegrationsAuth0UsersPatientPutRequest' is not null or undefined
            assertParamExists('v1IntegrationsAuth0UsersPatientPut', 'v1IntegrationsAuth0UsersPatientPutRequest', v1IntegrationsAuth0UsersPatientPutRequest)
            const localVarPath = `/v1/integrations/auth0/users/patient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1IntegrationsAuth0UsersPatientPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1IntegrationsDigicareBookingsPostRequest} v1IntegrationsDigicareBookingsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsDigicareBookingsPost: async (v1IntegrationsDigicareBookingsPostRequest: V1IntegrationsDigicareBookingsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1IntegrationsDigicareBookingsPostRequest' is not null or undefined
            assertParamExists('v1IntegrationsDigicareBookingsPost', 'v1IntegrationsDigicareBookingsPostRequest', v1IntegrationsDigicareBookingsPostRequest)
            const localVarPath = `/v1/integrations/digicare/bookings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1IntegrationsDigicareBookingsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsDigicareClinicsGet: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('v1IntegrationsDigicareClinicsGet', 'organizationId', organizationId)
            const localVarPath = `/v1/integrations/digicare/clinics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clinicIdWithDepartment 
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsDigicareClinicsPractitionersGet: async (clinicIdWithDepartment: string, serviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clinicIdWithDepartment' is not null or undefined
            assertParamExists('v1IntegrationsDigicareClinicsPractitionersGet', 'clinicIdWithDepartment', clinicIdWithDepartment)
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1IntegrationsDigicareClinicsPractitionersGet', 'serviceId', serviceId)
            const localVarPath = `/v1/integrations/digicare/clinics/practitioners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clinicIdWithDepartment !== undefined) {
                localVarQueryParameter['clinicIdWithDepartment'] = clinicIdWithDepartment;
            }

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clinicIdWithDepartment 
         * @param {string} serviceId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsDigicarePractitionersGet: async (clinicIdWithDepartment: string, serviceId: string, fromDate: string, toDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clinicIdWithDepartment' is not null or undefined
            assertParamExists('v1IntegrationsDigicarePractitionersGet', 'clinicIdWithDepartment', clinicIdWithDepartment)
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1IntegrationsDigicarePractitionersGet', 'serviceId', serviceId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('v1IntegrationsDigicarePractitionersGet', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('v1IntegrationsDigicarePractitionersGet', 'toDate', toDate)
            const localVarPath = `/v1/integrations/digicare/practitioners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clinicIdWithDepartment !== undefined) {
                localVarQueryParameter['clinicIdWithDepartment'] = clinicIdWithDepartment;
            }

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clinicIdWithDepartment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsDigicareServicesGet: async (clinicIdWithDepartment: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clinicIdWithDepartment' is not null or undefined
            assertParamExists('v1IntegrationsDigicareServicesGet', 'clinicIdWithDepartment', clinicIdWithDepartment)
            const localVarPath = `/v1/integrations/digicare/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clinicIdWithDepartment !== undefined) {
                localVarQueryParameter['clinicIdWithDepartment'] = clinicIdWithDepartment;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clinicIdWithDepartment 
         * @param {string} serviceId 
         * @param {string} practitionerId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsDigicareTimeslotsGet: async (clinicIdWithDepartment: string, serviceId: string, practitionerId: string, fromDate: string, toDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clinicIdWithDepartment' is not null or undefined
            assertParamExists('v1IntegrationsDigicareTimeslotsGet', 'clinicIdWithDepartment', clinicIdWithDepartment)
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1IntegrationsDigicareTimeslotsGet', 'serviceId', serviceId)
            // verify required parameter 'practitionerId' is not null or undefined
            assertParamExists('v1IntegrationsDigicareTimeslotsGet', 'practitionerId', practitionerId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('v1IntegrationsDigicareTimeslotsGet', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('v1IntegrationsDigicareTimeslotsGet', 'toDate', toDate)
            const localVarPath = `/v1/integrations/digicare/timeslots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clinicIdWithDepartment !== undefined) {
                localVarQueryParameter['clinicIdWithDepartment'] = clinicIdWithDepartment;
            }

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (practitionerId !== undefined) {
                localVarQueryParameter['practitionerId'] = practitionerId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsLinkMobilityDeliveryReportPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/integrations/link-mobility/delivery-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsLinkMobilityIncomingMessagePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/integrations/link-mobility/incoming-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsPaymentsPaymentIdCallbackGet: async (paymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('v1IntegrationsPaymentsPaymentIdCallbackGet', 'paymentId', paymentId)
            const localVarPath = `/v1/integrations/payments/{paymentId}/callback`
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} paymentId 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsPaymentsPaymentIdClientRedirectStatusGet: async (paymentId: string, status: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('v1IntegrationsPaymentsPaymentIdClientRedirectStatusGet', 'paymentId', paymentId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('v1IntegrationsPaymentsPaymentIdClientRedirectStatusGet', 'status', status)
            const localVarPath = `/v1/integrations/payments/{paymentId}/client_redirect/{status}`
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsPaymentsPaymentIdRedirectGet: async (paymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('v1IntegrationsPaymentsPaymentIdRedirectGet', 'paymentId', paymentId)
            const localVarPath = `/v1/integrations/payments/{paymentId}/redirect`
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalAppointmentsAutocompleteInProgressAppointmentAppointmentIdPost: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('v1IntegrationsTemporalAppointmentsAutocompleteInProgressAppointmentAppointmentIdPost', 'appointmentId', appointmentId)
            const localVarPath = `/v1/integrations/temporal/appointments/autocomplete-in-progress-appointment/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalAppointmentsCompleteStaleBookedAppointmentsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/integrations/temporal/appointments/complete-stale-booked-appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalAppointmentsDeleteStaleReservedAppointmentsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/integrations/temporal/appointments/delete-stale-reserved-appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalAppointmentsReleaseStaleClaimedAppointmentsAppointmentIdPost: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('v1IntegrationsTemporalAppointmentsReleaseStaleClaimedAppointmentsAppointmentIdPost', 'appointmentId', appointmentId)
            const localVarPath = `/v1/integrations/temporal/appointments/release-stale-claimed-appointments/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest} v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPost: async (v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest: V1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest' is not null or undefined
            assertParamExists('v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPost', 'v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest', v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest)
            const localVarPath = `/v1/integrations/temporal/appointments/reschedule-appointment-reminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest} v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPost: async (v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest: V1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest' is not null or undefined
            assertParamExists('v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPost', 'v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest', v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest)
            const localVarPath = `/v1/integrations/temporal/appointments/schedule-confirmation-messages-for-seeded-appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalEmployeesActivateHiredEmployeesPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/integrations/temporal/employees/activate-hired-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalEmployeesDeactivateTerminatedEmployeesPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/integrations/temporal/employees/deactivate-terminated-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest} v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalRecallsAttemptRecallBookingPost: async (v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest: V1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest' is not null or undefined
            assertParamExists('v1IntegrationsTemporalRecallsAttemptRecallBookingPost', 'v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest', v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest)
            const localVarPath = `/v1/integrations/temporal/recalls/attempt-recall-booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTwilioWakeUpCallCallbackPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/integrations/twilio/wake-up-call/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTwilioWakeUpCallMessageGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/integrations/twilio/wake-up-call/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InternalAuthCallbackGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal/auth/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InternalAuthTestProtectedGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal/auth-test/protected`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InternalAuthTestPublicGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/internal/auth-test/public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InternalLoginGet: async (returnTo: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'returnTo' is not null or undefined
            assertParamExists('v1InternalLoginGet', 'returnTo', returnTo)
            const localVarPath = `/v1/internal/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (returnTo !== undefined) {
                localVarQueryParameter['return_to'] = returnTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InternalRefreshSessionGet: async (returnTo: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'returnTo' is not null or undefined
            assertParamExists('v1InternalRefreshSessionGet', 'returnTo', returnTo)
            const localVarPath = `/v1/internal/refresh-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (returnTo !== undefined) {
                localVarQueryParameter['return_to'] = returnTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Book first available video appointment
         * @param {V1PatientBookFirstAvailableVideoAppointmentRequest} v1PatientBookFirstAvailableVideoAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientBookFirstAvailableVideoAppointment: async (v1PatientBookFirstAvailableVideoAppointmentRequest: V1PatientBookFirstAvailableVideoAppointmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientBookFirstAvailableVideoAppointmentRequest' is not null or undefined
            assertParamExists('v1PatientBookFirstAvailableVideoAppointment', 'v1PatientBookFirstAvailableVideoAppointmentRequest', v1PatientBookFirstAvailableVideoAppointmentRequest)
            const localVarPath = `/v1/patient/appointments/book-first-available-video-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientBookFirstAvailableVideoAppointmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Book physical appointment for logged-in patient
         * @param {V1PatientBookPhysicalAppointmentRequest} v1PatientBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientBookPhysicalAppointment: async (v1PatientBookPhysicalAppointmentRequest: V1PatientBookPhysicalAppointmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientBookPhysicalAppointmentRequest' is not null or undefined
            assertParamExists('v1PatientBookPhysicalAppointment', 'v1PatientBookPhysicalAppointmentRequest', v1PatientBookPhysicalAppointmentRequest)
            const localVarPath = `/v1/patient/appointments/book-physical-appointment-with-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientBookPhysicalAppointmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Book physical appointment for logged-in patient
         * @param {V1PatientBookPhysicalAppointmentForLoggedInPatientRequest} v1PatientBookPhysicalAppointmentForLoggedInPatientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientBookPhysicalAppointmentForLoggedInPatient: async (v1PatientBookPhysicalAppointmentForLoggedInPatientRequest: V1PatientBookPhysicalAppointmentForLoggedInPatientRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientBookPhysicalAppointmentForLoggedInPatientRequest' is not null or undefined
            assertParamExists('v1PatientBookPhysicalAppointmentForLoggedInPatient', 'v1PatientBookPhysicalAppointmentForLoggedInPatientRequest', v1PatientBookPhysicalAppointmentForLoggedInPatientRequest)
            const localVarPath = `/v1/patient/appointments/book-physical-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientBookPhysicalAppointmentForLoggedInPatientRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Book a video appointment
         * @param {V1PatientBookVideoAppointmentRequest} v1PatientBookVideoAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientBookVideoAppointment: async (v1PatientBookVideoAppointmentRequest: V1PatientBookVideoAppointmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientBookVideoAppointmentRequest' is not null or undefined
            assertParamExists('v1PatientBookVideoAppointment', 'v1PatientBookVideoAppointmentRequest', v1PatientBookVideoAppointmentRequest)
            const localVarPath = `/v1/patient/appointments/book-video-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientBookVideoAppointmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Book a video appointment
         * @param {V1PatientBookVideoAppointmentWithPractitionerRequest} v1PatientBookVideoAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientBookVideoAppointmentWithPractitioner: async (v1PatientBookVideoAppointmentWithPractitionerRequest: V1PatientBookVideoAppointmentWithPractitionerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientBookVideoAppointmentWithPractitionerRequest' is not null or undefined
            assertParamExists('v1PatientBookVideoAppointmentWithPractitioner', 'v1PatientBookVideoAppointmentWithPractitionerRequest', v1PatientBookVideoAppointmentWithPractitionerRequest)
            const localVarPath = `/v1/patient/appointments/book-video-appointment-with-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientBookVideoAppointmentWithPractitionerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel a photo case that has not yet been claimed.
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCancelPhotoCase: async (photoCaseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'photoCaseId' is not null or undefined
            assertParamExists('v1PatientCancelPhotoCase', 'photoCaseId', photoCaseId)
            const localVarPath = `/v1/patient/photo-cases/{photoCaseId}/cancel`
                .replace(`{${"photoCaseId"}}`, encodeURIComponent(String(photoCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} caseImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientConfirmCaseImageUpload: async (caseImageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseImageId' is not null or undefined
            assertParamExists('v1PatientConfirmCaseImageUpload', 'caseImageId', caseImageId)
            const localVarPath = `/v1/patient/case-images/{caseImageId}/confirm`
                .replace(`{${"caseImageId"}}`, encodeURIComponent(String(caseImageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientCreateCampaignMembershipWithCodeRequest} v1PatientCreateCampaignMembershipWithCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCreateCampaignMembershipWithCode: async (v1PatientCreateCampaignMembershipWithCodeRequest: V1PatientCreateCampaignMembershipWithCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientCreateCampaignMembershipWithCodeRequest' is not null or undefined
            assertParamExists('v1PatientCreateCampaignMembershipWithCode', 'v1PatientCreateCampaignMembershipWithCodeRequest', v1PatientCreateCampaignMembershipWithCodeRequest)
            const localVarPath = `/v1/patient/partners/memberships/code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientCreateCampaignMembershipWithCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientCreateCampaignMembershipWithEmailRequest} v1PatientCreateCampaignMembershipWithEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCreateCampaignMembershipWithEmail: async (v1PatientCreateCampaignMembershipWithEmailRequest: V1PatientCreateCampaignMembershipWithEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientCreateCampaignMembershipWithEmailRequest' is not null or undefined
            assertParamExists('v1PatientCreateCampaignMembershipWithEmail', 'v1PatientCreateCampaignMembershipWithEmailRequest', v1PatientCreateCampaignMembershipWithEmailRequest)
            const localVarPath = `/v1/patient/partners/memberships/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientCreateCampaignMembershipWithEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientCreateCampaignMembershipWithInsuranceNumberRequest} v1PatientCreateCampaignMembershipWithInsuranceNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCreateCampaignMembershipWithInsuranceNumber: async (v1PatientCreateCampaignMembershipWithInsuranceNumberRequest: V1PatientCreateCampaignMembershipWithInsuranceNumberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientCreateCampaignMembershipWithInsuranceNumberRequest' is not null or undefined
            assertParamExists('v1PatientCreateCampaignMembershipWithInsuranceNumber', 'v1PatientCreateCampaignMembershipWithInsuranceNumberRequest', v1PatientCreateCampaignMembershipWithInsuranceNumberRequest)
            const localVarPath = `/v1/patient/partners/memberships/insurance-number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientCreateCampaignMembershipWithInsuranceNumberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientCreateChildRequest} v1PatientCreateChildRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCreateChild: async (v1PatientCreateChildRequest: V1PatientCreateChildRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientCreateChildRequest' is not null or undefined
            assertParamExists('v1PatientCreateChild', 'v1PatientCreateChildRequest', v1PatientCreateChildRequest)
            const localVarPath = `/v1/patient/children/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientCreateChildRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check that the ssn is connected to a valid nordea life insurance, then create the campaign membership
         * @param {V1PatientCreateNordeaCampaignMembershipRequest} v1PatientCreateNordeaCampaignMembershipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCreateNordeaCampaignMembership: async (v1PatientCreateNordeaCampaignMembershipRequest: V1PatientCreateNordeaCampaignMembershipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientCreateNordeaCampaignMembershipRequest' is not null or undefined
            assertParamExists('v1PatientCreateNordeaCampaignMembership', 'v1PatientCreateNordeaCampaignMembershipRequest', v1PatientCreateNordeaCampaignMembershipRequest)
            const localVarPath = `/v1/patient/partners/memberships/nordea`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientCreateNordeaCampaignMembershipRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new draft photo case for the logged-in patient.
         * @param {V1PatientCreatePhotoCaseRequest} v1PatientCreatePhotoCaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCreatePhotoCase: async (v1PatientCreatePhotoCaseRequest: V1PatientCreatePhotoCaseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientCreatePhotoCaseRequest' is not null or undefined
            assertParamExists('v1PatientCreatePhotoCase', 'v1PatientCreatePhotoCaseRequest', v1PatientCreatePhotoCaseRequest)
            const localVarPath = `/v1/patient/photo-cases/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientCreatePhotoCaseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} paymentCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientDeactivatePaymentCard: async (paymentCardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentCardId' is not null or undefined
            assertParamExists('v1PatientDeactivatePaymentCard', 'paymentCardId', paymentCardId)
            const localVarPath = `/v1/patient/payments/cards/{paymentCardId}`
                .replace(`{${"paymentCardId"}}`, encodeURIComponent(String(paymentCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} caseImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientDeleteCaseImage: async (caseImageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseImageId' is not null or undefined
            assertParamExists('v1PatientDeleteCaseImage', 'caseImageId', caseImageId)
            const localVarPath = `/v1/patient/case-images/{caseImageId}`
                .replace(`{${"caseImageId"}}`, encodeURIComponent(String(caseImageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} childId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientDeleteChild: async (childId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'childId' is not null or undefined
            assertParamExists('v1PatientDeleteChild', 'childId', childId)
            const localVarPath = `/v1/patient/children/{childId}`
                .replace(`{${"childId"}}`, encodeURIComponent(String(childId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientDeletePartnerMembership: async (campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('v1PatientDeletePartnerMembership', 'campaignId', campaignId)
            const localVarPath = `/v1/patient/partners/memberships/{campaignId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single appointment by ID for logged-in patient with payment details.
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetAppointmentById: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('v1PatientGetAppointmentById', 'appointmentId', appointmentId)
            const localVarPath = `/v1/patient/appointments/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single appointment by video room ID for logged-in patient.
         * @param {string} videoRoomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetAppointmentByVideoRoomId: async (videoRoomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'videoRoomId' is not null or undefined
            assertParamExists('v1PatientGetAppointmentByVideoRoomId', 'videoRoomId', videoRoomId)
            const localVarPath = `/v1/patient/appointments/by-video-room/{videoRoomId}`
                .replace(`{${"videoRoomId"}}`, encodeURIComponent(String(videoRoomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current and upcoming appointments for logged-in patient.
         * @param {Array<V1PatientGetAppointmentsAdditionalStatusesEnum>} additionalStatuses 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetAppointments: async (additionalStatuses: Array<V1PatientGetAppointmentsAdditionalStatusesEnum>, fromDate?: string, toDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'additionalStatuses' is not null or undefined
            assertParamExists('v1PatientGetAppointments', 'additionalStatuses', additionalStatuses)
            const localVarPath = `/v1/patient/appointments/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (additionalStatuses) {
                localVarQueryParameter['additionalStatuses'] = additionalStatuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} caseImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetCaseImageViewUrl: async (caseImageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseImageId' is not null or undefined
            assertParamExists('v1PatientGetCaseImageViewUrl', 'caseImageId', caseImageId)
            const localVarPath = `/v1/patient/case-images/{caseImageId}/view-url`
                .replace(`{${"caseImageId"}}`, encodeURIComponent(String(caseImageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetChildren: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/children/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetMe: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/me/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetMyMedicalInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/medical-info/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the logged-in patient’s photo cases, newest first.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetMyPhotoCases: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/photo-cases/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} [fromDate] 
         * @param {string} [partnerCampaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetNextAvailableTimeslot: async (serviceId: string, fromDate?: string, partnerCampaignId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientGetNextAvailableTimeslot', 'serviceId', serviceId)
            const localVarPath = `/v1/patient/availability/next-available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (partnerCampaignId !== undefined) {
                localVarQueryParameter['partnerCampaignId'] = partnerCampaignId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} fromDate 
         * @param {string} practitionerId 
         * @param {string} [partnerCampaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetNextAvailableTimeslotWithPractitioner: async (serviceId: string, fromDate: string, practitionerId: string, partnerCampaignId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientGetNextAvailableTimeslotWithPractitioner', 'serviceId', serviceId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('v1PatientGetNextAvailableTimeslotWithPractitioner', 'fromDate', fromDate)
            // verify required parameter 'practitionerId' is not null or undefined
            assertParamExists('v1PatientGetNextAvailableTimeslotWithPractitioner', 'practitionerId', practitionerId)
            const localVarPath = `/v1/patient/availability/next-available-with-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (practitionerId !== undefined) {
                localVarQueryParameter['practitionerId'] = practitionerId;
            }

            if (partnerCampaignId !== undefined) {
                localVarQueryParameter['partnerCampaignId'] = partnerCampaignId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPartnerCampaigns: async (partnerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('v1PatientGetPartnerCampaigns', 'partnerId', partnerId)
            const localVarPath = `/v1/patient/partners/{partnerId}/campaigns`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPartnerList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/partners/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPatientCampaignMemberships: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/partners/memberships/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get patient campaign memberships that require reverification due to expiration. Currently supports Gjensidige Gouda and business-insured memberships.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPatientCampaignMembershipsRequiringReverification: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/partners/memberships/requiring-reverification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPatientDiagnosis: async (photoCaseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'photoCaseId' is not null or undefined
            assertParamExists('v1PatientGetPatientDiagnosis', 'photoCaseId', photoCaseId)
            const localVarPath = `/v1/patient/diagnoses/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (photoCaseId !== undefined) {
                localVarQueryParameter['photoCaseId'] = photoCaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPaymentCards: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/payments/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one of the logged-in patient’s photo cases by ID.
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPhotoCaseById: async (photoCaseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'photoCaseId' is not null or undefined
            assertParamExists('v1PatientGetPhotoCaseById', 'photoCaseId', photoCaseId)
            const localVarPath = `/v1/patient/photo-cases/{photoCaseId}`
                .replace(`{${"photoCaseId"}}`, encodeURIComponent(String(photoCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get skill proficiencies for a practitioner
         * @param {string} practitionerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPractitionerSkillProficiencies: async (practitionerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'practitionerId' is not null or undefined
            assertParamExists('v1PatientGetPractitionerSkillProficiencies', 'practitionerId', practitionerId)
            const localVarPath = `/v1/patient/public/practitioners/{practitionerId}/skill-proficiencies`
                .replace(`{${"practitionerId"}}`, encodeURIComponent(String(practitionerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} partnerCampaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetServicesForPartnerCampaign: async (partnerCampaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerCampaignId' is not null or undefined
            assertParamExists('v1PatientGetServicesForPartnerCampaign', 'partnerCampaignId', partnerCampaignId)
            const localVarPath = `/v1/patient/services/for-campaign/{partnerCampaignId}`
                .replace(`{${"partnerCampaignId"}}`, encodeURIComponent(String(partnerCampaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetVideoRoomAccessToken: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('v1PatientGetVideoRoomAccessToken', 'roomId', roomId)
            const localVarPath = `/v1/patient/video-rooms/{roomId}/access-token`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest} v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientInitiatePaymentForFirstAvailableVideoAppointment: async (v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest: V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest' is not null or undefined
            assertParamExists('v1PatientInitiatePaymentForFirstAvailableVideoAppointment', 'v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest', v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest)
            const localVarPath = `/v1/patient/appointments/initiate-payment-for-first-available-video-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit a draft photo case and start a Dintero payment session.
         * @param {string} photoCaseId 
         * @param {V1PatientInitiatePaymentForPhotoCaseRequest} v1PatientInitiatePaymentForPhotoCaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientInitiatePaymentForPhotoCase: async (photoCaseId: string, v1PatientInitiatePaymentForPhotoCaseRequest: V1PatientInitiatePaymentForPhotoCaseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'photoCaseId' is not null or undefined
            assertParamExists('v1PatientInitiatePaymentForPhotoCase', 'photoCaseId', photoCaseId)
            // verify required parameter 'v1PatientInitiatePaymentForPhotoCaseRequest' is not null or undefined
            assertParamExists('v1PatientInitiatePaymentForPhotoCase', 'v1PatientInitiatePaymentForPhotoCaseRequest', v1PatientInitiatePaymentForPhotoCaseRequest)
            const localVarPath = `/v1/patient/photo-cases/{photoCaseId}/initiate-payment`
                .replace(`{${"photoCaseId"}}`, encodeURIComponent(String(photoCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientInitiatePaymentForPhotoCaseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForPhysicalAppointmentRequest} v1PatientInitiatePaymentForPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientInitiatePaymentForPhysicalAppointment: async (v1PatientInitiatePaymentForPhysicalAppointmentRequest: V1PatientInitiatePaymentForPhysicalAppointmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientInitiatePaymentForPhysicalAppointmentRequest' is not null or undefined
            assertParamExists('v1PatientInitiatePaymentForPhysicalAppointment', 'v1PatientInitiatePaymentForPhysicalAppointmentRequest', v1PatientInitiatePaymentForPhysicalAppointmentRequest)
            const localVarPath = `/v1/patient/appointments/initiate-payment-for-physical-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientInitiatePaymentForPhysicalAppointmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest} v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientInitiatePaymentForPhysicalAppointmentWithPractitioner: async (v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest: V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest' is not null or undefined
            assertParamExists('v1PatientInitiatePaymentForPhysicalAppointmentWithPractitioner', 'v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest', v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest)
            const localVarPath = `/v1/patient/appointments/initiate-payment-for-physical-appointment-with-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForVideoAppointmentRequest} v1PatientInitiatePaymentForVideoAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientInitiatePaymentForVideoAppointment: async (v1PatientInitiatePaymentForVideoAppointmentRequest: V1PatientInitiatePaymentForVideoAppointmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientInitiatePaymentForVideoAppointmentRequest' is not null or undefined
            assertParamExists('v1PatientInitiatePaymentForVideoAppointment', 'v1PatientInitiatePaymentForVideoAppointmentRequest', v1PatientInitiatePaymentForVideoAppointmentRequest)
            const localVarPath = `/v1/patient/appointments/initiate-payment-for-video-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientInitiatePaymentForVideoAppointmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest} v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientInitiatePaymentForVideoAppointmentWithPractitioner: async (v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest: V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest' is not null or undefined
            assertParamExists('v1PatientInitiatePaymentForVideoAppointmentWithPractitioner', 'v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest', v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest)
            const localVarPath = `/v1/patient/appointments/initiate-payment-for-video-appointment-with-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientLegacyGetPatientCampaignMemberships: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/partners/memberships/legacy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientListCaseImages: async (photoCaseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'photoCaseId' is not null or undefined
            assertParamExists('v1PatientListCaseImages', 'photoCaseId', photoCaseId)
            const localVarPath = `/v1/patient/case-images/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (photoCaseId !== undefined) {
                localVarQueryParameter['photoCaseId'] = photoCaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicAuthCallbackGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/public/auth/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicAuthLoginGet: async (returnTo: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'returnTo' is not null or undefined
            assertParamExists('v1PatientPublicAuthLoginGet', 'returnTo', returnTo)
            const localVarPath = `/v1/patient/public/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (returnTo !== undefined) {
                localVarQueryParameter['return_to'] = returnTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicAuthLogoutGet: async (returnTo: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'returnTo' is not null or undefined
            assertParamExists('v1PatientPublicAuthLogoutGet', 'returnTo', returnTo)
            const localVarPath = `/v1/patient/public/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (returnTo !== undefined) {
                localVarQueryParameter['return_to'] = returnTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get next available timeslot for a service across clinics
         * @param {string} serviceId 
         * @param {string} [fromDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetNextAvailableTimeslotForServiceAcrossClinics: async (serviceId: string, fromDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientPublicGetNextAvailableTimeslotForServiceAcrossClinics', 'serviceId', serviceId)
            const localVarPath = `/v1/patient/public/availability/next-available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get next available timeslot for a service in a clinic
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} [fromDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetNextAvailableTimeslotForServiceInClinic: async (serviceId: string, clinicId: string, fromDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientPublicGetNextAvailableTimeslotForServiceInClinic', 'serviceId', serviceId)
            // verify required parameter 'clinicId' is not null or undefined
            assertParamExists('v1PatientPublicGetNextAvailableTimeslotForServiceInClinic', 'clinicId', clinicId)
            const localVarPath = `/v1/patient/public/availability/next-available-in-clinic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (clinicId !== undefined) {
                localVarQueryParameter['clinicId'] = clinicId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get next available timeslot for service in a clinic with a specific practitioner
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} practitionerId 
         * @param {string} [fromDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetNextAvailableTimeslotForServiceInClinicWithPractitioner: async (serviceId: string, clinicId: string, practitionerId: string, fromDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientPublicGetNextAvailableTimeslotForServiceInClinicWithPractitioner', 'serviceId', serviceId)
            // verify required parameter 'clinicId' is not null or undefined
            assertParamExists('v1PatientPublicGetNextAvailableTimeslotForServiceInClinicWithPractitioner', 'clinicId', clinicId)
            // verify required parameter 'practitionerId' is not null or undefined
            assertParamExists('v1PatientPublicGetNextAvailableTimeslotForServiceInClinicWithPractitioner', 'practitionerId', practitionerId)
            const localVarPath = `/v1/patient/public/availability/next-available-in-clinic-with-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (clinicId !== undefined) {
                localVarQueryParameter['clinicId'] = clinicId;
            }

            if (practitionerId !== undefined) {
                localVarQueryParameter['practitionerId'] = practitionerId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get next available timeslot for a service and practitioner across clinics
         * @param {string} serviceId 
         * @param {string} practitionerId 
         * @param {Array<string>} clinicIds 
         * @param {string} [fromDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics: async (serviceId: string, practitionerId: string, clinicIds: Array<string>, fromDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics', 'serviceId', serviceId)
            // verify required parameter 'practitionerId' is not null or undefined
            assertParamExists('v1PatientPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics', 'practitionerId', practitionerId)
            // verify required parameter 'clinicIds' is not null or undefined
            assertParamExists('v1PatientPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics', 'clinicIds', clinicIds)
            const localVarPath = `/v1/patient/public/availability/next-available-across-clinics-with-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (practitionerId !== undefined) {
                localVarQueryParameter['practitionerId'] = practitionerId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (clinicIds) {
                localVarQueryParameter['clinicIds'] = clinicIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get service by shortId
         * @param {string} organizationId 
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetServiceByShortId: async (organizationId: string, shortId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('v1PatientPublicGetServiceByShortId', 'organizationId', organizationId)
            // verify required parameter 'shortId' is not null or undefined
            assertParamExists('v1PatientPublicGetServiceByShortId', 'shortId', shortId)
            const localVarPath = `/v1/patient/public/services/shortid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (shortId !== undefined) {
                localVarQueryParameter['shortId'] = shortId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {V1PatientReportCallStatusRequest} v1PatientReportCallStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientReportCallStatus: async (roomId: string, v1PatientReportCallStatusRequest: V1PatientReportCallStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('v1PatientReportCallStatus', 'roomId', roomId)
            // verify required parameter 'v1PatientReportCallStatusRequest' is not null or undefined
            assertParamExists('v1PatientReportCallStatus', 'v1PatientReportCallStatusRequest', v1PatientReportCallStatusRequest)
            const localVarPath = `/v1/patient/video-rooms/call-statuses/{roomId}`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientReportCallStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientRequestCaseImageUploadUrlRequest} v1PatientRequestCaseImageUploadUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientRequestCaseImageUploadUrl: async (v1PatientRequestCaseImageUploadUrlRequest: V1PatientRequestCaseImageUploadUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientRequestCaseImageUploadUrlRequest' is not null or undefined
            assertParamExists('v1PatientRequestCaseImageUploadUrl', 'v1PatientRequestCaseImageUploadUrlRequest', v1PatientRequestCaseImageUploadUrlRequest)
            const localVarPath = `/v1/patient/case-images/upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientRequestCaseImageUploadUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit a draft photo case for review (no payment).
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientSubmitPhotoCase: async (photoCaseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'photoCaseId' is not null or undefined
            assertParamExists('v1PatientSubmitPhotoCase', 'photoCaseId', photoCaseId)
            const localVarPath = `/v1/patient/photo-cases/{photoCaseId}/submit`
                .replace(`{${"photoCaseId"}}`, encodeURIComponent(String(photoCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of all ISO3166-1 Countries with their localized name and their ISO3166-1 alpha-3 code for use in validation of travel insurance.
         * @param {V1PatientTravelInsuranceGetCountriesLangEnum} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientTravelInsuranceGetCountries: async (lang?: V1PatientTravelInsuranceGetCountriesLangEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/partners/travel-insurance/legacy/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientUpdatePersonalInfoRequest} v1PatientUpdatePersonalInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientUpdatePersonalInfo: async (v1PatientUpdatePersonalInfoRequest: V1PatientUpdatePersonalInfoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientUpdatePersonalInfoRequest' is not null or undefined
            assertParamExists('v1PatientUpdatePersonalInfo', 'v1PatientUpdatePersonalInfoRequest', v1PatientUpdatePersonalInfoRequest)
            const localVarPath = `/v1/patient/me/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientUpdatePersonalInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the editable fields of a draft photo case.
         * @param {string} photoCaseId 
         * @param {V1PatientUpdatePhotoCaseQuestionnaireRequest} v1PatientUpdatePhotoCaseQuestionnaireRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientUpdatePhotoCaseQuestionnaire: async (photoCaseId: string, v1PatientUpdatePhotoCaseQuestionnaireRequest: V1PatientUpdatePhotoCaseQuestionnaireRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'photoCaseId' is not null or undefined
            assertParamExists('v1PatientUpdatePhotoCaseQuestionnaire', 'photoCaseId', photoCaseId)
            // verify required parameter 'v1PatientUpdatePhotoCaseQuestionnaireRequest' is not null or undefined
            assertParamExists('v1PatientUpdatePhotoCaseQuestionnaire', 'v1PatientUpdatePhotoCaseQuestionnaireRequest', v1PatientUpdatePhotoCaseQuestionnaireRequest)
            const localVarPath = `/v1/patient/photo-cases/{photoCaseId}/questionnaire`
                .replace(`{${"photoCaseId"}}`, encodeURIComponent(String(photoCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientUpdatePhotoCaseQuestionnaireRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientUpsertMyMedicalInfoRequest} v1PatientUpsertMyMedicalInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientUpsertMyMedicalInfo: async (v1PatientUpsertMyMedicalInfoRequest: V1PatientUpsertMyMedicalInfoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientUpsertMyMedicalInfoRequest' is not null or undefined
            assertParamExists('v1PatientUpsertMyMedicalInfo', 'v1PatientUpsertMyMedicalInfoRequest', v1PatientUpsertMyMedicalInfoRequest)
            const localVarPath = `/v1/patient/medical-info/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientUpsertMyMedicalInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientVerifyGjensidigeInsuranceNumberRequest} v1PatientVerifyGjensidigeInsuranceNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientVerifyGjensidigeInsuranceNumber: async (v1PatientVerifyGjensidigeInsuranceNumberRequest: V1PatientVerifyGjensidigeInsuranceNumberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientVerifyGjensidigeInsuranceNumberRequest' is not null or undefined
            assertParamExists('v1PatientVerifyGjensidigeInsuranceNumber', 'v1PatientVerifyGjensidigeInsuranceNumberRequest', v1PatientVerifyGjensidigeInsuranceNumberRequest)
            const localVarPath = `/v1/patient/partners/memberships/verify-gjensidige-insurance-number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientVerifyGjensidigeInsuranceNumberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientVerifyPartnerCampaignCodeRequest} v1PatientVerifyPartnerCampaignCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientVerifyPartnerCampaignCode: async (v1PatientVerifyPartnerCampaignCodeRequest: V1PatientVerifyPartnerCampaignCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientVerifyPartnerCampaignCodeRequest' is not null or undefined
            assertParamExists('v1PatientVerifyPartnerCampaignCode', 'v1PatientVerifyPartnerCampaignCodeRequest', v1PatientVerifyPartnerCampaignCodeRequest)
            const localVarPath = `/v1/patient/partners/memberships/verify-campaign-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientVerifyPartnerCampaignCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PractitionerAppointmentsGet: async (fromDate?: string, toDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/practitioner/appointments/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PractitionerPaymentsPaymentIdGet: async (paymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('v1PractitionerPaymentsPaymentIdGet', 'paymentId', paymentId)
            const localVarPath = `/v1/practitioner/payments/{paymentId}`
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1createDeviceTokenRequest} v1createDeviceTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1createDeviceToken: async (v1createDeviceTokenRequest: V1createDeviceTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1createDeviceTokenRequest' is not null or undefined
            assertParamExists('v1createDeviceToken', 'v1createDeviceTokenRequest', v1createDeviceTokenRequest)
            const localVarPath = `/v1/patient/device-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1createDeviceTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.healthHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthLiveGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthLiveGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.healthLiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthReadyGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthReadyGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.healthReadyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if the patient has Motimate access, needs to create a user, or has expired access, or can be linked directly to the Motimate login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1CreateMotimateUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1CreateMotimateUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1CreateMotimateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch the Exorlive url for patient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1GetPatientExorliveUrl(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetPatientExorliveUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1GetPatientExorliveUrl(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1GetPatientExorliveUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if the patient has Motimate access, needs to create a user, or has expired access, or can be linked directly to the Motimate login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1GetPatientMotimateAccessStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1GetPatientMotimateAccessStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1GetPatientMotimateAccessStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1IntegrationsAuth0UsersEmployeePutRequest} v1IntegrationsAuth0UsersEmployeePutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsAuth0UsersEmployeePut(v1IntegrationsAuth0UsersEmployeePutRequest: V1IntegrationsAuth0UsersEmployeePutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsAuth0UsersEmployeePut(v1IntegrationsAuth0UsersEmployeePutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsAuth0UsersEmployeePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1IntegrationsAuth0UsersPatientPutRequest} v1IntegrationsAuth0UsersPatientPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsAuth0UsersPatientPut(v1IntegrationsAuth0UsersPatientPutRequest: V1IntegrationsAuth0UsersPatientPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsAuth0UsersPatientPut(v1IntegrationsAuth0UsersPatientPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsAuth0UsersPatientPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1IntegrationsDigicareBookingsPostRequest} v1IntegrationsDigicareBookingsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsDigicareBookingsPost(v1IntegrationsDigicareBookingsPostRequest: V1IntegrationsDigicareBookingsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsDigicareBookingsPost(v1IntegrationsDigicareBookingsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsDigicareBookingsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsDigicareClinicsGet(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsDigicareClinicsGet(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsDigicareClinicsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clinicIdWithDepartment 
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsDigicareClinicsPractitionersGet(clinicIdWithDepartment: string, serviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsDigicareClinicsPractitionersGet(clinicIdWithDepartment, serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsDigicareClinicsPractitionersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clinicIdWithDepartment 
         * @param {string} serviceId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsDigicarePractitionersGet(clinicIdWithDepartment: string, serviceId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsDigicarePractitionersGet(clinicIdWithDepartment, serviceId, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsDigicarePractitionersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clinicIdWithDepartment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsDigicareServicesGet(clinicIdWithDepartment: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsDigicareServicesGet(clinicIdWithDepartment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsDigicareServicesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clinicIdWithDepartment 
         * @param {string} serviceId 
         * @param {string} practitionerId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsDigicareTimeslotsGet(clinicIdWithDepartment: string, serviceId: string, practitionerId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsDigicareTimeslotsGet(clinicIdWithDepartment, serviceId, practitionerId, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsDigicareTimeslotsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsLinkMobilityDeliveryReportPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsLinkMobilityDeliveryReportPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsLinkMobilityDeliveryReportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsLinkMobilityIncomingMessagePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsLinkMobilityIncomingMessagePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsLinkMobilityIncomingMessagePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsPaymentsPaymentIdCallbackGet(paymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsPaymentsPaymentIdCallbackGet(paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsPaymentsPaymentIdCallbackGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} paymentId 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsPaymentsPaymentIdClientRedirectStatusGet(paymentId: string, status: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsPaymentsPaymentIdClientRedirectStatusGet(paymentId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsPaymentsPaymentIdClientRedirectStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsPaymentsPaymentIdRedirectGet(paymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsPaymentsPaymentIdRedirectGet(paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsPaymentsPaymentIdRedirectGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsTemporalAppointmentsAutocompleteInProgressAppointmentAppointmentIdPost(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsTemporalAppointmentsAutocompleteInProgressAppointmentAppointmentIdPost(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsTemporalAppointmentsAutocompleteInProgressAppointmentAppointmentIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsTemporalAppointmentsCompleteStaleBookedAppointmentsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsTemporalAppointmentsCompleteStaleBookedAppointmentsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsTemporalAppointmentsCompleteStaleBookedAppointmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsTemporalAppointmentsDeleteStaleReservedAppointmentsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsTemporalAppointmentsDeleteStaleReservedAppointmentsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsTemporalAppointmentsDeleteStaleReservedAppointmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsTemporalAppointmentsReleaseStaleClaimedAppointmentsAppointmentIdPost(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsTemporalAppointmentsReleaseStaleClaimedAppointmentsAppointmentIdPost(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsTemporalAppointmentsReleaseStaleClaimedAppointmentsAppointmentIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest} v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPost(v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest: V1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPost(v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest} v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPost(v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest: V1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPost(v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsTemporalEmployeesActivateHiredEmployeesPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsTemporalEmployeesActivateHiredEmployeesPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsTemporalEmployeesActivateHiredEmployeesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsTemporalEmployeesDeactivateTerminatedEmployeesPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsTemporalEmployeesDeactivateTerminatedEmployeesPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsTemporalEmployeesDeactivateTerminatedEmployeesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest} v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsTemporalRecallsAttemptRecallBookingPost(v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest: V1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsTemporalRecallsAttemptRecallBookingPost(v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsTemporalRecallsAttemptRecallBookingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsTwilioWakeUpCallCallbackPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsTwilioWakeUpCallCallbackPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsTwilioWakeUpCallCallbackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1IntegrationsTwilioWakeUpCallMessageGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1IntegrationsTwilioWakeUpCallMessageGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1IntegrationsTwilioWakeUpCallMessageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InternalAuthCallbackGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1InternalAuthCallbackGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1InternalAuthCallbackGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InternalAuthTestProtectedGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1InternalAuthTestProtectedGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1InternalAuthTestProtectedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InternalAuthTestPublicGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1InternalAuthTestPublicGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1InternalAuthTestPublicGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InternalLoginGet(returnTo: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1InternalLoginGet(returnTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1InternalLoginGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InternalRefreshSessionGet(returnTo: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1InternalRefreshSessionGet(returnTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1InternalRefreshSessionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Book first available video appointment
         * @param {V1PatientBookFirstAvailableVideoAppointmentRequest} v1PatientBookFirstAvailableVideoAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientBookFirstAvailableVideoAppointment(v1PatientBookFirstAvailableVideoAppointmentRequest: V1PatientBookFirstAvailableVideoAppointmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientBookVideoAppointmentWithPractitioner200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientBookFirstAvailableVideoAppointment(v1PatientBookFirstAvailableVideoAppointmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientBookFirstAvailableVideoAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Book physical appointment for logged-in patient
         * @param {V1PatientBookPhysicalAppointmentRequest} v1PatientBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientBookPhysicalAppointment(v1PatientBookPhysicalAppointmentRequest: V1PatientBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicBookPhysicalAppointment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientBookPhysicalAppointment(v1PatientBookPhysicalAppointmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientBookPhysicalAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Book physical appointment for logged-in patient
         * @param {V1PatientBookPhysicalAppointmentForLoggedInPatientRequest} v1PatientBookPhysicalAppointmentForLoggedInPatientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientBookPhysicalAppointmentForLoggedInPatient(v1PatientBookPhysicalAppointmentForLoggedInPatientRequest: V1PatientBookPhysicalAppointmentForLoggedInPatientRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicBookPhysicalAppointment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientBookPhysicalAppointmentForLoggedInPatient(v1PatientBookPhysicalAppointmentForLoggedInPatientRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientBookPhysicalAppointmentForLoggedInPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Book a video appointment
         * @param {V1PatientBookVideoAppointmentRequest} v1PatientBookVideoAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientBookVideoAppointment(v1PatientBookVideoAppointmentRequest: V1PatientBookVideoAppointmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientBookVideoAppointmentWithPractitioner200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientBookVideoAppointment(v1PatientBookVideoAppointmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientBookVideoAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Book a video appointment
         * @param {V1PatientBookVideoAppointmentWithPractitionerRequest} v1PatientBookVideoAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientBookVideoAppointmentWithPractitioner(v1PatientBookVideoAppointmentWithPractitionerRequest: V1PatientBookVideoAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientBookVideoAppointmentWithPractitioner200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientBookVideoAppointmentWithPractitioner(v1PatientBookVideoAppointmentWithPractitionerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientBookVideoAppointmentWithPractitioner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel a photo case that has not yet been claimed.
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientCancelPhotoCase(photoCaseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientCancelPhotoCase200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientCancelPhotoCase(photoCaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientCancelPhotoCase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} caseImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientConfirmCaseImageUpload(caseImageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientConfirmCaseImageUpload200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientConfirmCaseImageUpload(caseImageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientConfirmCaseImageUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientCreateCampaignMembershipWithCodeRequest} v1PatientCreateCampaignMembershipWithCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientCreateCampaignMembershipWithCode(v1PatientCreateCampaignMembershipWithCodeRequest: V1PatientCreateCampaignMembershipWithCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientCreateCampaignMembershipWithCode(v1PatientCreateCampaignMembershipWithCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientCreateCampaignMembershipWithCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientCreateCampaignMembershipWithEmailRequest} v1PatientCreateCampaignMembershipWithEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientCreateCampaignMembershipWithEmail(v1PatientCreateCampaignMembershipWithEmailRequest: V1PatientCreateCampaignMembershipWithEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientCreateCampaignMembershipWithEmail(v1PatientCreateCampaignMembershipWithEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientCreateCampaignMembershipWithEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientCreateCampaignMembershipWithInsuranceNumberRequest} v1PatientCreateCampaignMembershipWithInsuranceNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientCreateCampaignMembershipWithInsuranceNumber(v1PatientCreateCampaignMembershipWithInsuranceNumberRequest: V1PatientCreateCampaignMembershipWithInsuranceNumberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientCreateCampaignMembershipWithInsuranceNumber(v1PatientCreateCampaignMembershipWithInsuranceNumberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientCreateCampaignMembershipWithInsuranceNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientCreateChildRequest} v1PatientCreateChildRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientCreateChild(v1PatientCreateChildRequest: V1PatientCreateChildRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientGetChildren200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientCreateChild(v1PatientCreateChildRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientCreateChild']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check that the ssn is connected to a valid nordea life insurance, then create the campaign membership
         * @param {V1PatientCreateNordeaCampaignMembershipRequest} v1PatientCreateNordeaCampaignMembershipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientCreateNordeaCampaignMembership(v1PatientCreateNordeaCampaignMembershipRequest: V1PatientCreateNordeaCampaignMembershipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientCreateNordeaCampaignMembership(v1PatientCreateNordeaCampaignMembershipRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientCreateNordeaCampaignMembership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new draft photo case for the logged-in patient.
         * @param {V1PatientCreatePhotoCaseRequest} v1PatientCreatePhotoCaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientCreatePhotoCase(v1PatientCreatePhotoCaseRequest: V1PatientCreatePhotoCaseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientCreatePhotoCase201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientCreatePhotoCase(v1PatientCreatePhotoCaseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientCreatePhotoCase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} paymentCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientDeactivatePaymentCard(paymentCardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicBookPhysicalAppointment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientDeactivatePaymentCard(paymentCardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientDeactivatePaymentCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} caseImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientDeleteCaseImage(caseImageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientDeleteCaseImage(caseImageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientDeleteCaseImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} childId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientDeleteChild(childId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientDeleteChild(childId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientDeleteChild']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientDeletePartnerMembership(campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientDeletePartnerMembership(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientDeletePartnerMembership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a single appointment by ID for logged-in patient with payment details.
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetAppointmentById(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientGetAppointmentById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetAppointmentById(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetAppointmentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a single appointment by video room ID for logged-in patient.
         * @param {string} videoRoomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetAppointmentByVideoRoomId(videoRoomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientGetAppointmentByVideoRoomId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetAppointmentByVideoRoomId(videoRoomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetAppointmentByVideoRoomId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get current and upcoming appointments for logged-in patient.
         * @param {Array<V1PatientGetAppointmentsAdditionalStatusesEnum>} additionalStatuses 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetAppointments(additionalStatuses: Array<V1PatientGetAppointmentsAdditionalStatusesEnum>, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientGetAppointments200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetAppointments(additionalStatuses, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetAppointments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} caseImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetCaseImageViewUrl(caseImageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientGetCaseImageViewUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetCaseImageViewUrl(caseImageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetCaseImageViewUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetChildren(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientGetChildren200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetChildren(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetChildren']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetMe(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientGetMe200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetMe(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetMyMedicalInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientGetMyMedicalInfo200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetMyMedicalInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetMyMedicalInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the logged-in patient’s photo cases, newest first.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetMyPhotoCases(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientGetMyPhotoCases200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetMyPhotoCases(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetMyPhotoCases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} [fromDate] 
         * @param {string} [partnerCampaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetNextAvailableTimeslot(serviceId: string, fromDate?: string, partnerCampaignId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetNextAvailableTimeslot(serviceId, fromDate, partnerCampaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetNextAvailableTimeslot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} fromDate 
         * @param {string} practitionerId 
         * @param {string} [partnerCampaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetNextAvailableTimeslotWithPractitioner(serviceId: string, fromDate: string, practitionerId: string, partnerCampaignId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetNextAvailableTimeslotWithPractitioner(serviceId, fromDate, practitionerId, partnerCampaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetNextAvailableTimeslotWithPractitioner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetPartnerCampaigns(partnerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientGetPartnerCampaigns200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetPartnerCampaigns(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetPartnerCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetPartnerList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientGetPartnerList200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetPartnerList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetPartnerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetPatientCampaignMemberships(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientGetPatientCampaignMemberships200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetPatientCampaignMemberships(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetPatientCampaignMemberships']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get patient campaign memberships that require reverification due to expiration. Currently supports Gjensidige Gouda and business-insured memberships.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetPatientCampaignMembershipsRequiringReverification(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientGetPatientCampaignMembershipsRequiringReverification200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetPatientCampaignMembershipsRequiringReverification(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetPatientCampaignMembershipsRequiringReverification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetPatientDiagnosis(photoCaseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientGetPatientDiagnosis200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetPatientDiagnosis(photoCaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetPatientDiagnosis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetPaymentCards(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientGetPaymentCards200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetPaymentCards(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetPaymentCards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get one of the logged-in patient’s photo cases by ID.
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetPhotoCaseById(photoCaseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientGetPhotoCaseById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetPhotoCaseById(photoCaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetPhotoCaseById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get skill proficiencies for a practitioner
         * @param {string} practitionerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetPractitionerSkillProficiencies(practitionerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientGetPractitionerSkillProficiencies200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetPractitionerSkillProficiencies(practitionerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetPractitionerSkillProficiencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} partnerCampaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetServicesForPartnerCampaign(partnerCampaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetServices200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetServicesForPartnerCampaign(partnerCampaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetServicesForPartnerCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetVideoRoomAccessToken(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientGetVideoRoomAccessToken200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetVideoRoomAccessToken(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientGetVideoRoomAccessToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest} v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientInitiatePaymentForFirstAvailableVideoAppointment(v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest: V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientInitiatePaymentForVideoAppointmentWithPractitioner200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientInitiatePaymentForFirstAvailableVideoAppointment(v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientInitiatePaymentForFirstAvailableVideoAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit a draft photo case and start a Dintero payment session.
         * @param {string} photoCaseId 
         * @param {V1PatientInitiatePaymentForPhotoCaseRequest} v1PatientInitiatePaymentForPhotoCaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientInitiatePaymentForPhotoCase(photoCaseId: string, v1PatientInitiatePaymentForPhotoCaseRequest: V1PatientInitiatePaymentForPhotoCaseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientInitiatePaymentForPhotoCase200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientInitiatePaymentForPhotoCase(photoCaseId, v1PatientInitiatePaymentForPhotoCaseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientInitiatePaymentForPhotoCase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForPhysicalAppointmentRequest} v1PatientInitiatePaymentForPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientInitiatePaymentForPhysicalAppointment(v1PatientInitiatePaymentForPhysicalAppointmentRequest: V1PatientInitiatePaymentForPhysicalAppointmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientInitiatePaymentForVideoAppointmentWithPractitioner200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientInitiatePaymentForPhysicalAppointment(v1PatientInitiatePaymentForPhysicalAppointmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientInitiatePaymentForPhysicalAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest} v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientInitiatePaymentForPhysicalAppointmentWithPractitioner(v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest: V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientInitiatePaymentForVideoAppointmentWithPractitioner200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientInitiatePaymentForPhysicalAppointmentWithPractitioner(v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientInitiatePaymentForPhysicalAppointmentWithPractitioner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForVideoAppointmentRequest} v1PatientInitiatePaymentForVideoAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientInitiatePaymentForVideoAppointment(v1PatientInitiatePaymentForVideoAppointmentRequest: V1PatientInitiatePaymentForVideoAppointmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientInitiatePaymentForVideoAppointmentWithPractitioner200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientInitiatePaymentForVideoAppointment(v1PatientInitiatePaymentForVideoAppointmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientInitiatePaymentForVideoAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest} v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientInitiatePaymentForVideoAppointmentWithPractitioner(v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest: V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientInitiatePaymentForVideoAppointmentWithPractitioner200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientInitiatePaymentForVideoAppointmentWithPractitioner(v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientInitiatePaymentForVideoAppointmentWithPractitioner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientLegacyGetPatientCampaignMemberships(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientLegacyGetPatientCampaignMemberships200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientLegacyGetPatientCampaignMemberships(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientLegacyGetPatientCampaignMemberships']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientListCaseImages(photoCaseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientListCaseImages200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientListCaseImages(photoCaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientListCaseImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicAuthCallbackGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicAuthCallbackGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientPublicAuthCallbackGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicAuthLoginGet(returnTo: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicAuthLoginGet(returnTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientPublicAuthLoginGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicAuthLogoutGet(returnTo: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicAuthLogoutGet(returnTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientPublicAuthLogoutGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get next available timeslot for a service across clinics
         * @param {string} serviceId 
         * @param {string} [fromDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetNextAvailableTimeslotForServiceAcrossClinics(serviceId: string, fromDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetNextAvailableTimeslotForServiceAcrossClinics(serviceId, fromDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientPublicGetNextAvailableTimeslotForServiceAcrossClinics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get next available timeslot for a service in a clinic
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} [fromDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetNextAvailableTimeslotForServiceInClinic(serviceId: string, clinicId: string, fromDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetNextAvailableTimeslotForServiceInClinic(serviceId, clinicId, fromDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientPublicGetNextAvailableTimeslotForServiceInClinic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get next available timeslot for service in a clinic with a specific practitioner
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} practitionerId 
         * @param {string} [fromDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetNextAvailableTimeslotForServiceInClinicWithPractitioner(serviceId: string, clinicId: string, practitionerId: string, fromDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetNextAvailableTimeslotForServiceInClinicWithPractitioner(serviceId, clinicId, practitionerId, fromDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientPublicGetNextAvailableTimeslotForServiceInClinicWithPractitioner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get next available timeslot for a service and practitioner across clinics
         * @param {string} serviceId 
         * @param {string} practitionerId 
         * @param {Array<string>} clinicIds 
         * @param {string} [fromDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics(serviceId: string, practitionerId: string, clinicIds: Array<string>, fromDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics(serviceId, practitionerId, clinicIds, fromDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get service by shortId
         * @param {string} organizationId 
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetServiceByShortId(organizationId: string, shortId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicGetServiceByShortId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetServiceByShortId(organizationId, shortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientPublicGetServiceByShortId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {V1PatientReportCallStatusRequest} v1PatientReportCallStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientReportCallStatus(roomId: string, v1PatientReportCallStatusRequest: V1PatientReportCallStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientReportCallStatus(roomId, v1PatientReportCallStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientReportCallStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientRequestCaseImageUploadUrlRequest} v1PatientRequestCaseImageUploadUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientRequestCaseImageUploadUrl(v1PatientRequestCaseImageUploadUrlRequest: V1PatientRequestCaseImageUploadUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientRequestCaseImageUploadUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientRequestCaseImageUploadUrl(v1PatientRequestCaseImageUploadUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientRequestCaseImageUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit a draft photo case for review (no payment).
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientSubmitPhotoCase(photoCaseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientSubmitPhotoCase200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientSubmitPhotoCase(photoCaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientSubmitPhotoCase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of all ISO3166-1 Countries with their localized name and their ISO3166-1 alpha-3 code for use in validation of travel insurance.
         * @param {V1PatientTravelInsuranceGetCountriesLangEnum} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientTravelInsuranceGetCountries(lang?: V1PatientTravelInsuranceGetCountriesLangEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientTravelInsuranceGetCountries200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientTravelInsuranceGetCountries(lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientTravelInsuranceGetCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientUpdatePersonalInfoRequest} v1PatientUpdatePersonalInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientUpdatePersonalInfo(v1PatientUpdatePersonalInfoRequest: V1PatientUpdatePersonalInfoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientUpdatePersonalInfo200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientUpdatePersonalInfo(v1PatientUpdatePersonalInfoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientUpdatePersonalInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the editable fields of a draft photo case.
         * @param {string} photoCaseId 
         * @param {V1PatientUpdatePhotoCaseQuestionnaireRequest} v1PatientUpdatePhotoCaseQuestionnaireRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientUpdatePhotoCaseQuestionnaire(photoCaseId: string, v1PatientUpdatePhotoCaseQuestionnaireRequest: V1PatientUpdatePhotoCaseQuestionnaireRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientUpdatePhotoCaseQuestionnaire200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientUpdatePhotoCaseQuestionnaire(photoCaseId, v1PatientUpdatePhotoCaseQuestionnaireRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientUpdatePhotoCaseQuestionnaire']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientUpsertMyMedicalInfoRequest} v1PatientUpsertMyMedicalInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientUpsertMyMedicalInfo(v1PatientUpsertMyMedicalInfoRequest: V1PatientUpsertMyMedicalInfoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientUpsertMyMedicalInfo200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientUpsertMyMedicalInfo(v1PatientUpsertMyMedicalInfoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientUpsertMyMedicalInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientVerifyGjensidigeInsuranceNumberRequest} v1PatientVerifyGjensidigeInsuranceNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientVerifyGjensidigeInsuranceNumber(v1PatientVerifyGjensidigeInsuranceNumberRequest: V1PatientVerifyGjensidigeInsuranceNumberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientVerifyGjensidigeInsuranceNumber(v1PatientVerifyGjensidigeInsuranceNumberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientVerifyGjensidigeInsuranceNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientVerifyPartnerCampaignCodeRequest} v1PatientVerifyPartnerCampaignCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientVerifyPartnerCampaignCode(v1PatientVerifyPartnerCampaignCodeRequest: V1PatientVerifyPartnerCampaignCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientVerifyPartnerCampaignCode(v1PatientVerifyPartnerCampaignCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PatientVerifyPartnerCampaignCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PractitionerAppointmentsGet(fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PractitionerAppointmentsGet(fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PractitionerAppointmentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PractitionerPaymentsPaymentIdGet(paymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PractitionerPaymentsPaymentIdGet(paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1PractitionerPaymentsPaymentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1createDeviceTokenRequest} v1createDeviceTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1createDeviceToken(v1createDeviceTokenRequest: V1createDeviceTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1createDeviceToken200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1createDeviceToken(v1createDeviceTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.v1createDeviceToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.healthHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthLiveGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.healthLiveGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthReadyGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.healthReadyGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if the patient has Motimate access, needs to create a user, or has expired access, or can be linked directly to the Motimate login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CreateMotimateUser(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.v1CreateMotimateUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the Exorlive url for patient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPatientExorliveUrl(options?: RawAxiosRequestConfig): AxiosPromise<V1GetPatientExorliveUrl200Response> {
            return localVarFp.v1GetPatientExorliveUrl(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if the patient has Motimate access, needs to create a user, or has expired access, or can be linked directly to the Motimate login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPatientMotimateAccessStatus(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.v1GetPatientMotimateAccessStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1IntegrationsAuth0UsersEmployeePutRequest} v1IntegrationsAuth0UsersEmployeePutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsAuth0UsersEmployeePut(v1IntegrationsAuth0UsersEmployeePutRequest: V1IntegrationsAuth0UsersEmployeePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsAuth0UsersEmployeePut(v1IntegrationsAuth0UsersEmployeePutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1IntegrationsAuth0UsersPatientPutRequest} v1IntegrationsAuth0UsersPatientPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsAuth0UsersPatientPut(v1IntegrationsAuth0UsersPatientPutRequest: V1IntegrationsAuth0UsersPatientPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsAuth0UsersPatientPut(v1IntegrationsAuth0UsersPatientPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1IntegrationsDigicareBookingsPostRequest} v1IntegrationsDigicareBookingsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsDigicareBookingsPost(v1IntegrationsDigicareBookingsPostRequest: V1IntegrationsDigicareBookingsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsDigicareBookingsPost(v1IntegrationsDigicareBookingsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsDigicareClinicsGet(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsDigicareClinicsGet(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clinicIdWithDepartment 
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsDigicareClinicsPractitionersGet(clinicIdWithDepartment: string, serviceId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsDigicareClinicsPractitionersGet(clinicIdWithDepartment, serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clinicIdWithDepartment 
         * @param {string} serviceId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsDigicarePractitionersGet(clinicIdWithDepartment: string, serviceId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsDigicarePractitionersGet(clinicIdWithDepartment, serviceId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clinicIdWithDepartment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsDigicareServicesGet(clinicIdWithDepartment: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsDigicareServicesGet(clinicIdWithDepartment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clinicIdWithDepartment 
         * @param {string} serviceId 
         * @param {string} practitionerId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsDigicareTimeslotsGet(clinicIdWithDepartment: string, serviceId: string, practitionerId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsDigicareTimeslotsGet(clinicIdWithDepartment, serviceId, practitionerId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsLinkMobilityDeliveryReportPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsLinkMobilityDeliveryReportPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsLinkMobilityIncomingMessagePost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsLinkMobilityIncomingMessagePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsPaymentsPaymentIdCallbackGet(paymentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsPaymentsPaymentIdCallbackGet(paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} paymentId 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsPaymentsPaymentIdClientRedirectStatusGet(paymentId: string, status: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsPaymentsPaymentIdClientRedirectStatusGet(paymentId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsPaymentsPaymentIdRedirectGet(paymentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsPaymentsPaymentIdRedirectGet(paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalAppointmentsAutocompleteInProgressAppointmentAppointmentIdPost(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsTemporalAppointmentsAutocompleteInProgressAppointmentAppointmentIdPost(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalAppointmentsCompleteStaleBookedAppointmentsPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsTemporalAppointmentsCompleteStaleBookedAppointmentsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalAppointmentsDeleteStaleReservedAppointmentsPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsTemporalAppointmentsDeleteStaleReservedAppointmentsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalAppointmentsReleaseStaleClaimedAppointmentsAppointmentIdPost(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsTemporalAppointmentsReleaseStaleClaimedAppointmentsAppointmentIdPost(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest} v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPost(v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest: V1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPost(v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest} v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPost(v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest: V1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPost(v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalEmployeesActivateHiredEmployeesPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsTemporalEmployeesActivateHiredEmployeesPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalEmployeesDeactivateTerminatedEmployeesPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsTemporalEmployeesDeactivateTerminatedEmployeesPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest} v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTemporalRecallsAttemptRecallBookingPost(v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest: V1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsTemporalRecallsAttemptRecallBookingPost(v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTwilioWakeUpCallCallbackPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsTwilioWakeUpCallCallbackPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1IntegrationsTwilioWakeUpCallMessageGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1IntegrationsTwilioWakeUpCallMessageGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InternalAuthCallbackGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1InternalAuthCallbackGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InternalAuthTestProtectedGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1InternalAuthTestProtectedGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InternalAuthTestPublicGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1InternalAuthTestPublicGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InternalLoginGet(returnTo: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1InternalLoginGet(returnTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InternalRefreshSessionGet(returnTo: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1InternalRefreshSessionGet(returnTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Book first available video appointment
         * @param {V1PatientBookFirstAvailableVideoAppointmentRequest} v1PatientBookFirstAvailableVideoAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientBookFirstAvailableVideoAppointment(v1PatientBookFirstAvailableVideoAppointmentRequest: V1PatientBookFirstAvailableVideoAppointmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientBookVideoAppointmentWithPractitioner200Response> {
            return localVarFp.v1PatientBookFirstAvailableVideoAppointment(v1PatientBookFirstAvailableVideoAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Book physical appointment for logged-in patient
         * @param {V1PatientBookPhysicalAppointmentRequest} v1PatientBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientBookPhysicalAppointment(v1PatientBookPhysicalAppointmentRequest: V1PatientBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicBookPhysicalAppointment200Response> {
            return localVarFp.v1PatientBookPhysicalAppointment(v1PatientBookPhysicalAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Book physical appointment for logged-in patient
         * @param {V1PatientBookPhysicalAppointmentForLoggedInPatientRequest} v1PatientBookPhysicalAppointmentForLoggedInPatientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientBookPhysicalAppointmentForLoggedInPatient(v1PatientBookPhysicalAppointmentForLoggedInPatientRequest: V1PatientBookPhysicalAppointmentForLoggedInPatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicBookPhysicalAppointment200Response> {
            return localVarFp.v1PatientBookPhysicalAppointmentForLoggedInPatient(v1PatientBookPhysicalAppointmentForLoggedInPatientRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Book a video appointment
         * @param {V1PatientBookVideoAppointmentRequest} v1PatientBookVideoAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientBookVideoAppointment(v1PatientBookVideoAppointmentRequest: V1PatientBookVideoAppointmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientBookVideoAppointmentWithPractitioner200Response> {
            return localVarFp.v1PatientBookVideoAppointment(v1PatientBookVideoAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Book a video appointment
         * @param {V1PatientBookVideoAppointmentWithPractitionerRequest} v1PatientBookVideoAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientBookVideoAppointmentWithPractitioner(v1PatientBookVideoAppointmentWithPractitionerRequest: V1PatientBookVideoAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientBookVideoAppointmentWithPractitioner200Response> {
            return localVarFp.v1PatientBookVideoAppointmentWithPractitioner(v1PatientBookVideoAppointmentWithPractitionerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel a photo case that has not yet been claimed.
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCancelPhotoCase(photoCaseId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientCancelPhotoCase200Response> {
            return localVarFp.v1PatientCancelPhotoCase(photoCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} caseImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientConfirmCaseImageUpload(caseImageId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientConfirmCaseImageUpload200Response> {
            return localVarFp.v1PatientConfirmCaseImageUpload(caseImageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientCreateCampaignMembershipWithCodeRequest} v1PatientCreateCampaignMembershipWithCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCreateCampaignMembershipWithCode(v1PatientCreateCampaignMembershipWithCodeRequest: V1PatientCreateCampaignMembershipWithCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.v1PatientCreateCampaignMembershipWithCode(v1PatientCreateCampaignMembershipWithCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientCreateCampaignMembershipWithEmailRequest} v1PatientCreateCampaignMembershipWithEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCreateCampaignMembershipWithEmail(v1PatientCreateCampaignMembershipWithEmailRequest: V1PatientCreateCampaignMembershipWithEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.v1PatientCreateCampaignMembershipWithEmail(v1PatientCreateCampaignMembershipWithEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientCreateCampaignMembershipWithInsuranceNumberRequest} v1PatientCreateCampaignMembershipWithInsuranceNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCreateCampaignMembershipWithInsuranceNumber(v1PatientCreateCampaignMembershipWithInsuranceNumberRequest: V1PatientCreateCampaignMembershipWithInsuranceNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.v1PatientCreateCampaignMembershipWithInsuranceNumber(v1PatientCreateCampaignMembershipWithInsuranceNumberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientCreateChildRequest} v1PatientCreateChildRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCreateChild(v1PatientCreateChildRequest: V1PatientCreateChildRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientGetChildren200ResponseInner> {
            return localVarFp.v1PatientCreateChild(v1PatientCreateChildRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check that the ssn is connected to a valid nordea life insurance, then create the campaign membership
         * @param {V1PatientCreateNordeaCampaignMembershipRequest} v1PatientCreateNordeaCampaignMembershipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCreateNordeaCampaignMembership(v1PatientCreateNordeaCampaignMembershipRequest: V1PatientCreateNordeaCampaignMembershipRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.v1PatientCreateNordeaCampaignMembership(v1PatientCreateNordeaCampaignMembershipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new draft photo case for the logged-in patient.
         * @param {V1PatientCreatePhotoCaseRequest} v1PatientCreatePhotoCaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCreatePhotoCase(v1PatientCreatePhotoCaseRequest: V1PatientCreatePhotoCaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientCreatePhotoCase201Response> {
            return localVarFp.v1PatientCreatePhotoCase(v1PatientCreatePhotoCaseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} paymentCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientDeactivatePaymentCard(paymentCardId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicBookPhysicalAppointment200Response> {
            return localVarFp.v1PatientDeactivatePaymentCard(paymentCardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} caseImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientDeleteCaseImage(caseImageId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.v1PatientDeleteCaseImage(caseImageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} childId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientDeleteChild(childId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.v1PatientDeleteChild(childId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientDeletePartnerMembership(campaignId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.v1PatientDeletePartnerMembership(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single appointment by ID for logged-in patient with payment details.
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetAppointmentById(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientGetAppointmentById200Response> {
            return localVarFp.v1PatientGetAppointmentById(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single appointment by video room ID for logged-in patient.
         * @param {string} videoRoomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetAppointmentByVideoRoomId(videoRoomId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientGetAppointmentByVideoRoomId200Response> {
            return localVarFp.v1PatientGetAppointmentByVideoRoomId(videoRoomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current and upcoming appointments for logged-in patient.
         * @param {Array<V1PatientGetAppointmentsAdditionalStatusesEnum>} additionalStatuses 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetAppointments(additionalStatuses: Array<V1PatientGetAppointmentsAdditionalStatusesEnum>, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientGetAppointments200ResponseInner>> {
            return localVarFp.v1PatientGetAppointments(additionalStatuses, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} caseImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetCaseImageViewUrl(caseImageId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientGetCaseImageViewUrl200Response> {
            return localVarFp.v1PatientGetCaseImageViewUrl(caseImageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetChildren(options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientGetChildren200ResponseInner>> {
            return localVarFp.v1PatientGetChildren(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetMe(options?: RawAxiosRequestConfig): AxiosPromise<V1PatientGetMe200Response> {
            return localVarFp.v1PatientGetMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetMyMedicalInfo(options?: RawAxiosRequestConfig): AxiosPromise<V1PatientGetMyMedicalInfo200Response> {
            return localVarFp.v1PatientGetMyMedicalInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the logged-in patient’s photo cases, newest first.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetMyPhotoCases(options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientGetMyPhotoCases200ResponseInner>> {
            return localVarFp.v1PatientGetMyPhotoCases(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} [fromDate] 
         * @param {string} [partnerCampaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetNextAvailableTimeslot(serviceId: string, fromDate?: string, partnerCampaignId?: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response> {
            return localVarFp.v1PatientGetNextAvailableTimeslot(serviceId, fromDate, partnerCampaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} fromDate 
         * @param {string} practitionerId 
         * @param {string} [partnerCampaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetNextAvailableTimeslotWithPractitioner(serviceId: string, fromDate: string, practitionerId: string, partnerCampaignId?: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response> {
            return localVarFp.v1PatientGetNextAvailableTimeslotWithPractitioner(serviceId, fromDate, practitionerId, partnerCampaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPartnerCampaigns(partnerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientGetPartnerCampaigns200ResponseInner>> {
            return localVarFp.v1PatientGetPartnerCampaigns(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPartnerList(options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientGetPartnerList200ResponseInner>> {
            return localVarFp.v1PatientGetPartnerList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPatientCampaignMemberships(options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientGetPatientCampaignMemberships200ResponseInner>> {
            return localVarFp.v1PatientGetPatientCampaignMemberships(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get patient campaign memberships that require reverification due to expiration. Currently supports Gjensidige Gouda and business-insured memberships.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPatientCampaignMembershipsRequiringReverification(options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientGetPatientCampaignMembershipsRequiringReverification200ResponseInner>> {
            return localVarFp.v1PatientGetPatientCampaignMembershipsRequiringReverification(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPatientDiagnosis(photoCaseId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientGetPatientDiagnosis200Response> {
            return localVarFp.v1PatientGetPatientDiagnosis(photoCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPaymentCards(options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientGetPaymentCards200ResponseInner>> {
            return localVarFp.v1PatientGetPaymentCards(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one of the logged-in patient’s photo cases by ID.
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPhotoCaseById(photoCaseId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientGetPhotoCaseById200Response> {
            return localVarFp.v1PatientGetPhotoCaseById(photoCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get skill proficiencies for a practitioner
         * @param {string} practitionerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPractitionerSkillProficiencies(practitionerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientGetPractitionerSkillProficiencies200ResponseInner>> {
            return localVarFp.v1PatientGetPractitionerSkillProficiencies(practitionerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} partnerCampaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetServicesForPartnerCampaign(partnerCampaignId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetServices200ResponseInner>> {
            return localVarFp.v1PatientGetServicesForPartnerCampaign(partnerCampaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetVideoRoomAccessToken(roomId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientGetVideoRoomAccessToken200Response> {
            return localVarFp.v1PatientGetVideoRoomAccessToken(roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest} v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientInitiatePaymentForFirstAvailableVideoAppointment(v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest: V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientInitiatePaymentForVideoAppointmentWithPractitioner200Response> {
            return localVarFp.v1PatientInitiatePaymentForFirstAvailableVideoAppointment(v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit a draft photo case and start a Dintero payment session.
         * @param {string} photoCaseId 
         * @param {V1PatientInitiatePaymentForPhotoCaseRequest} v1PatientInitiatePaymentForPhotoCaseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientInitiatePaymentForPhotoCase(photoCaseId: string, v1PatientInitiatePaymentForPhotoCaseRequest: V1PatientInitiatePaymentForPhotoCaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientInitiatePaymentForPhotoCase200Response> {
            return localVarFp.v1PatientInitiatePaymentForPhotoCase(photoCaseId, v1PatientInitiatePaymentForPhotoCaseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForPhysicalAppointmentRequest} v1PatientInitiatePaymentForPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientInitiatePaymentForPhysicalAppointment(v1PatientInitiatePaymentForPhysicalAppointmentRequest: V1PatientInitiatePaymentForPhysicalAppointmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientInitiatePaymentForVideoAppointmentWithPractitioner200Response> {
            return localVarFp.v1PatientInitiatePaymentForPhysicalAppointment(v1PatientInitiatePaymentForPhysicalAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest} v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientInitiatePaymentForPhysicalAppointmentWithPractitioner(v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest: V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientInitiatePaymentForVideoAppointmentWithPractitioner200Response> {
            return localVarFp.v1PatientInitiatePaymentForPhysicalAppointmentWithPractitioner(v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForVideoAppointmentRequest} v1PatientInitiatePaymentForVideoAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientInitiatePaymentForVideoAppointment(v1PatientInitiatePaymentForVideoAppointmentRequest: V1PatientInitiatePaymentForVideoAppointmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientInitiatePaymentForVideoAppointmentWithPractitioner200Response> {
            return localVarFp.v1PatientInitiatePaymentForVideoAppointment(v1PatientInitiatePaymentForVideoAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest} v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientInitiatePaymentForVideoAppointmentWithPractitioner(v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest: V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientInitiatePaymentForVideoAppointmentWithPractitioner200Response> {
            return localVarFp.v1PatientInitiatePaymentForVideoAppointmentWithPractitioner(v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientLegacyGetPatientCampaignMemberships(options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientLegacyGetPatientCampaignMemberships200ResponseInner>> {
            return localVarFp.v1PatientLegacyGetPatientCampaignMemberships(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientListCaseImages(photoCaseId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientListCaseImages200ResponseInner>> {
            return localVarFp.v1PatientListCaseImages(photoCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicAuthCallbackGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1PatientPublicAuthCallbackGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicAuthLoginGet(returnTo: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1PatientPublicAuthLoginGet(returnTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicAuthLogoutGet(returnTo: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1PatientPublicAuthLogoutGet(returnTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get next available timeslot for a service across clinics
         * @param {string} serviceId 
         * @param {string} [fromDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetNextAvailableTimeslotForServiceAcrossClinics(serviceId: string, fromDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response> {
            return localVarFp.v1PatientPublicGetNextAvailableTimeslotForServiceAcrossClinics(serviceId, fromDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get next available timeslot for a service in a clinic
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} [fromDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetNextAvailableTimeslotForServiceInClinic(serviceId: string, clinicId: string, fromDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response> {
            return localVarFp.v1PatientPublicGetNextAvailableTimeslotForServiceInClinic(serviceId, clinicId, fromDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get next available timeslot for service in a clinic with a specific practitioner
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} practitionerId 
         * @param {string} [fromDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetNextAvailableTimeslotForServiceInClinicWithPractitioner(serviceId: string, clinicId: string, practitionerId: string, fromDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response> {
            return localVarFp.v1PatientPublicGetNextAvailableTimeslotForServiceInClinicWithPractitioner(serviceId, clinicId, practitionerId, fromDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get next available timeslot for a service and practitioner across clinics
         * @param {string} serviceId 
         * @param {string} practitionerId 
         * @param {Array<string>} clinicIds 
         * @param {string} [fromDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics(serviceId: string, practitionerId: string, clinicIds: Array<string>, fromDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response> {
            return localVarFp.v1PatientPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics(serviceId, practitionerId, clinicIds, fromDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get service by shortId
         * @param {string} organizationId 
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetServiceByShortId(organizationId: string, shortId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicGetServiceByShortId200Response> {
            return localVarFp.v1PatientPublicGetServiceByShortId(organizationId, shortId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} roomId 
         * @param {V1PatientReportCallStatusRequest} v1PatientReportCallStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientReportCallStatus(roomId: string, v1PatientReportCallStatusRequest: V1PatientReportCallStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.v1PatientReportCallStatus(roomId, v1PatientReportCallStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientRequestCaseImageUploadUrlRequest} v1PatientRequestCaseImageUploadUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientRequestCaseImageUploadUrl(v1PatientRequestCaseImageUploadUrlRequest: V1PatientRequestCaseImageUploadUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientRequestCaseImageUploadUrl200Response> {
            return localVarFp.v1PatientRequestCaseImageUploadUrl(v1PatientRequestCaseImageUploadUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit a draft photo case for review (no payment).
         * @param {string} photoCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientSubmitPhotoCase(photoCaseId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientSubmitPhotoCase200Response> {
            return localVarFp.v1PatientSubmitPhotoCase(photoCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of all ISO3166-1 Countries with their localized name and their ISO3166-1 alpha-3 code for use in validation of travel insurance.
         * @param {V1PatientTravelInsuranceGetCountriesLangEnum} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientTravelInsuranceGetCountries(lang?: V1PatientTravelInsuranceGetCountriesLangEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientTravelInsuranceGetCountries200ResponseInner>> {
            return localVarFp.v1PatientTravelInsuranceGetCountries(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientUpdatePersonalInfoRequest} v1PatientUpdatePersonalInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientUpdatePersonalInfo(v1PatientUpdatePersonalInfoRequest: V1PatientUpdatePersonalInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientUpdatePersonalInfo200Response> {
            return localVarFp.v1PatientUpdatePersonalInfo(v1PatientUpdatePersonalInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the editable fields of a draft photo case.
         * @param {string} photoCaseId 
         * @param {V1PatientUpdatePhotoCaseQuestionnaireRequest} v1PatientUpdatePhotoCaseQuestionnaireRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientUpdatePhotoCaseQuestionnaire(photoCaseId: string, v1PatientUpdatePhotoCaseQuestionnaireRequest: V1PatientUpdatePhotoCaseQuestionnaireRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientUpdatePhotoCaseQuestionnaire200Response> {
            return localVarFp.v1PatientUpdatePhotoCaseQuestionnaire(photoCaseId, v1PatientUpdatePhotoCaseQuestionnaireRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientUpsertMyMedicalInfoRequest} v1PatientUpsertMyMedicalInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientUpsertMyMedicalInfo(v1PatientUpsertMyMedicalInfoRequest: V1PatientUpsertMyMedicalInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientUpsertMyMedicalInfo200Response> {
            return localVarFp.v1PatientUpsertMyMedicalInfo(v1PatientUpsertMyMedicalInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientVerifyGjensidigeInsuranceNumberRequest} v1PatientVerifyGjensidigeInsuranceNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientVerifyGjensidigeInsuranceNumber(v1PatientVerifyGjensidigeInsuranceNumberRequest: V1PatientVerifyGjensidigeInsuranceNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.v1PatientVerifyGjensidigeInsuranceNumber(v1PatientVerifyGjensidigeInsuranceNumberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientVerifyPartnerCampaignCodeRequest} v1PatientVerifyPartnerCampaignCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientVerifyPartnerCampaignCode(v1PatientVerifyPartnerCampaignCodeRequest: V1PatientVerifyPartnerCampaignCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.v1PatientVerifyPartnerCampaignCode(v1PatientVerifyPartnerCampaignCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PractitionerAppointmentsGet(fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1PractitionerAppointmentsGet(fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PractitionerPaymentsPaymentIdGet(paymentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1PractitionerPaymentsPaymentIdGet(paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1createDeviceTokenRequest} v1createDeviceTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1createDeviceToken(v1createDeviceTokenRequest: V1createDeviceTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1createDeviceToken200Response> {
            return localVarFp.v1createDeviceToken(v1createDeviceTokenRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public healthHealthGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).healthHealthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public healthLiveGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).healthLiveGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public healthReadyGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).healthReadyGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if the patient has Motimate access, needs to create a user, or has expired access, or can be linked directly to the Motimate login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1CreateMotimateUser(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1CreateMotimateUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the Exorlive url for patient
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1GetPatientExorliveUrl(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1GetPatientExorliveUrl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if the patient has Motimate access, needs to create a user, or has expired access, or can be linked directly to the Motimate login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1GetPatientMotimateAccessStatus(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1GetPatientMotimateAccessStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1IntegrationsAuth0UsersEmployeePutRequest} v1IntegrationsAuth0UsersEmployeePutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsAuth0UsersEmployeePut(v1IntegrationsAuth0UsersEmployeePutRequest: V1IntegrationsAuth0UsersEmployeePutRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsAuth0UsersEmployeePut(v1IntegrationsAuth0UsersEmployeePutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1IntegrationsAuth0UsersPatientPutRequest} v1IntegrationsAuth0UsersPatientPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsAuth0UsersPatientPut(v1IntegrationsAuth0UsersPatientPutRequest: V1IntegrationsAuth0UsersPatientPutRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsAuth0UsersPatientPut(v1IntegrationsAuth0UsersPatientPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1IntegrationsDigicareBookingsPostRequest} v1IntegrationsDigicareBookingsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsDigicareBookingsPost(v1IntegrationsDigicareBookingsPostRequest: V1IntegrationsDigicareBookingsPostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsDigicareBookingsPost(v1IntegrationsDigicareBookingsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsDigicareClinicsGet(organizationId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsDigicareClinicsGet(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clinicIdWithDepartment 
     * @param {string} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsDigicareClinicsPractitionersGet(clinicIdWithDepartment: string, serviceId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsDigicareClinicsPractitionersGet(clinicIdWithDepartment, serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clinicIdWithDepartment 
     * @param {string} serviceId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsDigicarePractitionersGet(clinicIdWithDepartment: string, serviceId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsDigicarePractitionersGet(clinicIdWithDepartment, serviceId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clinicIdWithDepartment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsDigicareServicesGet(clinicIdWithDepartment: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsDigicareServicesGet(clinicIdWithDepartment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clinicIdWithDepartment 
     * @param {string} serviceId 
     * @param {string} practitionerId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsDigicareTimeslotsGet(clinicIdWithDepartment: string, serviceId: string, practitionerId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsDigicareTimeslotsGet(clinicIdWithDepartment, serviceId, practitionerId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsLinkMobilityDeliveryReportPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsLinkMobilityDeliveryReportPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsLinkMobilityIncomingMessagePost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsLinkMobilityIncomingMessagePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} paymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsPaymentsPaymentIdCallbackGet(paymentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsPaymentsPaymentIdCallbackGet(paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} paymentId 
     * @param {string} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsPaymentsPaymentIdClientRedirectStatusGet(paymentId: string, status: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsPaymentsPaymentIdClientRedirectStatusGet(paymentId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} paymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsPaymentsPaymentIdRedirectGet(paymentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsPaymentsPaymentIdRedirectGet(paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsTemporalAppointmentsAutocompleteInProgressAppointmentAppointmentIdPost(appointmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsTemporalAppointmentsAutocompleteInProgressAppointmentAppointmentIdPost(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsTemporalAppointmentsCompleteStaleBookedAppointmentsPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsTemporalAppointmentsCompleteStaleBookedAppointmentsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsTemporalAppointmentsDeleteStaleReservedAppointmentsPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsTemporalAppointmentsDeleteStaleReservedAppointmentsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsTemporalAppointmentsReleaseStaleClaimedAppointmentsAppointmentIdPost(appointmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsTemporalAppointmentsReleaseStaleClaimedAppointmentsAppointmentIdPost(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest} v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPost(v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest: V1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPost(v1IntegrationsTemporalAppointmentsRescheduleAppointmentRemindersPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest} v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPost(v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest: V1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPost(v1IntegrationsTemporalAppointmentsScheduleConfirmationMessagesForSeededAppointmentsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsTemporalEmployeesActivateHiredEmployeesPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsTemporalEmployeesActivateHiredEmployeesPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsTemporalEmployeesDeactivateTerminatedEmployeesPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsTemporalEmployeesDeactivateTerminatedEmployeesPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest} v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsTemporalRecallsAttemptRecallBookingPost(v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest: V1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsTemporalRecallsAttemptRecallBookingPost(v1IntegrationsTemporalRecallsAttemptRecallBookingPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsTwilioWakeUpCallCallbackPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsTwilioWakeUpCallCallbackPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1IntegrationsTwilioWakeUpCallMessageGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1IntegrationsTwilioWakeUpCallMessageGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1InternalAuthCallbackGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1InternalAuthCallbackGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1InternalAuthTestProtectedGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1InternalAuthTestProtectedGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1InternalAuthTestPublicGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1InternalAuthTestPublicGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} returnTo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1InternalLoginGet(returnTo: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1InternalLoginGet(returnTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} returnTo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1InternalRefreshSessionGet(returnTo: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1InternalRefreshSessionGet(returnTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Book first available video appointment
     * @param {V1PatientBookFirstAvailableVideoAppointmentRequest} v1PatientBookFirstAvailableVideoAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientBookFirstAvailableVideoAppointment(v1PatientBookFirstAvailableVideoAppointmentRequest: V1PatientBookFirstAvailableVideoAppointmentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientBookFirstAvailableVideoAppointment(v1PatientBookFirstAvailableVideoAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Book physical appointment for logged-in patient
     * @param {V1PatientBookPhysicalAppointmentRequest} v1PatientBookPhysicalAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientBookPhysicalAppointment(v1PatientBookPhysicalAppointmentRequest: V1PatientBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientBookPhysicalAppointment(v1PatientBookPhysicalAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Book physical appointment for logged-in patient
     * @param {V1PatientBookPhysicalAppointmentForLoggedInPatientRequest} v1PatientBookPhysicalAppointmentForLoggedInPatientRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientBookPhysicalAppointmentForLoggedInPatient(v1PatientBookPhysicalAppointmentForLoggedInPatientRequest: V1PatientBookPhysicalAppointmentForLoggedInPatientRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientBookPhysicalAppointmentForLoggedInPatient(v1PatientBookPhysicalAppointmentForLoggedInPatientRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Book a video appointment
     * @param {V1PatientBookVideoAppointmentRequest} v1PatientBookVideoAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientBookVideoAppointment(v1PatientBookVideoAppointmentRequest: V1PatientBookVideoAppointmentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientBookVideoAppointment(v1PatientBookVideoAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Book a video appointment
     * @param {V1PatientBookVideoAppointmentWithPractitionerRequest} v1PatientBookVideoAppointmentWithPractitionerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientBookVideoAppointmentWithPractitioner(v1PatientBookVideoAppointmentWithPractitionerRequest: V1PatientBookVideoAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientBookVideoAppointmentWithPractitioner(v1PatientBookVideoAppointmentWithPractitionerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel a photo case that has not yet been claimed.
     * @param {string} photoCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientCancelPhotoCase(photoCaseId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientCancelPhotoCase(photoCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} caseImageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientConfirmCaseImageUpload(caseImageId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientConfirmCaseImageUpload(caseImageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientCreateCampaignMembershipWithCodeRequest} v1PatientCreateCampaignMembershipWithCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientCreateCampaignMembershipWithCode(v1PatientCreateCampaignMembershipWithCodeRequest: V1PatientCreateCampaignMembershipWithCodeRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientCreateCampaignMembershipWithCode(v1PatientCreateCampaignMembershipWithCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientCreateCampaignMembershipWithEmailRequest} v1PatientCreateCampaignMembershipWithEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientCreateCampaignMembershipWithEmail(v1PatientCreateCampaignMembershipWithEmailRequest: V1PatientCreateCampaignMembershipWithEmailRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientCreateCampaignMembershipWithEmail(v1PatientCreateCampaignMembershipWithEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientCreateCampaignMembershipWithInsuranceNumberRequest} v1PatientCreateCampaignMembershipWithInsuranceNumberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientCreateCampaignMembershipWithInsuranceNumber(v1PatientCreateCampaignMembershipWithInsuranceNumberRequest: V1PatientCreateCampaignMembershipWithInsuranceNumberRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientCreateCampaignMembershipWithInsuranceNumber(v1PatientCreateCampaignMembershipWithInsuranceNumberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientCreateChildRequest} v1PatientCreateChildRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientCreateChild(v1PatientCreateChildRequest: V1PatientCreateChildRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientCreateChild(v1PatientCreateChildRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check that the ssn is connected to a valid nordea life insurance, then create the campaign membership
     * @param {V1PatientCreateNordeaCampaignMembershipRequest} v1PatientCreateNordeaCampaignMembershipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientCreateNordeaCampaignMembership(v1PatientCreateNordeaCampaignMembershipRequest: V1PatientCreateNordeaCampaignMembershipRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientCreateNordeaCampaignMembership(v1PatientCreateNordeaCampaignMembershipRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new draft photo case for the logged-in patient.
     * @param {V1PatientCreatePhotoCaseRequest} v1PatientCreatePhotoCaseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientCreatePhotoCase(v1PatientCreatePhotoCaseRequest: V1PatientCreatePhotoCaseRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientCreatePhotoCase(v1PatientCreatePhotoCaseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} paymentCardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientDeactivatePaymentCard(paymentCardId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientDeactivatePaymentCard(paymentCardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} caseImageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientDeleteCaseImage(caseImageId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientDeleteCaseImage(caseImageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} childId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientDeleteChild(childId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientDeleteChild(childId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientDeletePartnerMembership(campaignId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientDeletePartnerMembership(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single appointment by ID for logged-in patient with payment details.
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetAppointmentById(appointmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetAppointmentById(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single appointment by video room ID for logged-in patient.
     * @param {string} videoRoomId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetAppointmentByVideoRoomId(videoRoomId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetAppointmentByVideoRoomId(videoRoomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current and upcoming appointments for logged-in patient.
     * @param {Array<V1PatientGetAppointmentsAdditionalStatusesEnum>} additionalStatuses 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetAppointments(additionalStatuses: Array<V1PatientGetAppointmentsAdditionalStatusesEnum>, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetAppointments(additionalStatuses, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} caseImageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetCaseImageViewUrl(caseImageId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetCaseImageViewUrl(caseImageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetChildren(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetChildren(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetMe(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetMyMedicalInfo(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetMyMedicalInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the logged-in patient’s photo cases, newest first.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetMyPhotoCases(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetMyPhotoCases(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serviceId 
     * @param {string} [fromDate] 
     * @param {string} [partnerCampaignId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetNextAvailableTimeslot(serviceId: string, fromDate?: string, partnerCampaignId?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetNextAvailableTimeslot(serviceId, fromDate, partnerCampaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serviceId 
     * @param {string} fromDate 
     * @param {string} practitionerId 
     * @param {string} [partnerCampaignId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetNextAvailableTimeslotWithPractitioner(serviceId: string, fromDate: string, practitionerId: string, partnerCampaignId?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetNextAvailableTimeslotWithPractitioner(serviceId, fromDate, practitionerId, partnerCampaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} partnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetPartnerCampaigns(partnerId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetPartnerCampaigns(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetPartnerList(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetPartnerList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetPatientCampaignMemberships(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetPatientCampaignMemberships(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get patient campaign memberships that require reverification due to expiration. Currently supports Gjensidige Gouda and business-insured memberships.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetPatientCampaignMembershipsRequiringReverification(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetPatientCampaignMembershipsRequiringReverification(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} photoCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetPatientDiagnosis(photoCaseId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetPatientDiagnosis(photoCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetPaymentCards(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetPaymentCards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one of the logged-in patient’s photo cases by ID.
     * @param {string} photoCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetPhotoCaseById(photoCaseId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetPhotoCaseById(photoCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get skill proficiencies for a practitioner
     * @param {string} practitionerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetPractitionerSkillProficiencies(practitionerId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetPractitionerSkillProficiencies(practitionerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} partnerCampaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetServicesForPartnerCampaign(partnerCampaignId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetServicesForPartnerCampaign(partnerCampaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} roomId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetVideoRoomAccessToken(roomId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientGetVideoRoomAccessToken(roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest} v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientInitiatePaymentForFirstAvailableVideoAppointment(v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest: V1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientInitiatePaymentForFirstAvailableVideoAppointment(v1PatientInitiatePaymentForFirstAvailableVideoAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit a draft photo case and start a Dintero payment session.
     * @param {string} photoCaseId 
     * @param {V1PatientInitiatePaymentForPhotoCaseRequest} v1PatientInitiatePaymentForPhotoCaseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientInitiatePaymentForPhotoCase(photoCaseId: string, v1PatientInitiatePaymentForPhotoCaseRequest: V1PatientInitiatePaymentForPhotoCaseRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientInitiatePaymentForPhotoCase(photoCaseId, v1PatientInitiatePaymentForPhotoCaseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientInitiatePaymentForPhysicalAppointmentRequest} v1PatientInitiatePaymentForPhysicalAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientInitiatePaymentForPhysicalAppointment(v1PatientInitiatePaymentForPhysicalAppointmentRequest: V1PatientInitiatePaymentForPhysicalAppointmentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientInitiatePaymentForPhysicalAppointment(v1PatientInitiatePaymentForPhysicalAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest} v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientInitiatePaymentForPhysicalAppointmentWithPractitioner(v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest: V1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientInitiatePaymentForPhysicalAppointmentWithPractitioner(v1PatientInitiatePaymentForPhysicalAppointmentWithPractitionerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientInitiatePaymentForVideoAppointmentRequest} v1PatientInitiatePaymentForVideoAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientInitiatePaymentForVideoAppointment(v1PatientInitiatePaymentForVideoAppointmentRequest: V1PatientInitiatePaymentForVideoAppointmentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientInitiatePaymentForVideoAppointment(v1PatientInitiatePaymentForVideoAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest} v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientInitiatePaymentForVideoAppointmentWithPractitioner(v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest: V1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientInitiatePaymentForVideoAppointmentWithPractitioner(v1PatientInitiatePaymentForVideoAppointmentWithPractitionerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientLegacyGetPatientCampaignMemberships(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientLegacyGetPatientCampaignMemberships(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} photoCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientListCaseImages(photoCaseId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientListCaseImages(photoCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicAuthCallbackGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientPublicAuthCallbackGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} returnTo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicAuthLoginGet(returnTo: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientPublicAuthLoginGet(returnTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} returnTo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicAuthLogoutGet(returnTo: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientPublicAuthLogoutGet(returnTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get next available timeslot for a service across clinics
     * @param {string} serviceId 
     * @param {string} [fromDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetNextAvailableTimeslotForServiceAcrossClinics(serviceId: string, fromDate?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientPublicGetNextAvailableTimeslotForServiceAcrossClinics(serviceId, fromDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get next available timeslot for a service in a clinic
     * @param {string} serviceId 
     * @param {string} clinicId 
     * @param {string} [fromDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetNextAvailableTimeslotForServiceInClinic(serviceId: string, clinicId: string, fromDate?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientPublicGetNextAvailableTimeslotForServiceInClinic(serviceId, clinicId, fromDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get next available timeslot for service in a clinic with a specific practitioner
     * @param {string} serviceId 
     * @param {string} clinicId 
     * @param {string} practitionerId 
     * @param {string} [fromDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetNextAvailableTimeslotForServiceInClinicWithPractitioner(serviceId: string, clinicId: string, practitionerId: string, fromDate?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientPublicGetNextAvailableTimeslotForServiceInClinicWithPractitioner(serviceId, clinicId, practitionerId, fromDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get next available timeslot for a service and practitioner across clinics
     * @param {string} serviceId 
     * @param {string} practitionerId 
     * @param {Array<string>} clinicIds 
     * @param {string} [fromDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics(serviceId: string, practitionerId: string, clinicIds: Array<string>, fromDate?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics(serviceId, practitionerId, clinicIds, fromDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get service by shortId
     * @param {string} organizationId 
     * @param {string} shortId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetServiceByShortId(organizationId: string, shortId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientPublicGetServiceByShortId(organizationId, shortId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} roomId 
     * @param {V1PatientReportCallStatusRequest} v1PatientReportCallStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientReportCallStatus(roomId: string, v1PatientReportCallStatusRequest: V1PatientReportCallStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientReportCallStatus(roomId, v1PatientReportCallStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientRequestCaseImageUploadUrlRequest} v1PatientRequestCaseImageUploadUrlRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientRequestCaseImageUploadUrl(v1PatientRequestCaseImageUploadUrlRequest: V1PatientRequestCaseImageUploadUrlRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientRequestCaseImageUploadUrl(v1PatientRequestCaseImageUploadUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit a draft photo case for review (no payment).
     * @param {string} photoCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientSubmitPhotoCase(photoCaseId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientSubmitPhotoCase(photoCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of all ISO3166-1 Countries with their localized name and their ISO3166-1 alpha-3 code for use in validation of travel insurance.
     * @param {V1PatientTravelInsuranceGetCountriesLangEnum} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientTravelInsuranceGetCountries(lang?: V1PatientTravelInsuranceGetCountriesLangEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientTravelInsuranceGetCountries(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientUpdatePersonalInfoRequest} v1PatientUpdatePersonalInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientUpdatePersonalInfo(v1PatientUpdatePersonalInfoRequest: V1PatientUpdatePersonalInfoRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientUpdatePersonalInfo(v1PatientUpdatePersonalInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the editable fields of a draft photo case.
     * @param {string} photoCaseId 
     * @param {V1PatientUpdatePhotoCaseQuestionnaireRequest} v1PatientUpdatePhotoCaseQuestionnaireRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientUpdatePhotoCaseQuestionnaire(photoCaseId: string, v1PatientUpdatePhotoCaseQuestionnaireRequest: V1PatientUpdatePhotoCaseQuestionnaireRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientUpdatePhotoCaseQuestionnaire(photoCaseId, v1PatientUpdatePhotoCaseQuestionnaireRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientUpsertMyMedicalInfoRequest} v1PatientUpsertMyMedicalInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientUpsertMyMedicalInfo(v1PatientUpsertMyMedicalInfoRequest: V1PatientUpsertMyMedicalInfoRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientUpsertMyMedicalInfo(v1PatientUpsertMyMedicalInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientVerifyGjensidigeInsuranceNumberRequest} v1PatientVerifyGjensidigeInsuranceNumberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientVerifyGjensidigeInsuranceNumber(v1PatientVerifyGjensidigeInsuranceNumberRequest: V1PatientVerifyGjensidigeInsuranceNumberRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientVerifyGjensidigeInsuranceNumber(v1PatientVerifyGjensidigeInsuranceNumberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientVerifyPartnerCampaignCodeRequest} v1PatientVerifyPartnerCampaignCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientVerifyPartnerCampaignCode(v1PatientVerifyPartnerCampaignCodeRequest: V1PatientVerifyPartnerCampaignCodeRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PatientVerifyPartnerCampaignCode(v1PatientVerifyPartnerCampaignCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PractitionerAppointmentsGet(fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PractitionerAppointmentsGet(fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} paymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PractitionerPaymentsPaymentIdGet(paymentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1PractitionerPaymentsPaymentIdGet(paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1createDeviceTokenRequest} v1createDeviceTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1createDeviceToken(v1createDeviceTokenRequest: V1createDeviceTokenRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v1createDeviceToken(v1createDeviceTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

export const V1PatientGetAppointmentsAdditionalStatusesEnum = {
    Reserved: 'reserved',
    Booked: 'booked',
    Claimed: 'claimed',
    InProgress: 'in_progress',
    Cancelled: 'cancelled',
    NoShow: 'no_show',
    Completed: 'completed',
    Failed: 'failed',
    Deleted: 'deleted'
} as const;
export type V1PatientGetAppointmentsAdditionalStatusesEnum = typeof V1PatientGetAppointmentsAdditionalStatusesEnum[keyof typeof V1PatientGetAppointmentsAdditionalStatusesEnum];
export const V1PatientTravelInsuranceGetCountriesLangEnum = {
    Nb: 'nb',
    En: 'en'
} as const;
export type V1PatientTravelInsuranceGetCountriesLangEnum = typeof V1PatientTravelInsuranceGetCountriesLangEnum[keyof typeof V1PatientTravelInsuranceGetCountriesLangEnum];


/**
 * LegacyApi - axios parameter creator
 */
export const LegacyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Book physical appointment for logged-in patient
         * @param {V1PatientLegacyBookPhysicalAppointmentRequest} v1PatientLegacyBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientLegacyBookPhysicalAppointment: async (v1PatientLegacyBookPhysicalAppointmentRequest: V1PatientLegacyBookPhysicalAppointmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientLegacyBookPhysicalAppointmentRequest' is not null or undefined
            assertParamExists('v1PatientLegacyBookPhysicalAppointment', 'v1PatientLegacyBookPhysicalAppointmentRequest', v1PatientLegacyBookPhysicalAppointmentRequest)
            const localVarPath = `/v1/patient/appointments/legacy/book-physical-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientLegacyBookPhysicalAppointmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Book physical appointment for logged-in patient
         * @param {V1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest} v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientLegacyBookPhysicalAppointmentWithPractitioner: async (v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest: V1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest' is not null or undefined
            assertParamExists('v1PatientLegacyBookPhysicalAppointmentWithPractitioner', 'v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest', v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest)
            const localVarPath = `/v1/patient/appointments/legacy/book-physical-appointment-with-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Backwards compatible version of get current and upcoming appointments for logged-in patient.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientLegacyGetAppointments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/appointments/legacy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Legacy version of get next available timeslot for a service across clinics
         * @param {string} serviceId 
         * @param {string} [fromDate] 
         * @param {string} [partnerCampaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientLegacyPublicGetNextAvailableTimeslotForServiceAcrossClinics: async (serviceId: string, fromDate?: string, partnerCampaignId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientLegacyPublicGetNextAvailableTimeslotForServiceAcrossClinics', 'serviceId', serviceId)
            const localVarPath = `/v1/patient/public/availability/legacy/next-available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (partnerCampaignId !== undefined) {
                localVarQueryParameter['partnerCampaignId'] = partnerCampaignId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Legacy version of get next available timeslot for a service across clinics with a specified practitioner
         * @param {string} serviceId 
         * @param {string} practitionerId 
         * @param {string} [fromDate] 
         * @param {string} [partnerCampaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientLegacyPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics: async (serviceId: string, practitionerId: string, fromDate?: string, partnerCampaignId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientLegacyPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics', 'serviceId', serviceId)
            // verify required parameter 'practitionerId' is not null or undefined
            assertParamExists('v1PatientLegacyPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics', 'practitionerId', practitionerId)
            const localVarPath = `/v1/patient/public/availability/legacy/next-available-with-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (practitionerId !== undefined) {
                localVarQueryParameter['practitionerId'] = practitionerId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (partnerCampaignId !== undefined) {
                localVarQueryParameter['partnerCampaignId'] = partnerCampaignId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Book physical appointment for guest user
         * @param {V1PatientPublicLegacyBookPhysicalAppointmentRequest} v1PatientPublicLegacyBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicLegacyBookPhysicalAppointment: async (v1PatientPublicLegacyBookPhysicalAppointmentRequest: V1PatientPublicLegacyBookPhysicalAppointmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientPublicLegacyBookPhysicalAppointmentRequest' is not null or undefined
            assertParamExists('v1PatientPublicLegacyBookPhysicalAppointment', 'v1PatientPublicLegacyBookPhysicalAppointmentRequest', v1PatientPublicLegacyBookPhysicalAppointmentRequest)
            const localVarPath = `/v1/patient/public/appointments/legacy/book-physical-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientPublicLegacyBookPhysicalAppointmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Legacy book physical appointment with a specific practitioner for guest user
         * @param {V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest} v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner: async (v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest: V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest' is not null or undefined
            assertParamExists('v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner', 'v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest', v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest)
            const localVarPath = `/v1/patient/public/appointments/legacy/book-physical-appointment-with-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if a partner campaign and service requires providing a country.
         * @param {string} partnerCampaignId 
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientTravelInsuranceLegacyNeedsCountry: async (partnerCampaignId: string, serviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerCampaignId' is not null or undefined
            assertParamExists('v1PatientTravelInsuranceLegacyNeedsCountry', 'partnerCampaignId', partnerCampaignId)
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientTravelInsuranceLegacyNeedsCountry', 'serviceId', serviceId)
            const localVarPath = `/v1/patient/partners/travel-insurance/legacy/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (partnerCampaignId !== undefined) {
                localVarQueryParameter['partnerCampaignId'] = partnerCampaignId;
            }

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if the selected country is valid for a partner campaign and service. Will return an error message in the specified locale (default to Norwegian Bokmål if not specified).
         * @param {V1PatientTravelInsuranceLegacyValidateCountryRequest} v1PatientTravelInsuranceLegacyValidateCountryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientTravelInsuranceLegacyValidateCountry: async (v1PatientTravelInsuranceLegacyValidateCountryRequest: V1PatientTravelInsuranceLegacyValidateCountryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientTravelInsuranceLegacyValidateCountryRequest' is not null or undefined
            assertParamExists('v1PatientTravelInsuranceLegacyValidateCountry', 'v1PatientTravelInsuranceLegacyValidateCountryRequest', v1PatientTravelInsuranceLegacyValidateCountryRequest)
            const localVarPath = `/v1/patient/partners/travel-insurance/legacy/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientTravelInsuranceLegacyValidateCountryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegacyApi - functional programming interface
 */
export const LegacyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegacyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Book physical appointment for logged-in patient
         * @param {V1PatientLegacyBookPhysicalAppointmentRequest} v1PatientLegacyBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientLegacyBookPhysicalAppointment(v1PatientLegacyBookPhysicalAppointmentRequest: V1PatientLegacyBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicLegacyBookPhysicalAppointment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientLegacyBookPhysicalAppointment(v1PatientLegacyBookPhysicalAppointmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyApi.v1PatientLegacyBookPhysicalAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Book physical appointment for logged-in patient
         * @param {V1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest} v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientLegacyBookPhysicalAppointmentWithPractitioner(v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest: V1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicLegacyBookPhysicalAppointment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientLegacyBookPhysicalAppointmentWithPractitioner(v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyApi.v1PatientLegacyBookPhysicalAppointmentWithPractitioner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Backwards compatible version of get current and upcoming appointments for logged-in patient.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientLegacyGetAppointments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientLegacyGetAppointments200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientLegacyGetAppointments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyApi.v1PatientLegacyGetAppointments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Legacy version of get next available timeslot for a service across clinics
         * @param {string} serviceId 
         * @param {string} [fromDate] 
         * @param {string} [partnerCampaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientLegacyPublicGetNextAvailableTimeslotForServiceAcrossClinics(serviceId: string, fromDate?: string, partnerCampaignId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientLegacyPublicGetNextAvailableTimeslotForServiceAcrossClinics(serviceId, fromDate, partnerCampaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyApi.v1PatientLegacyPublicGetNextAvailableTimeslotForServiceAcrossClinics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Legacy version of get next available timeslot for a service across clinics with a specified practitioner
         * @param {string} serviceId 
         * @param {string} practitionerId 
         * @param {string} [fromDate] 
         * @param {string} [partnerCampaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientLegacyPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics(serviceId: string, practitionerId: string, fromDate?: string, partnerCampaignId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientLegacyPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics(serviceId, practitionerId, fromDate, partnerCampaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyApi.v1PatientLegacyPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Book physical appointment for guest user
         * @param {V1PatientPublicLegacyBookPhysicalAppointmentRequest} v1PatientPublicLegacyBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicLegacyBookPhysicalAppointment(v1PatientPublicLegacyBookPhysicalAppointmentRequest: V1PatientPublicLegacyBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicLegacyBookPhysicalAppointment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicLegacyBookPhysicalAppointment(v1PatientPublicLegacyBookPhysicalAppointmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyApi.v1PatientPublicLegacyBookPhysicalAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Legacy book physical appointment with a specific practitioner for guest user
         * @param {V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest} v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner(v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest: V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicLegacyBookPhysicalAppointment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner(v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyApi.v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if a partner campaign and service requires providing a country.
         * @param {string} partnerCampaignId 
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientTravelInsuranceLegacyNeedsCountry(partnerCampaignId: string, serviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientTravelInsuranceLegacyNeedsCountry(partnerCampaignId, serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyApi.v1PatientTravelInsuranceLegacyNeedsCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if the selected country is valid for a partner campaign and service. Will return an error message in the specified locale (default to Norwegian Bokmål if not specified).
         * @param {V1PatientTravelInsuranceLegacyValidateCountryRequest} v1PatientTravelInsuranceLegacyValidateCountryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientTravelInsuranceLegacyValidateCountry(v1PatientTravelInsuranceLegacyValidateCountryRequest: V1PatientTravelInsuranceLegacyValidateCountryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientTravelInsuranceLegacyValidateCountry200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientTravelInsuranceLegacyValidateCountry(v1PatientTravelInsuranceLegacyValidateCountryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyApi.v1PatientTravelInsuranceLegacyValidateCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegacyApi - factory interface
 */
export const LegacyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegacyApiFp(configuration)
    return {
        /**
         * 
         * @summary Book physical appointment for logged-in patient
         * @param {V1PatientLegacyBookPhysicalAppointmentRequest} v1PatientLegacyBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientLegacyBookPhysicalAppointment(v1PatientLegacyBookPhysicalAppointmentRequest: V1PatientLegacyBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicLegacyBookPhysicalAppointment200Response> {
            return localVarFp.v1PatientLegacyBookPhysicalAppointment(v1PatientLegacyBookPhysicalAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Book physical appointment for logged-in patient
         * @param {V1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest} v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientLegacyBookPhysicalAppointmentWithPractitioner(v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest: V1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicLegacyBookPhysicalAppointment200Response> {
            return localVarFp.v1PatientLegacyBookPhysicalAppointmentWithPractitioner(v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Backwards compatible version of get current and upcoming appointments for logged-in patient.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientLegacyGetAppointments(options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientLegacyGetAppointments200ResponseInner>> {
            return localVarFp.v1PatientLegacyGetAppointments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Legacy version of get next available timeslot for a service across clinics
         * @param {string} serviceId 
         * @param {string} [fromDate] 
         * @param {string} [partnerCampaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientLegacyPublicGetNextAvailableTimeslotForServiceAcrossClinics(serviceId: string, fromDate?: string, partnerCampaignId?: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response> {
            return localVarFp.v1PatientLegacyPublicGetNextAvailableTimeslotForServiceAcrossClinics(serviceId, fromDate, partnerCampaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Legacy version of get next available timeslot for a service across clinics with a specified practitioner
         * @param {string} serviceId 
         * @param {string} practitionerId 
         * @param {string} [fromDate] 
         * @param {string} [partnerCampaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientLegacyPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics(serviceId: string, practitionerId: string, fromDate?: string, partnerCampaignId?: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicGetNextAvailableTimeslotForServiceInClinic200Response> {
            return localVarFp.v1PatientLegacyPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics(serviceId, practitionerId, fromDate, partnerCampaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Book physical appointment for guest user
         * @param {V1PatientPublicLegacyBookPhysicalAppointmentRequest} v1PatientPublicLegacyBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicLegacyBookPhysicalAppointment(v1PatientPublicLegacyBookPhysicalAppointmentRequest: V1PatientPublicLegacyBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicLegacyBookPhysicalAppointment200Response> {
            return localVarFp.v1PatientPublicLegacyBookPhysicalAppointment(v1PatientPublicLegacyBookPhysicalAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Legacy book physical appointment with a specific practitioner for guest user
         * @param {V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest} v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner(v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest: V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicLegacyBookPhysicalAppointment200Response> {
            return localVarFp.v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner(v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if a partner campaign and service requires providing a country.
         * @param {string} partnerCampaignId 
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientTravelInsuranceLegacyNeedsCountry(partnerCampaignId: string, serviceId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.v1PatientTravelInsuranceLegacyNeedsCountry(partnerCampaignId, serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if the selected country is valid for a partner campaign and service. Will return an error message in the specified locale (default to Norwegian Bokmål if not specified).
         * @param {V1PatientTravelInsuranceLegacyValidateCountryRequest} v1PatientTravelInsuranceLegacyValidateCountryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientTravelInsuranceLegacyValidateCountry(v1PatientTravelInsuranceLegacyValidateCountryRequest: V1PatientTravelInsuranceLegacyValidateCountryRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientTravelInsuranceLegacyValidateCountry200Response> {
            return localVarFp.v1PatientTravelInsuranceLegacyValidateCountry(v1PatientTravelInsuranceLegacyValidateCountryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegacyApi - object-oriented interface
 */
export class LegacyApi extends BaseAPI {
    /**
     * 
     * @summary Book physical appointment for logged-in patient
     * @param {V1PatientLegacyBookPhysicalAppointmentRequest} v1PatientLegacyBookPhysicalAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientLegacyBookPhysicalAppointment(v1PatientLegacyBookPhysicalAppointmentRequest: V1PatientLegacyBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig) {
        return LegacyApiFp(this.configuration).v1PatientLegacyBookPhysicalAppointment(v1PatientLegacyBookPhysicalAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Book physical appointment for logged-in patient
     * @param {V1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest} v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientLegacyBookPhysicalAppointmentWithPractitioner(v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest: V1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig) {
        return LegacyApiFp(this.configuration).v1PatientLegacyBookPhysicalAppointmentWithPractitioner(v1PatientLegacyBookPhysicalAppointmentWithPractitionerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Backwards compatible version of get current and upcoming appointments for logged-in patient.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientLegacyGetAppointments(options?: RawAxiosRequestConfig) {
        return LegacyApiFp(this.configuration).v1PatientLegacyGetAppointments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Legacy version of get next available timeslot for a service across clinics
     * @param {string} serviceId 
     * @param {string} [fromDate] 
     * @param {string} [partnerCampaignId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientLegacyPublicGetNextAvailableTimeslotForServiceAcrossClinics(serviceId: string, fromDate?: string, partnerCampaignId?: string, options?: RawAxiosRequestConfig) {
        return LegacyApiFp(this.configuration).v1PatientLegacyPublicGetNextAvailableTimeslotForServiceAcrossClinics(serviceId, fromDate, partnerCampaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Legacy version of get next available timeslot for a service across clinics with a specified practitioner
     * @param {string} serviceId 
     * @param {string} practitionerId 
     * @param {string} [fromDate] 
     * @param {string} [partnerCampaignId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientLegacyPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics(serviceId: string, practitionerId: string, fromDate?: string, partnerCampaignId?: string, options?: RawAxiosRequestConfig) {
        return LegacyApiFp(this.configuration).v1PatientLegacyPublicGetNextAvailableTimeslotForServiceWithPractitionerAcrossClinics(serviceId, practitionerId, fromDate, partnerCampaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Book physical appointment for guest user
     * @param {V1PatientPublicLegacyBookPhysicalAppointmentRequest} v1PatientPublicLegacyBookPhysicalAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicLegacyBookPhysicalAppointment(v1PatientPublicLegacyBookPhysicalAppointmentRequest: V1PatientPublicLegacyBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig) {
        return LegacyApiFp(this.configuration).v1PatientPublicLegacyBookPhysicalAppointment(v1PatientPublicLegacyBookPhysicalAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Legacy book physical appointment with a specific practitioner for guest user
     * @param {V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest} v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner(v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest: V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig) {
        return LegacyApiFp(this.configuration).v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner(v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if a partner campaign and service requires providing a country.
     * @param {string} partnerCampaignId 
     * @param {string} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientTravelInsuranceLegacyNeedsCountry(partnerCampaignId: string, serviceId: string, options?: RawAxiosRequestConfig) {
        return LegacyApiFp(this.configuration).v1PatientTravelInsuranceLegacyNeedsCountry(partnerCampaignId, serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if the selected country is valid for a partner campaign and service. Will return an error message in the specified locale (default to Norwegian Bokmål if not specified).
     * @param {V1PatientTravelInsuranceLegacyValidateCountryRequest} v1PatientTravelInsuranceLegacyValidateCountryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientTravelInsuranceLegacyValidateCountry(v1PatientTravelInsuranceLegacyValidateCountryRequest: V1PatientTravelInsuranceLegacyValidateCountryRequest, options?: RawAxiosRequestConfig) {
        return LegacyApiFp(this.configuration).v1PatientTravelInsuranceLegacyValidateCountry(v1PatientTravelInsuranceLegacyValidateCountryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PublicApi - axios parameter creator
 */
export const PublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientAuthChallenge: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/public/auth/challenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCapChallenge: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/patient/public/cap/challenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientCapRedeemRequest} v1PatientCapRedeemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCapRedeem: async (v1PatientCapRedeemRequest: V1PatientCapRedeemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientCapRedeemRequest' is not null or undefined
            assertParamExists('v1PatientCapRedeem', 'v1PatientCapRedeemRequest', v1PatientCapRedeemRequest)
            const localVarPath = `/v1/patient/public/cap/redeem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientCapRedeemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} practitionerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPractitioner: async (practitionerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'practitionerId' is not null or undefined
            assertParamExists('v1PatientGetPractitioner', 'practitionerId', practitionerId)
            const localVarPath = `/v1/patient/public/practitioners/{practitionerId}`
                .replace(`{${"practitionerId"}}`, encodeURIComponent(String(practitionerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPractitionersInClinicWithService: async (serviceId: string, clinicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientGetPractitionersInClinicWithService', 'serviceId', serviceId)
            // verify required parameter 'clinicId' is not null or undefined
            assertParamExists('v1PatientGetPractitionersInClinicWithService', 'clinicId', clinicId)
            const localVarPath = `/v1/patient/public/practitioners/in-clinic-with-service`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (clinicId !== undefined) {
                localVarQueryParameter['clinicId'] = clinicId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPractitionersWithService: async (serviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientGetPractitionersWithService', 'serviceId', serviceId)
            const localVarPath = `/v1/patient/public/practitioners/with-service`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientInitiatePhoneVerificationRequest} v1PatientInitiatePhoneVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientInitiatePhoneVerification: async (v1PatientInitiatePhoneVerificationRequest: V1PatientInitiatePhoneVerificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientInitiatePhoneVerificationRequest' is not null or undefined
            assertParamExists('v1PatientInitiatePhoneVerification', 'v1PatientInitiatePhoneVerificationRequest', v1PatientInitiatePhoneVerificationRequest)
            const localVarPath = `/v1/patient/public/phone-verification/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientInitiatePhoneVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Book physical appointment for guest user
         * @param {V1PatientPublicBookPhysicalAppointmentRequest} v1PatientPublicBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicBookPhysicalAppointment: async (v1PatientPublicBookPhysicalAppointmentRequest: V1PatientPublicBookPhysicalAppointmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientPublicBookPhysicalAppointmentRequest' is not null or undefined
            assertParamExists('v1PatientPublicBookPhysicalAppointment', 'v1PatientPublicBookPhysicalAppointmentRequest', v1PatientPublicBookPhysicalAppointmentRequest)
            const localVarPath = `/v1/patient/public/appointments/book-physical-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientPublicBookPhysicalAppointmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Book physical appointment with a specific practitioner for guest user
         * @param {V1PatientPublicBookPhysicalAppointmentWithPractitionerRequest} v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicBookPhysicalAppointmentWithPractitioner: async (v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest: V1PatientPublicBookPhysicalAppointmentWithPractitionerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest' is not null or undefined
            assertParamExists('v1PatientPublicBookPhysicalAppointmentWithPractitioner', 'v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest', v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest)
            const localVarPath = `/v1/patient/public/appointments/book-physical-appointment-with-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Redirect to feedback URL for an appointment
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicFeedbackRedirect: async (shortId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shortId' is not null or undefined
            assertParamExists('v1PatientPublicFeedbackRedirect', 'shortId', shortId)
            const localVarPath = `/v1/patient/public/appointments/feedback/{shortId}`
                .replace(`{${"shortId"}}`, encodeURIComponent(String(shortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get areas in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetAreas: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('v1PatientPublicGetAreas', 'organizationId', organizationId)
            const localVarPath = `/v1/patient/public/areas/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get availability for a service across clinics
         * @param {string} serviceId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetAvailabilityAcrossClinics: async (serviceId: string, fromDate?: string, toDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientPublicGetAvailabilityAcrossClinics', 'serviceId', serviceId)
            const localVarPath = `/v1/patient/public/availability/across-clinics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get availability for a service across clinics with a specific practitioner
         * @param {string} serviceId 
         * @param {string} practitionerId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetAvailabilityAcrossClinicsWithPractitioner: async (serviceId: string, practitionerId: string, fromDate?: string, toDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientPublicGetAvailabilityAcrossClinicsWithPractitioner', 'serviceId', serviceId)
            // verify required parameter 'practitionerId' is not null or undefined
            assertParamExists('v1PatientPublicGetAvailabilityAcrossClinicsWithPractitioner', 'practitionerId', practitionerId)
            const localVarPath = `/v1/patient/public/availability/across-clinics-with-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (practitionerId !== undefined) {
                localVarQueryParameter['practitionerId'] = practitionerId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} [practitionerId] 
         * @param {string} [fromDate] 
         * @param {string} [nrOfDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetAvailabilityForServiceInClinicByDate: async (serviceId: string, clinicId: string, practitionerId?: string, fromDate?: string, nrOfDays?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientPublicGetAvailabilityForServiceInClinicByDate', 'serviceId', serviceId)
            // verify required parameter 'clinicId' is not null or undefined
            assertParamExists('v1PatientPublicGetAvailabilityForServiceInClinicByDate', 'clinicId', clinicId)
            const localVarPath = `/v1/patient/public/availability/in-clinic-by-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (clinicId !== undefined) {
                localVarQueryParameter['clinicId'] = clinicId;
            }

            if (practitionerId !== undefined) {
                localVarQueryParameter['practitionerId'] = practitionerId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (nrOfDays !== undefined) {
                localVarQueryParameter['nrOfDays'] = nrOfDays;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} [practitionerId] 
         * @param {string} [fromDate] 
         * @param {string} [nrOfDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetAvailabilityForServiceInClinicByDateAndPractitioner: async (serviceId: string, clinicId: string, practitionerId?: string, fromDate?: string, nrOfDays?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientPublicGetAvailabilityForServiceInClinicByDateAndPractitioner', 'serviceId', serviceId)
            // verify required parameter 'clinicId' is not null or undefined
            assertParamExists('v1PatientPublicGetAvailabilityForServiceInClinicByDateAndPractitioner', 'clinicId', clinicId)
            const localVarPath = `/v1/patient/public/availability/in-clinic-by-date-and-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (clinicId !== undefined) {
                localVarQueryParameter['clinicId'] = clinicId;
            }

            if (practitionerId !== undefined) {
                localVarQueryParameter['practitionerId'] = practitionerId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (nrOfDays !== undefined) {
                localVarQueryParameter['nrOfDays'] = nrOfDays;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get availability for a service in a clinic
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetAvailabilityInClinic: async (serviceId: string, clinicId: string, fromDate?: string, toDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientPublicGetAvailabilityInClinic', 'serviceId', serviceId)
            // verify required parameter 'clinicId' is not null or undefined
            assertParamExists('v1PatientPublicGetAvailabilityInClinic', 'clinicId', clinicId)
            const localVarPath = `/v1/patient/public/availability/in-clinic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (clinicId !== undefined) {
                localVarQueryParameter['clinicId'] = clinicId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get availability for a service in a clinic with a specific practitioner
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} practitionerId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetAvailabilityInClinicWithPractitioner: async (serviceId: string, clinicId: string, practitionerId: string, fromDate?: string, toDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientPublicGetAvailabilityInClinicWithPractitioner', 'serviceId', serviceId)
            // verify required parameter 'clinicId' is not null or undefined
            assertParamExists('v1PatientPublicGetAvailabilityInClinicWithPractitioner', 'clinicId', clinicId)
            // verify required parameter 'practitionerId' is not null or undefined
            assertParamExists('v1PatientPublicGetAvailabilityInClinicWithPractitioner', 'practitionerId', practitionerId)
            const localVarPath = `/v1/patient/public/availability/in-clinic-with-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (clinicId !== undefined) {
                localVarQueryParameter['clinicId'] = clinicId;
            }

            if (practitionerId !== undefined) {
                localVarQueryParameter['practitionerId'] = practitionerId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetClinicByShortId: async (organizationId: string, shortId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('v1PatientPublicGetClinicByShortId', 'organizationId', organizationId)
            // verify required parameter 'shortId' is not null or undefined
            assertParamExists('v1PatientPublicGetClinicByShortId', 'shortId', shortId)
            const localVarPath = `/v1/patient/public/clinics/shortid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (shortId !== undefined) {
                localVarQueryParameter['shortId'] = shortId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get active clinics in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetClinics: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('v1PatientPublicGetClinics', 'organizationId', organizationId)
            const localVarPath = `/v1/patient/public/clinics/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get clinics with service by area
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetClinicsByArea: async (serviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientPublicGetClinicsByArea', 'serviceId', serviceId)
            const localVarPath = `/v1/patient/public/clinics/with-service-by-area`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get active clinics that have practitioners of the specified types
         * @param {string} organizationId 
         * @param {Array<string>} practitionerTypeShortIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetClinicsForPractitionerTypes: async (organizationId: string, practitionerTypeShortIds: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('v1PatientPublicGetClinicsForPractitionerTypes', 'organizationId', organizationId)
            // verify required parameter 'practitionerTypeShortIds' is not null or undefined
            assertParamExists('v1PatientPublicGetClinicsForPractitionerTypes', 'practitionerTypeShortIds', practitionerTypeShortIds)
            const localVarPath = `/v1/patient/public/clinics/for-practitioner-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (practitionerTypeShortIds) {
                localVarQueryParameter['practitionerTypeShortIds'] = practitionerTypeShortIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get active clinics that provide the requested service
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetClinicsWithService: async (serviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientPublicGetClinicsWithService', 'serviceId', serviceId)
            const localVarPath = `/v1/patient/public/clinics/with-service`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get filter data (locations, clinics, services, skills) for practitioner listing page
         * @param {string} organizationId 
         * @param {V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter} practitionerTypeShortIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetPractitionerListingFilters: async (organizationId: string, practitionerTypeShortIds: V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('v1PatientPublicGetPractitionerListingFilters', 'organizationId', organizationId)
            // verify required parameter 'practitionerTypeShortIds' is not null or undefined
            assertParamExists('v1PatientPublicGetPractitionerListingFilters', 'practitionerTypeShortIds', practitionerTypeShortIds)
            const localVarPath = `/v1/patient/public/practitioners/for-listing/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (practitionerTypeShortIds !== undefined) {
                for (const [key, value] of Object.entries(practitionerTypeShortIds)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get practitioner types in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetPractitionerTypes: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('v1PatientPublicGetPractitionerTypes', 'organizationId', organizationId)
            const localVarPath = `/v1/patient/public/practitioner-types/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get practitioners for public listing page with their service IDs, clinic IDs, and skill proficiencies
         * @param {string} organizationId 
         * @param {V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter} practitionerTypeShortIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetPractitionersForListing: async (organizationId: string, practitionerTypeShortIds: V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('v1PatientPublicGetPractitionersForListing', 'organizationId', organizationId)
            // verify required parameter 'practitionerTypeShortIds' is not null or undefined
            assertParamExists('v1PatientPublicGetPractitionersForListing', 'practitionerTypeShortIds', practitionerTypeShortIds)
            const localVarPath = `/v1/patient/public/practitioners/for-listing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (practitionerTypeShortIds !== undefined) {
                for (const [key, value] of Object.entries(practitionerTypeShortIds)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get service by id
         * @param {string} organizationId 
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetService: async (organizationId: string, serviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('v1PatientPublicGetService', 'organizationId', organizationId)
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientPublicGetService', 'serviceId', serviceId)
            const localVarPath = `/v1/patient/public/services/{serviceId}`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get service categories in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetServiceCategories: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('v1PatientPublicGetServiceCategories', 'organizationId', organizationId)
            const localVarPath = `/v1/patient/public/services/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get active triage for service, if one exists
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetServiceTriage: async (serviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('v1PatientPublicGetServiceTriage', 'serviceId', serviceId)
            const localVarPath = `/v1/patient/public/services/{serviceId}/triage`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get services open for public booking in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetServices: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('v1PatientPublicGetServices', 'organizationId', organizationId)
            const localVarPath = `/v1/patient/public/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get active services for the specified practitioner types
         * @param {string} organizationId 
         * @param {Array<string>} practitionerTypeShortIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetServicesForPractitionerTypes: async (organizationId: string, practitionerTypeShortIds: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('v1PatientPublicGetServicesForPractitionerTypes', 'organizationId', organizationId)
            // verify required parameter 'practitionerTypeShortIds' is not null or undefined
            assertParamExists('v1PatientPublicGetServicesForPractitionerTypes', 'practitionerTypeShortIds', practitionerTypeShortIds)
            const localVarPath = `/v1/patient/public/services/for-practitioner-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (practitionerTypeShortIds) {
                localVarQueryParameter['practitionerTypeShortIds'] = practitionerTypeShortIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get skill categories with skills in the organization
         * @param {string} organizationId 
         * @param {Array<string>} [practitionerTypeShortIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetSkillCategories: async (organizationId: string, practitionerTypeShortIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('v1PatientPublicGetSkillCategories', 'organizationId', organizationId)
            const localVarPath = `/v1/patient/public/skills/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (practitionerTypeShortIds) {
                localVarQueryParameter['practitionerTypeShortIds'] = practitionerTypeShortIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Book physical appointment for guest user
         * @param {V1PatientPublicLegacyBookPhysicalAppointmentRequest} v1PatientPublicLegacyBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicLegacyBookPhysicalAppointment: async (v1PatientPublicLegacyBookPhysicalAppointmentRequest: V1PatientPublicLegacyBookPhysicalAppointmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientPublicLegacyBookPhysicalAppointmentRequest' is not null or undefined
            assertParamExists('v1PatientPublicLegacyBookPhysicalAppointment', 'v1PatientPublicLegacyBookPhysicalAppointmentRequest', v1PatientPublicLegacyBookPhysicalAppointmentRequest)
            const localVarPath = `/v1/patient/public/appointments/legacy/book-physical-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientPublicLegacyBookPhysicalAppointmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Legacy book physical appointment with a specific practitioner for guest user
         * @param {V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest} v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner: async (v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest: V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest' is not null or undefined
            assertParamExists('v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner', 'v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest', v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest)
            const localVarPath = `/v1/patient/public/appointments/legacy/book-physical-appointment-with-practitioner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Redirect to appointment status page URL
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicStatusPageRedirect: async (shortId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shortId' is not null or undefined
            assertParamExists('v1PatientPublicStatusPageRedirect', 'shortId', shortId)
            const localVarPath = `/v1/patient/public/appointments/status-page/{shortId}`
                .replace(`{${"shortId"}}`, encodeURIComponent(String(shortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Redirect to practitioner video URL for an appointment
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicVideoUrlRedirect: async (shortId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shortId' is not null or undefined
            assertParamExists('v1PatientPublicVideoUrlRedirect', 'shortId', shortId)
            const localVarPath = `/v1/patient/public/appointments/video-url/{shortId}`
                .replace(`{${"shortId"}}`, encodeURIComponent(String(shortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1PatientVerifyPhoneNumberRequest} v1PatientVerifyPhoneNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientVerifyPhoneNumber: async (v1PatientVerifyPhoneNumberRequest: V1PatientVerifyPhoneNumberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'v1PatientVerifyPhoneNumberRequest' is not null or undefined
            assertParamExists('v1PatientVerifyPhoneNumber', 'v1PatientVerifyPhoneNumberRequest', v1PatientVerifyPhoneNumberRequest)
            const localVarPath = `/v1/patient/public/phone-verification/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PatientVerifyPhoneNumberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PublicPatientCancelAppointment: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('v1PublicPatientCancelAppointment', 'appointmentId', appointmentId)
            const localVarPath = `/v1/patient/public/appointments/{appointmentId}/cancel`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get appointment used for public patient access
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PublicPatientGetAppointment: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('v1PublicPatientGetAppointment', 'appointmentId', appointmentId)
            const localVarPath = `/v1/patient/public/appointments/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reschedule appointment
         * @param {string} appointmentId 
         * @param {V1PublicPatientRescheduleAppointmentRequest} v1PublicPatientRescheduleAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PublicPatientRescheduleAppointment: async (appointmentId: string, v1PublicPatientRescheduleAppointmentRequest: V1PublicPatientRescheduleAppointmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('v1PublicPatientRescheduleAppointment', 'appointmentId', appointmentId)
            // verify required parameter 'v1PublicPatientRescheduleAppointmentRequest' is not null or undefined
            assertParamExists('v1PublicPatientRescheduleAppointment', 'v1PublicPatientRescheduleAppointmentRequest', v1PublicPatientRescheduleAppointmentRequest)
            const localVarPath = `/v1/patient/public/appointments/{appointmentId}/reschedule`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1PublicPatientRescheduleAppointmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicApi - functional programming interface
 */
export const PublicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientAuthChallenge(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientAuthChallenge200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientAuthChallenge(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientAuthChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientCapChallenge(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientCapChallenge200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientCapChallenge(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientCapChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientCapRedeemRequest} v1PatientCapRedeemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientCapRedeem(v1PatientCapRedeemRequest: V1PatientCapRedeemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientCapRedeem200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientCapRedeem(v1PatientCapRedeemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientCapRedeem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} practitionerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetPractitioner(practitionerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientGetPractitioner200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetPractitioner(practitionerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientGetPractitioner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetPractitionersInClinicWithService(serviceId: string, clinicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientGetPractitionersWithService200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetPractitionersInClinicWithService(serviceId, clinicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientGetPractitionersInClinicWithService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientGetPractitionersWithService(serviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientGetPractitionersWithService200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientGetPractitionersWithService(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientGetPractitionersWithService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientInitiatePhoneVerificationRequest} v1PatientInitiatePhoneVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientInitiatePhoneVerification(v1PatientInitiatePhoneVerificationRequest: V1PatientInitiatePhoneVerificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientInitiatePhoneVerification200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientInitiatePhoneVerification(v1PatientInitiatePhoneVerificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientInitiatePhoneVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Book physical appointment for guest user
         * @param {V1PatientPublicBookPhysicalAppointmentRequest} v1PatientPublicBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicBookPhysicalAppointment(v1PatientPublicBookPhysicalAppointmentRequest: V1PatientPublicBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicBookPhysicalAppointment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicBookPhysicalAppointment(v1PatientPublicBookPhysicalAppointmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicBookPhysicalAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Book physical appointment with a specific practitioner for guest user
         * @param {V1PatientPublicBookPhysicalAppointmentWithPractitionerRequest} v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicBookPhysicalAppointmentWithPractitioner(v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest: V1PatientPublicBookPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicBookPhysicalAppointment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicBookPhysicalAppointmentWithPractitioner(v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicBookPhysicalAppointmentWithPractitioner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Redirect to feedback URL for an appointment
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicFeedbackRedirect(shortId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicFeedbackRedirect(shortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicFeedbackRedirect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get areas in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetAreas(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetAreas200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetAreas(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetAreas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get availability for a service across clinics
         * @param {string} serviceId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetAvailabilityAcrossClinics(serviceId: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetAvailabilityInClinic200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetAvailabilityAcrossClinics(serviceId, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetAvailabilityAcrossClinics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get availability for a service across clinics with a specific practitioner
         * @param {string} serviceId 
         * @param {string} practitionerId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetAvailabilityAcrossClinicsWithPractitioner(serviceId: string, practitionerId: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetAvailabilityInClinic200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetAvailabilityAcrossClinicsWithPractitioner(serviceId, practitionerId, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetAvailabilityAcrossClinicsWithPractitioner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} [practitionerId] 
         * @param {string} [fromDate] 
         * @param {string} [nrOfDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetAvailabilityForServiceInClinicByDate(serviceId: string, clinicId: string, practitionerId?: string, fromDate?: string, nrOfDays?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<V1PatientPublicGetAvailabilityInClinicWithPractitioner200ResponseInner>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetAvailabilityForServiceInClinicByDate(serviceId, clinicId, practitionerId, fromDate, nrOfDays, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetAvailabilityForServiceInClinicByDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} [practitionerId] 
         * @param {string} [fromDate] 
         * @param {string} [nrOfDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetAvailabilityForServiceInClinicByDateAndPractitioner(serviceId: string, clinicId: string, practitionerId?: string, fromDate?: string, nrOfDays?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<V1PatientPublicGetAvailabilityForServiceInClinicByDateAndPractitioner200ResponseValueInner>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetAvailabilityForServiceInClinicByDateAndPractitioner(serviceId, clinicId, practitionerId, fromDate, nrOfDays, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetAvailabilityForServiceInClinicByDateAndPractitioner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get availability for a service in a clinic
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetAvailabilityInClinic(serviceId: string, clinicId: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetAvailabilityInClinic200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetAvailabilityInClinic(serviceId, clinicId, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetAvailabilityInClinic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get availability for a service in a clinic with a specific practitioner
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} practitionerId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetAvailabilityInClinicWithPractitioner(serviceId: string, clinicId: string, practitionerId: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetAvailabilityInClinicWithPractitioner200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetAvailabilityInClinicWithPractitioner(serviceId, clinicId, practitionerId, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetAvailabilityInClinicWithPractitioner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetClinicByShortId(organizationId: string, shortId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicGetClinicByShortId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetClinicByShortId(organizationId, shortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetClinicByShortId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get active clinics in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetClinics(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetClinics200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetClinics(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetClinics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get clinics with service by area
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetClinicsByArea(serviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetClinicsByArea200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetClinicsByArea(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetClinicsByArea']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get active clinics that have practitioners of the specified types
         * @param {string} organizationId 
         * @param {Array<string>} practitionerTypeShortIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetClinicsForPractitionerTypes(organizationId: string, practitionerTypeShortIds: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetClinics200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetClinicsForPractitionerTypes(organizationId, practitionerTypeShortIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetClinicsForPractitionerTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get active clinics that provide the requested service
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetClinicsWithService(serviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetClinicsWithService200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetClinicsWithService(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetClinicsWithService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get filter data (locations, clinics, services, skills) for practitioner listing page
         * @param {string} organizationId 
         * @param {V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter} practitionerTypeShortIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetPractitionerListingFilters(organizationId: string, practitionerTypeShortIds: V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicGetPractitionerListingFilters200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetPractitionerListingFilters(organizationId, practitionerTypeShortIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetPractitionerListingFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get practitioner types in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetPractitionerTypes(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetPractitionerTypes200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetPractitionerTypes(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetPractitionerTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get practitioners for public listing page with their service IDs, clinic IDs, and skill proficiencies
         * @param {string} organizationId 
         * @param {V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter} practitionerTypeShortIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetPractitionersForListing(organizationId: string, practitionerTypeShortIds: V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetPractitionersForListing200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetPractitionersForListing(organizationId, practitionerTypeShortIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetPractitionersForListing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get service by id
         * @param {string} organizationId 
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetService(organizationId: string, serviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicGetServiceByShortId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetService(organizationId, serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get service categories in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetServiceCategories(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetServiceCategories200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetServiceCategories(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetServiceCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get active triage for service, if one exists
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetServiceTriage(serviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicGetServiceTriage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetServiceTriage(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetServiceTriage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get services open for public booking in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetServices(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetServices200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetServices(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get active services for the specified practitioner types
         * @param {string} organizationId 
         * @param {Array<string>} practitionerTypeShortIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetServicesForPractitionerTypes(organizationId: string, practitionerTypeShortIds: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetServices200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetServicesForPractitionerTypes(organizationId, practitionerTypeShortIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetServicesForPractitionerTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get skill categories with skills in the organization
         * @param {string} organizationId 
         * @param {Array<string>} [practitionerTypeShortIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicGetSkillCategories(organizationId: string, practitionerTypeShortIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<V1PatientPublicGetSkillCategories200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicGetSkillCategories(organizationId, practitionerTypeShortIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicGetSkillCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Book physical appointment for guest user
         * @param {V1PatientPublicLegacyBookPhysicalAppointmentRequest} v1PatientPublicLegacyBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicLegacyBookPhysicalAppointment(v1PatientPublicLegacyBookPhysicalAppointmentRequest: V1PatientPublicLegacyBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicLegacyBookPhysicalAppointment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicLegacyBookPhysicalAppointment(v1PatientPublicLegacyBookPhysicalAppointmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicLegacyBookPhysicalAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Legacy book physical appointment with a specific practitioner for guest user
         * @param {V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest} v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner(v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest: V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientPublicLegacyBookPhysicalAppointment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner(v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Redirect to appointment status page URL
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicStatusPageRedirect(shortId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicStatusPageRedirect(shortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicStatusPageRedirect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Redirect to practitioner video URL for an appointment
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientPublicVideoUrlRedirect(shortId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientPublicVideoUrlRedirect(shortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientPublicVideoUrlRedirect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {V1PatientVerifyPhoneNumberRequest} v1PatientVerifyPhoneNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PatientVerifyPhoneNumber(v1PatientVerifyPhoneNumberRequest: V1PatientVerifyPhoneNumberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PatientVerifyPhoneNumber200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PatientVerifyPhoneNumber(v1PatientVerifyPhoneNumberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PatientVerifyPhoneNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PublicPatientCancelAppointment(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PublicPatientCancelAppointment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PublicPatientCancelAppointment(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PublicPatientCancelAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get appointment used for public patient access
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PublicPatientGetAppointment(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PublicPatientGetAppointment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PublicPatientGetAppointment(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PublicPatientGetAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reschedule appointment
         * @param {string} appointmentId 
         * @param {V1PublicPatientRescheduleAppointmentRequest} v1PublicPatientRescheduleAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PublicPatientRescheduleAppointment(appointmentId: string, v1PublicPatientRescheduleAppointmentRequest: V1PublicPatientRescheduleAppointmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PublicPatientRescheduleAppointment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PublicPatientRescheduleAppointment(appointmentId, v1PublicPatientRescheduleAppointmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.v1PublicPatientRescheduleAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicApi - factory interface
 */
export const PublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientAuthChallenge(options?: RawAxiosRequestConfig): AxiosPromise<V1PatientAuthChallenge200Response> {
            return localVarFp.v1PatientAuthChallenge(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCapChallenge(options?: RawAxiosRequestConfig): AxiosPromise<V1PatientCapChallenge200Response> {
            return localVarFp.v1PatientCapChallenge(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientCapRedeemRequest} v1PatientCapRedeemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientCapRedeem(v1PatientCapRedeemRequest: V1PatientCapRedeemRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientCapRedeem200Response> {
            return localVarFp.v1PatientCapRedeem(v1PatientCapRedeemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} practitionerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPractitioner(practitionerId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientGetPractitioner200Response> {
            return localVarFp.v1PatientGetPractitioner(practitionerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPractitionersInClinicWithService(serviceId: string, clinicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientGetPractitionersWithService200ResponseInner>> {
            return localVarFp.v1PatientGetPractitionersInClinicWithService(serviceId, clinicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientGetPractitionersWithService(serviceId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientGetPractitionersWithService200ResponseInner>> {
            return localVarFp.v1PatientGetPractitionersWithService(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientInitiatePhoneVerificationRequest} v1PatientInitiatePhoneVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientInitiatePhoneVerification(v1PatientInitiatePhoneVerificationRequest: V1PatientInitiatePhoneVerificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientInitiatePhoneVerification200Response> {
            return localVarFp.v1PatientInitiatePhoneVerification(v1PatientInitiatePhoneVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Book physical appointment for guest user
         * @param {V1PatientPublicBookPhysicalAppointmentRequest} v1PatientPublicBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicBookPhysicalAppointment(v1PatientPublicBookPhysicalAppointmentRequest: V1PatientPublicBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicBookPhysicalAppointment200Response> {
            return localVarFp.v1PatientPublicBookPhysicalAppointment(v1PatientPublicBookPhysicalAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Book physical appointment with a specific practitioner for guest user
         * @param {V1PatientPublicBookPhysicalAppointmentWithPractitionerRequest} v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicBookPhysicalAppointmentWithPractitioner(v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest: V1PatientPublicBookPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicBookPhysicalAppointment200Response> {
            return localVarFp.v1PatientPublicBookPhysicalAppointmentWithPractitioner(v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Redirect to feedback URL for an appointment
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicFeedbackRedirect(shortId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.v1PatientPublicFeedbackRedirect(shortId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get areas in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetAreas(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetAreas200ResponseInner>> {
            return localVarFp.v1PatientPublicGetAreas(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get availability for a service across clinics
         * @param {string} serviceId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetAvailabilityAcrossClinics(serviceId: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetAvailabilityInClinic200ResponseInner>> {
            return localVarFp.v1PatientPublicGetAvailabilityAcrossClinics(serviceId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get availability for a service across clinics with a specific practitioner
         * @param {string} serviceId 
         * @param {string} practitionerId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetAvailabilityAcrossClinicsWithPractitioner(serviceId: string, practitionerId: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetAvailabilityInClinic200ResponseInner>> {
            return localVarFp.v1PatientPublicGetAvailabilityAcrossClinicsWithPractitioner(serviceId, practitionerId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} [practitionerId] 
         * @param {string} [fromDate] 
         * @param {string} [nrOfDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetAvailabilityForServiceInClinicByDate(serviceId: string, clinicId: string, practitionerId?: string, fromDate?: string, nrOfDays?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<V1PatientPublicGetAvailabilityInClinicWithPractitioner200ResponseInner>; }> {
            return localVarFp.v1PatientPublicGetAvailabilityForServiceInClinicByDate(serviceId, clinicId, practitionerId, fromDate, nrOfDays, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} [practitionerId] 
         * @param {string} [fromDate] 
         * @param {string} [nrOfDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetAvailabilityForServiceInClinicByDateAndPractitioner(serviceId: string, clinicId: string, practitionerId?: string, fromDate?: string, nrOfDays?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<V1PatientPublicGetAvailabilityForServiceInClinicByDateAndPractitioner200ResponseValueInner>; }> {
            return localVarFp.v1PatientPublicGetAvailabilityForServiceInClinicByDateAndPractitioner(serviceId, clinicId, practitionerId, fromDate, nrOfDays, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get availability for a service in a clinic
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetAvailabilityInClinic(serviceId: string, clinicId: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetAvailabilityInClinic200ResponseInner>> {
            return localVarFp.v1PatientPublicGetAvailabilityInClinic(serviceId, clinicId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get availability for a service in a clinic with a specific practitioner
         * @param {string} serviceId 
         * @param {string} clinicId 
         * @param {string} practitionerId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetAvailabilityInClinicWithPractitioner(serviceId: string, clinicId: string, practitionerId: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetAvailabilityInClinicWithPractitioner200ResponseInner>> {
            return localVarFp.v1PatientPublicGetAvailabilityInClinicWithPractitioner(serviceId, clinicId, practitionerId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetClinicByShortId(organizationId: string, shortId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicGetClinicByShortId200Response> {
            return localVarFp.v1PatientPublicGetClinicByShortId(organizationId, shortId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get active clinics in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetClinics(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetClinics200ResponseInner>> {
            return localVarFp.v1PatientPublicGetClinics(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get clinics with service by area
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetClinicsByArea(serviceId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetClinicsByArea200ResponseInner>> {
            return localVarFp.v1PatientPublicGetClinicsByArea(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get active clinics that have practitioners of the specified types
         * @param {string} organizationId 
         * @param {Array<string>} practitionerTypeShortIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetClinicsForPractitionerTypes(organizationId: string, practitionerTypeShortIds: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetClinics200ResponseInner>> {
            return localVarFp.v1PatientPublicGetClinicsForPractitionerTypes(organizationId, practitionerTypeShortIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get active clinics that provide the requested service
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetClinicsWithService(serviceId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetClinicsWithService200ResponseInner>> {
            return localVarFp.v1PatientPublicGetClinicsWithService(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get filter data (locations, clinics, services, skills) for practitioner listing page
         * @param {string} organizationId 
         * @param {V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter} practitionerTypeShortIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetPractitionerListingFilters(organizationId: string, practitionerTypeShortIds: V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicGetPractitionerListingFilters200Response> {
            return localVarFp.v1PatientPublicGetPractitionerListingFilters(organizationId, practitionerTypeShortIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get practitioner types in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetPractitionerTypes(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetPractitionerTypes200ResponseInner>> {
            return localVarFp.v1PatientPublicGetPractitionerTypes(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get practitioners for public listing page with their service IDs, clinic IDs, and skill proficiencies
         * @param {string} organizationId 
         * @param {V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter} practitionerTypeShortIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetPractitionersForListing(organizationId: string, practitionerTypeShortIds: V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetPractitionersForListing200ResponseInner>> {
            return localVarFp.v1PatientPublicGetPractitionersForListing(organizationId, practitionerTypeShortIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get service by id
         * @param {string} organizationId 
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetService(organizationId: string, serviceId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicGetServiceByShortId200Response> {
            return localVarFp.v1PatientPublicGetService(organizationId, serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get service categories in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetServiceCategories(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetServiceCategories200ResponseInner>> {
            return localVarFp.v1PatientPublicGetServiceCategories(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get active triage for service, if one exists
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetServiceTriage(serviceId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicGetServiceTriage200Response> {
            return localVarFp.v1PatientPublicGetServiceTriage(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get services open for public booking in the organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetServices(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetServices200ResponseInner>> {
            return localVarFp.v1PatientPublicGetServices(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get active services for the specified practitioner types
         * @param {string} organizationId 
         * @param {Array<string>} practitionerTypeShortIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetServicesForPractitionerTypes(organizationId: string, practitionerTypeShortIds: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetServices200ResponseInner>> {
            return localVarFp.v1PatientPublicGetServicesForPractitionerTypes(organizationId, practitionerTypeShortIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get skill categories with skills in the organization
         * @param {string} organizationId 
         * @param {Array<string>} [practitionerTypeShortIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicGetSkillCategories(organizationId: string, practitionerTypeShortIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<V1PatientPublicGetSkillCategories200ResponseInner>> {
            return localVarFp.v1PatientPublicGetSkillCategories(organizationId, practitionerTypeShortIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Book physical appointment for guest user
         * @param {V1PatientPublicLegacyBookPhysicalAppointmentRequest} v1PatientPublicLegacyBookPhysicalAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicLegacyBookPhysicalAppointment(v1PatientPublicLegacyBookPhysicalAppointmentRequest: V1PatientPublicLegacyBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicLegacyBookPhysicalAppointment200Response> {
            return localVarFp.v1PatientPublicLegacyBookPhysicalAppointment(v1PatientPublicLegacyBookPhysicalAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Legacy book physical appointment with a specific practitioner for guest user
         * @param {V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest} v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner(v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest: V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientPublicLegacyBookPhysicalAppointment200Response> {
            return localVarFp.v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner(v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Redirect to appointment status page URL
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicStatusPageRedirect(shortId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.v1PatientPublicStatusPageRedirect(shortId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Redirect to practitioner video URL for an appointment
         * @param {string} shortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientPublicVideoUrlRedirect(shortId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.v1PatientPublicVideoUrlRedirect(shortId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1PatientVerifyPhoneNumberRequest} v1PatientVerifyPhoneNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PatientVerifyPhoneNumber(v1PatientVerifyPhoneNumberRequest: V1PatientVerifyPhoneNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PatientVerifyPhoneNumber200Response> {
            return localVarFp.v1PatientVerifyPhoneNumber(v1PatientVerifyPhoneNumberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PublicPatientCancelAppointment(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PublicPatientCancelAppointment200Response> {
            return localVarFp.v1PublicPatientCancelAppointment(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get appointment used for public patient access
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PublicPatientGetAppointment(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<V1PublicPatientGetAppointment200Response> {
            return localVarFp.v1PublicPatientGetAppointment(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reschedule appointment
         * @param {string} appointmentId 
         * @param {V1PublicPatientRescheduleAppointmentRequest} v1PublicPatientRescheduleAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PublicPatientRescheduleAppointment(appointmentId: string, v1PublicPatientRescheduleAppointmentRequest: V1PublicPatientRescheduleAppointmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1PublicPatientRescheduleAppointment200Response> {
            return localVarFp.v1PublicPatientRescheduleAppointment(appointmentId, v1PublicPatientRescheduleAppointmentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicApi - object-oriented interface
 */
export class PublicApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientAuthChallenge(options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientAuthChallenge(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientCapChallenge(options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientCapChallenge(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientCapRedeemRequest} v1PatientCapRedeemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientCapRedeem(v1PatientCapRedeemRequest: V1PatientCapRedeemRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientCapRedeem(v1PatientCapRedeemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} practitionerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetPractitioner(practitionerId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientGetPractitioner(practitionerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serviceId 
     * @param {string} clinicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetPractitionersInClinicWithService(serviceId: string, clinicId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientGetPractitionersInClinicWithService(serviceId, clinicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientGetPractitionersWithService(serviceId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientGetPractitionersWithService(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientInitiatePhoneVerificationRequest} v1PatientInitiatePhoneVerificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientInitiatePhoneVerification(v1PatientInitiatePhoneVerificationRequest: V1PatientInitiatePhoneVerificationRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientInitiatePhoneVerification(v1PatientInitiatePhoneVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Book physical appointment for guest user
     * @param {V1PatientPublicBookPhysicalAppointmentRequest} v1PatientPublicBookPhysicalAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicBookPhysicalAppointment(v1PatientPublicBookPhysicalAppointmentRequest: V1PatientPublicBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicBookPhysicalAppointment(v1PatientPublicBookPhysicalAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Book physical appointment with a specific practitioner for guest user
     * @param {V1PatientPublicBookPhysicalAppointmentWithPractitionerRequest} v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicBookPhysicalAppointmentWithPractitioner(v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest: V1PatientPublicBookPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicBookPhysicalAppointmentWithPractitioner(v1PatientPublicBookPhysicalAppointmentWithPractitionerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Redirect to feedback URL for an appointment
     * @param {string} shortId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicFeedbackRedirect(shortId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicFeedbackRedirect(shortId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get areas in the organization
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetAreas(organizationId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetAreas(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get availability for a service across clinics
     * @param {string} serviceId 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetAvailabilityAcrossClinics(serviceId: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetAvailabilityAcrossClinics(serviceId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get availability for a service across clinics with a specific practitioner
     * @param {string} serviceId 
     * @param {string} practitionerId 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetAvailabilityAcrossClinicsWithPractitioner(serviceId: string, practitionerId: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetAvailabilityAcrossClinicsWithPractitioner(serviceId, practitionerId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serviceId 
     * @param {string} clinicId 
     * @param {string} [practitionerId] 
     * @param {string} [fromDate] 
     * @param {string} [nrOfDays] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetAvailabilityForServiceInClinicByDate(serviceId: string, clinicId: string, practitionerId?: string, fromDate?: string, nrOfDays?: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetAvailabilityForServiceInClinicByDate(serviceId, clinicId, practitionerId, fromDate, nrOfDays, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serviceId 
     * @param {string} clinicId 
     * @param {string} [practitionerId] 
     * @param {string} [fromDate] 
     * @param {string} [nrOfDays] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetAvailabilityForServiceInClinicByDateAndPractitioner(serviceId: string, clinicId: string, practitionerId?: string, fromDate?: string, nrOfDays?: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetAvailabilityForServiceInClinicByDateAndPractitioner(serviceId, clinicId, practitionerId, fromDate, nrOfDays, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get availability for a service in a clinic
     * @param {string} serviceId 
     * @param {string} clinicId 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetAvailabilityInClinic(serviceId: string, clinicId: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetAvailabilityInClinic(serviceId, clinicId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get availability for a service in a clinic with a specific practitioner
     * @param {string} serviceId 
     * @param {string} clinicId 
     * @param {string} practitionerId 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetAvailabilityInClinicWithPractitioner(serviceId: string, clinicId: string, practitionerId: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetAvailabilityInClinicWithPractitioner(serviceId, clinicId, practitionerId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {string} shortId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetClinicByShortId(organizationId: string, shortId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetClinicByShortId(organizationId, shortId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get active clinics in the organization
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetClinics(organizationId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetClinics(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get clinics with service by area
     * @param {string} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetClinicsByArea(serviceId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetClinicsByArea(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get active clinics that have practitioners of the specified types
     * @param {string} organizationId 
     * @param {Array<string>} practitionerTypeShortIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetClinicsForPractitionerTypes(organizationId: string, practitionerTypeShortIds: Array<string>, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetClinicsForPractitionerTypes(organizationId, practitionerTypeShortIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get active clinics that provide the requested service
     * @param {string} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetClinicsWithService(serviceId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetClinicsWithService(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get filter data (locations, clinics, services, skills) for practitioner listing page
     * @param {string} organizationId 
     * @param {V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter} practitionerTypeShortIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetPractitionerListingFilters(organizationId: string, practitionerTypeShortIds: V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetPractitionerListingFilters(organizationId, practitionerTypeShortIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get practitioner types in the organization
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetPractitionerTypes(organizationId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetPractitionerTypes(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get practitioners for public listing page with their service IDs, clinic IDs, and skill proficiencies
     * @param {string} organizationId 
     * @param {V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter} practitionerTypeShortIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetPractitionersForListing(organizationId: string, practitionerTypeShortIds: V1PatientPublicGetPractitionersForListingPractitionerTypeShortIdsParameter, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetPractitionersForListing(organizationId, practitionerTypeShortIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get service by id
     * @param {string} organizationId 
     * @param {string} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetService(organizationId: string, serviceId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetService(organizationId, serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get service categories in the organization
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetServiceCategories(organizationId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetServiceCategories(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get active triage for service, if one exists
     * @param {string} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetServiceTriage(serviceId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetServiceTriage(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get services open for public booking in the organization
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetServices(organizationId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetServices(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get active services for the specified practitioner types
     * @param {string} organizationId 
     * @param {Array<string>} practitionerTypeShortIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetServicesForPractitionerTypes(organizationId: string, practitionerTypeShortIds: Array<string>, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetServicesForPractitionerTypes(organizationId, practitionerTypeShortIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get skill categories with skills in the organization
     * @param {string} organizationId 
     * @param {Array<string>} [practitionerTypeShortIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicGetSkillCategories(organizationId: string, practitionerTypeShortIds?: Array<string>, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicGetSkillCategories(organizationId, practitionerTypeShortIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Book physical appointment for guest user
     * @param {V1PatientPublicLegacyBookPhysicalAppointmentRequest} v1PatientPublicLegacyBookPhysicalAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicLegacyBookPhysicalAppointment(v1PatientPublicLegacyBookPhysicalAppointmentRequest: V1PatientPublicLegacyBookPhysicalAppointmentRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicLegacyBookPhysicalAppointment(v1PatientPublicLegacyBookPhysicalAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Legacy book physical appointment with a specific practitioner for guest user
     * @param {V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest} v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner(v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest: V1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicLegacyBookPhysicalAppointmentWithPractitioner(v1PatientPublicLegacyBookPhysicalAppointmentWithPractitionerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Redirect to appointment status page URL
     * @param {string} shortId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicStatusPageRedirect(shortId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicStatusPageRedirect(shortId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Redirect to practitioner video URL for an appointment
     * @param {string} shortId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientPublicVideoUrlRedirect(shortId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientPublicVideoUrlRedirect(shortId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1PatientVerifyPhoneNumberRequest} v1PatientVerifyPhoneNumberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PatientVerifyPhoneNumber(v1PatientVerifyPhoneNumberRequest: V1PatientVerifyPhoneNumberRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PatientVerifyPhoneNumber(v1PatientVerifyPhoneNumberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel appointment
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PublicPatientCancelAppointment(appointmentId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PublicPatientCancelAppointment(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get appointment used for public patient access
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PublicPatientGetAppointment(appointmentId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PublicPatientGetAppointment(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reschedule appointment
     * @param {string} appointmentId 
     * @param {V1PublicPatientRescheduleAppointmentRequest} v1PublicPatientRescheduleAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v1PublicPatientRescheduleAppointment(appointmentId: string, v1PublicPatientRescheduleAppointmentRequest: V1PublicPatientRescheduleAppointmentRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).v1PublicPatientRescheduleAppointment(appointmentId, v1PublicPatientRescheduleAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



